    (function () {
      const configEl = document.querySelector('[data-personalisation-config]');
      if (!configEl) return;

      let config = {};
      try {
        config = JSON.parse(configEl.textContent || '{}');
      } catch (err) {
        return;
      }

      const wrapper = configEl.closest('[data-personalisation-block]');
      if (!wrapper) return;
      if (wrapper.dataset.personalisationInitialized === 'true') return;
      wrapper.dataset.personalisationInitialized = 'true';
      wrapper.dataset.portraitShape = 'portrait';
      wrapper.dataset.previewThemeId = String(config.previewThemeId || '');
      const getPortraitShape = () => config.portraitShapesEnabled ? (wrapper.dataset.portraitShape || 'portrait') : 'portrait';
      const portraitShapePayload = () => ({ portraitShape: getPortraitShape(), previewThemeId: String(config.previewThemeId || '') });

      // A style changes the artwork reference, never the page's purchasable product.
      const originalPortraitStyleId = String(config.productId || '');
      let portraitStyleChoices = [];
      try {
        const choices = JSON.parse(wrapper.querySelector('[data-pop-portrait-style-config]')?.textContent || '[]');
        if (Array.isArray(choices)) portraitStyleChoices = choices.map((choice) => {
          const imageSource = String(choice?.imageUrl || '').trim();
          if (!imageSource) return null;
          const image = new URL(imageSource, window.location.origin);
          const id = String(choice?.id || '');
          if (!/^\d+$/.test(id) || image.protocol !== 'https:') return null;
          const value = { id, label: String(choice.label || ''), imageUrl: image.href,
            prompt: String(choice.prompt || ''), imageModel: String(choice.imageModel || config.imageModel || 'gemini') };
          return { ...value, key: JSON.stringify([value.id, value.imageUrl, value.prompt, value.imageModel]) };
        }).filter(Boolean);
      } catch {}
      let selectedPortraitStyle = portraitStyleChoices.find((choice) => choice.id === originalPortraitStyleId) || null;
      const configurePortraitStyle = (choice) => {
        if (!choice) return;
        selectedPortraitStyle = choice;
        config.baseImageUrl = choice.imageUrl;
        config.styleImageUrl = choice.imageUrl;
        config.prompt = choice.prompt;
        config.imageModel = choice.imageModel;
        wrapper.dataset.portraitStyleId = choice.id;
      };
      configurePortraitStyle(selectedPortraitStyle);
      const portraitStyleDetails = () => selectedPortraitStyle ? {
        portraitStyleId: selectedPortraitStyle.id, portraitStyleKey: selectedPortraitStyle.key,
      } : {};
      const styleIdForDetails = (details) => String(details?.portraitStyleId || details?.productId || originalPortraitStyleId);
      const detailsMatchPortraitStyle = (details) => !selectedPortraitStyle ||
        (styleIdForDetails(details) === selectedPortraitStyle.id &&
          (!details?.portraitStyleKey || details.portraitStyleKey === selectedPortraitStyle.key));
      const syncPortraitStyleChoices = () => {
        if (!selectedPortraitStyle) return;
        const busy = wrapper.classList.contains('is-loading') || wrapper.classList.contains('is-amending');
        wrapper.querySelectorAll('[data-pop-portrait-style-id]').forEach((choice) => {
          const selected = choice.dataset.popPortraitStyleId === selectedPortraitStyle.id;
          choice.setAttribute('aria-pressed', String(selected));
          choice.disabled = busy;
          const check = choice.querySelector('.pop-style-options__check');
          if (check) check.hidden = !selected;
        });
      };

      const button = wrapper.querySelector('[data-personalisation-generate]');
      const statusEl = wrapper.querySelector('[data-personalisation-status]');
      const outputInput = wrapper.querySelector('[data-personalisation-output]');
      const fulfillmentOutputInput = wrapper.querySelector('[data-personalisation-fulfillment-output]');
      const originalUploadOutputInput = wrapper.querySelector('[data-personalisation-original-upload-output]');
      const digitalDownloadLabelInput = wrapper.querySelector('[data-personalisation-digital-download-label]');
      const digitalDownloadKeyInput = wrapper.querySelector('[data-personalisation-digital-download-key]');
      const digitalDownloadUpsell = wrapper.querySelector('[data-personalisation-digital-upsell]');
      const digitalDownloadToggle = wrapper.querySelector('[data-personalisation-digital-upsell-toggle]');
      const inputs = Array.from(wrapper.querySelectorAll('.personalisation-input'));
      const textInputs = inputs.filter((input) => input.type !== 'file');
      const hasTextInputs = textInputs.length > 0;
      const editDetailsButton = wrapper.querySelector('[data-personalisation-edit-details]');
      const uploadInputs = inputs.filter((input) => input.type === 'file');
      const uploadRequiredStates = new Map(uploadInputs.map((input) => [input, input.required]));
      const uploadFieldWrappers = uploadInputs
        .map((input) => input.closest('.personalisation-field--upload'))
        .filter(Boolean);
      const hasUploadInputs = uploadInputs.length > 0;
      const mobileUploadDock = wrapper.querySelector('[data-pop-pdp-mobile-upload-dock]');
      const nativeUploadButton = wrapper.querySelector('.personalisation-upload-button');
      const reviewMessageEl = wrapper.querySelector('[data-personalisation-review]');
      const amendPanelEl = wrapper.querySelector('[data-personalisation-amend]');
      const amendToggleEl = wrapper.querySelector('[data-personalisation-amend-toggle]');
      const amendBodyEl = wrapper.querySelector('[data-personalisation-amend-body]');
      const amendFormEl = wrapper.querySelector('[data-personalisation-amend-form]');
      const amendPromptEl = wrapper.querySelector('[data-personalisation-amend-prompt]');
      const amendSubmitEl = wrapper.querySelector('[data-personalisation-amend-submit]');
      const amendStatusEl = wrapper.querySelector('[data-personalisation-amend-status]');
      const progressEl = wrapper.querySelector('[data-personalisation-progress]');
      const progressCardEl = progressEl?.querySelector('.personalisation-progress__card') || null;
      const progressMessageEl = wrapper.querySelector('[data-personalisation-progress-message]');
      const progressFillEl = wrapper.querySelector('[data-personalisation-progress-fill]');
      const progressBarEl = wrapper.querySelector('[data-personalisation-progress-bar]');
      const progressReassuranceEl = wrapper.querySelector('[data-personalisation-progress-reassurance]');
      const progressTitleEl = wrapper.querySelector('[data-personalisation-progress-title]');
      const progressSubtextEl = wrapper.querySelector('[data-personalisation-progress-subtext]');
      const progressIconEl = wrapper.querySelector('[data-personalisation-progress-icon]');
      const progressIconImageEl = wrapper.querySelector('[data-personalisation-progress-icon-image]');
      const progressErrorEl = wrapper.querySelector('[data-personalisation-progress-error]');
      const progressErrorMessageEl = wrapper.querySelector('[data-personalisation-progress-error-message]');
      const progressRetryEl = wrapper.querySelector('[data-personalisation-progress-retry]');
      const progressBackEl = wrapper.querySelector('[data-personalisation-progress-back]');
      const progressEmailSectionEl = wrapper.querySelector('[data-personalisation-progress-email-section]');
      const progressEmailFormEl = wrapper.querySelector('[data-personalisation-progress-email-form]');
      const progressEmailInputEl = wrapper.querySelector('[data-personalisation-progress-email-input]');
      const progressEmailSubmitEl = wrapper.querySelector('[data-personalisation-progress-email-submit]');
      const progressEmailSkipEl = wrapper.querySelector('[data-personalisation-progress-email-skip]');
      const progressEmailSuccessEl = wrapper.querySelector('[data-personalisation-progress-email-success]');
      const progressReadyEl = wrapper.querySelector('[data-personalisation-progress-ready]');
      const progressViewButtonEl = wrapper.querySelector('[data-personalisation-progress-view]');
      const discountFlyoutEl = wrapper.querySelector('[data-personalisation-discount-flyout]');
      const discountFlyoutFormEl = wrapper.querySelector('[data-personalisation-discount-form]');
      const discountFlyoutEmailEl = wrapper.querySelector('[data-personalisation-discount-email]');
      const discountFlyoutSubmitEl = wrapper.querySelector('[data-personalisation-discount-submit]');
      const discountFlyoutHintEl = wrapper.querySelector('[data-personalisation-discount-hint]');
      const discountFlyoutSuccessEl = wrapper.querySelector('[data-personalisation-discount-success]');
      const discountFlyoutCodeEl = wrapper.querySelector('[data-personalisation-discount-code]');
      const discountFlyoutCopyEl = wrapper.querySelector('[data-personalisation-discount-copy]');
      const discountFlyoutCloseEls = Array.from(wrapper.querySelectorAll('[data-personalisation-discount-close]'));
      const progressUsesPreviewOverlay = Boolean(
        progressEl && progressEl.hasAttribute('data-personalisation-progress-email-overlay')
      );
      const sectionRoot = wrapper.closest('[data-testid="product-information"]') || document.documentElement;
      const removeDuplicateReviewMessages = () => {
        const reviewMessages = Array.from(
          sectionRoot.querySelectorAll('.personalisation-review-message')
        );
        if (reviewMessages.length < 2) return;

        const canonicalMessage =
          reviewMessageEl && reviewMessageEl.isConnected && sectionRoot.contains(reviewMessageEl)
            ? reviewMessageEl
            : reviewMessages[0];

        reviewMessages.forEach((messageEl) => {
          if (messageEl !== canonicalMessage) messageEl.remove();
        });
      };
      const reviewMessageObserver = new MutationObserver((records) => {
        const reviewMessageAdded = records.some((record) =>
          Array.from(record.addedNodes).some(
            (node) =>
              node instanceof Element &&
              (node.matches('.personalisation-review-message') ||
                node.querySelector('.personalisation-review-message'))
          )
        );
        if (reviewMessageAdded) removeDuplicateReviewMessages();
      });
      reviewMessageObserver.observe(sectionRoot, { childList: true, subtree: true });
      removeDuplicateReviewMessages();
      const howModal = wrapper.querySelector('[data-personalisation-how-modal]');
      const howOpenButtons = Array.from(document.querySelectorAll('[data-personalisation-how-open]'));
      const howCloseElements = Array.from(wrapper.querySelectorAll('[data-personalisation-how-close]'));
      const compareSlider = wrapper.querySelector('[data-personalisation-compare-slider]');
      const compareBeforeImage = wrapper.querySelector('[data-personalisation-compare-before]');
      const compareAfterImage = wrapper.querySelector('[data-personalisation-compare-after]');
      const compareAfterWrap = wrapper.querySelector('[data-personalisation-compare-after-wrap]');
      const compareCenterLine = wrapper.querySelector('[data-personalisation-compare-center-line]');
      const hideGenerateButton = Boolean(config.hideGenerateButton);
      const autoGeneratePreviewOnUpload = config.autoGeneratePreviewOnUpload !== false;
      const digitalDownloadVariantId = String(config.digitalDownloadVariantId || '').trim();
      const digitalDownloadEnabled = Boolean(digitalDownloadVariantId);
      const personalizedCheckoutCountry = () => String(window.Shopify?.country || config.countryCode || 'US').trim().toUpperCase();
      const personalizedCheckoutConfigured = () => (window.PopPrintsCheckoutMode
        ? window.PopPrintsCheckoutMode.isEnabled({
            eligible: config.personalizedCheckoutOverrideEligible === true,
            defaultEnabled: config.personalizedCheckoutEnabled === true,
          })
        : config.personalizedCheckoutEnabled === true);
      const personalizedCheckoutEnabled = () => ['US', 'CA', 'GB'].includes(personalizedCheckoutCountry()) && personalizedCheckoutConfigured();
      let checkoutDesignId = '';
      let checkoutDesignToken = '';
      let checkoutArtworkSource = '';
      let digitalDownloadSelected = false;
      let digitalDownloadKey = '';
      let digitalDownloadCartSubmitting = false;
      let compareBeforeUrl = '';
      let uploadPreviewObjectUrl = '';
      let uploadButtonHighlightTimer = null;
      let autoGenerateUploadSignature = '';
      let personalisationRevision = 0;
      let activePersonalisationOperation = null;
      let portraitDetailsSnapshot = null;
      let restoringPortraitDetails = false;
      const capturePersonalisationDetails = () => ({
        version: 1,
        productId: String(config.productId || ''),
        ...portraitStyleDetails(),
        portraitShape: getPortraitShape(),
        fields: textInputs.map((input) => ({ key: input.id || input.name, value: String(input.value || '').trim() })),
      });
      const isCompatiblePersonalisationDetails = (details) => Boolean(details && details.version === 1 &&
        details.productId === String(config.productId || '') && Array.isArray(details.fields) &&
        details.fields.length === textInputs.length && details.fields.every((field, index) => field &&
          field.key === (textInputs[index].id || textInputs[index].name) && typeof field.value === 'string'));
      const personalisationDetailsSignature = (details) => JSON.stringify({ fields: details?.fields || [], portraitShape: details?.portraitShape || 'portrait',
        ...(selectedPortraitStyle ? { portraitStyleId: styleIdForDetails(details), portraitStyleKey: details?.portraitStyleKey || '' } : {}) });
      const currentDetailsSignature = () => personalisationDetailsSignature(capturePersonalisationDetails());
      let lastTextDetailsSignature = currentDetailsSignature();
      let selectedShapeArtwork = null;
      const hasCurrentPortraitDetails = () => Boolean(portraitDetailsSnapshot) && (portraitDetailsSnapshot.portraitShape || 'portrait') === getPortraitShape() &&
        detailsMatchPortraitStyle(portraitDetailsSnapshot) &&
        (!hasTextInputs || (isCompatiblePersonalisationDetails(portraitDetailsSnapshot) &&
        personalisationDetailsSignature(portraitDetailsSnapshot) === currentDetailsSignature()));
      const beginPersonalisationOperation = (requestId, details = capturePersonalisationDetails()) => {
        const operation = { revision: ++personalisationRevision, requestId, details,
          uploadFile: uploadInputs.find((input) => input.files?.length)?.files[0] || null };
        activePersonalisationOperation = operation;
        return operation;
      };
      const isCurrentPersonalisationOperation = (operation) => Boolean(operation && wrapper.isConnected &&
        operation === activePersonalisationOperation && operation.revision === personalisationRevision &&
        operation.requestId === activeGenerationRequestId &&
        personalisationDetailsSignature(operation.details) === currentDetailsSignature());
      let nativeUploadButtonVisible = false;
      let nativeUploadButtonReached = false;
      let mobileUploadHeroVisible = false;
      const configuredHowBeforeUrl = typeof config.howItWorksBeforeUrl === 'string' ? config.howItWorksBeforeUrl.trim() : '';
      const configuredHowAfterUrl = typeof config.howItWorksAfterUrl === 'string' ? config.howItWorksAfterUrl.trim() : '';

      const buildPlaceholderDataUri = (label, fromColor, toColor) => {
        const safeLabel = String(label || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        const from = String(fromColor || '#e2e8f0');
        const to = String(toColor || '#cbd5e1');
        const svg =
          '<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="1200" viewBox="0 0 1200 1200">' +
          '<defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1">' +
          `<stop offset="0%" stop-color="${from}"/><stop offset="100%" stop-color="${to}"/>` +
          '</linearGradient></defs>' +
          '<rect width="1200" height="1200" fill="url(#g)"/>' +
          '<circle cx="600" cy="460" r="170" fill="rgba(255,255,255,0.55)"/>' +
          '<rect x="300" y="700" width="600" height="220" rx="110" fill="rgba(255,255,255,0.55)"/>' +
          `<text x="600" y="1030" text-anchor="middle" font-family="Arial, sans-serif" font-size="68" font-weight="700" fill="#0f172a">${safeLabel}</text>` +
          '</svg>';
        return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
      };

      const defaultBeforePlaceholder =
        configuredHowBeforeUrl || buildPlaceholderDataUri('Customer Photo', '#dbeafe', '#cbd5e1');
      const defaultAfterPlaceholder =
        configuredHowAfterUrl || buildPlaceholderDataUri(config.comparisonAfterPlaceholderLabel, '#fef3c7', '#fdba74');

      const setComparisonImages = ({ before } = {}) => {
        if (before !== undefined) compareBeforeUrl = before || '';

        const beforeSrc = compareBeforeUrl || defaultBeforePlaceholder;
        const afterSrc = defaultAfterPlaceholder;

        if (compareBeforeImage) {
          compareBeforeImage.src = beforeSrc;
        }

        if (compareAfterImage) {
          compareAfterImage.src = afterSrc;
        }
      };

      const updateComparisonSplit = () => {
        const raw = Number(compareSlider?.value || 50);
        const value = Number.isFinite(raw) ? Math.min(100, Math.max(0, raw)) : 50;
        if (compareAfterWrap) {
          compareAfterWrap.style.width = value + '%';
        }
        if (compareCenterLine) {
          compareCenterLine.style.left = value + '%';
        }
      };

      const openHowModal = () => {
        if (!howModal) return;
        howModal.hidden = false;
        document.body.classList.add('personalisation-how-modal-open');
        updateComparisonSplit();
      };

      const closeHowModal = () => {
        if (!howModal) return;
        howModal.hidden = true;
        document.body.classList.remove('personalisation-how-modal-open');
      };

      sectionRoot.classList.add('personalisation-enabled');
      sectionRoot.classList.add('personalisation-locked');
      if (digitalDownloadEnabled) {
        sectionRoot.classList.add('personalisation-digital-upsell-enabled');
      }
      setComparisonImages();
      updateComparisonSplit();

      const mobileUploadHero = sectionRoot.querySelector(
        'slideshow-slide.pop-pdp-primary-slide, .media-gallery__grid .pop-pdp-primary-slide'
      );

      const syncMobileUploadHeroPosition = () => {
        if (!mobileUploadDock || !mobileUploadHero || !sectionRoot) return;
        const sectionRect = sectionRoot.getBoundingClientRect();
        const heroRect = mobileUploadHero.getBoundingClientRect();
        const heroBottom = Math.max(0, heroRect.bottom - sectionRect.top);
        mobileUploadDock.style.setProperty('--pop-mobile-upload-hero-bottom', heroBottom + 'px');
      };

      if (mobileUploadDock && mobileUploadDock.parentElement !== sectionRoot) {
        sectionRoot.appendChild(mobileUploadDock);
      }

      const updateMobileUploadDock = () => {
        if (!mobileUploadDock) return;
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const previewReady = sectionRoot.classList.contains('personalisation-ready');
        const progressVisible = Boolean(progressEl && !progressEl.hidden);
        const isGenerating = wrapper.classList.contains('is-loading');
        const uploadButtonUnavailable = isMobile ? !nativeUploadButtonVisible : !nativeUploadButtonReached;
        const shouldShow = uploadButtonUnavailable && !previewReady && !progressVisible && !isGenerating;

        mobileUploadDock.hidden = !shouldShow;
        mobileUploadDock.classList.toggle('is-visible', shouldShow);
        mobileUploadDock.classList.toggle('is-over-hero', isMobile && shouldShow && mobileUploadHeroVisible);
        if (hasTextInputs) {
          const dockLabel = mobileUploadDock.querySelector('.pop-pdp-mobile-upload-dock__button span');
          if (dockLabel) dockLabel.textContent = uploadInputs.some((input) => input.files?.length)
            ? 'Continue to Details' : 'Choose Pet Photo';
        }
      };

      if (mobileUploadDock && nativeUploadButton) {
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(
            (entries) => {
              const entry = entries[0];
              nativeUploadButtonVisible = Boolean(entry && entry.isIntersecting);
              if (entry && entry.isIntersecting && entry.intersectionRatio >= 1) {
                nativeUploadButtonReached = true;
              }
              updateMobileUploadDock();
            },
            { threshold: [0, 1] }
          ).observe(nativeUploadButton);

          if (mobileUploadHero) {
            new IntersectionObserver(
              (entries) => {
                const entry = entries[0];
                mobileUploadHeroVisible = Boolean(entry && entry.isIntersecting);
                syncMobileUploadHeroPosition();
                updateMobileUploadDock();
              },
              { threshold: [0, 0.05, 1] }
            ).observe(mobileUploadHero);
          }
        }

        new MutationObserver(updateMobileUploadDock).observe(sectionRoot, {
          attributes: true,
          attributeFilter: ['class'],
        });

        new MutationObserver(updateMobileUploadDock).observe(wrapper, {
          attributes: true,
          attributeFilter: ['class'],
        });

        if (progressEl) {
          new MutationObserver(updateMobileUploadDock).observe(progressEl, {
            attributes: true,
            attributeFilter: ['hidden'],
          });
        }

        window.addEventListener(
          'resize',
          () => {
            syncMobileUploadHeroPosition();
            updateMobileUploadDock();
          },
          { passive: true }
        );
        window.requestAnimationFrame(() => {
          syncMobileUploadHeroPosition();
          updateMobileUploadDock();
        });
      }

      const normalizeValue = (value) => String(value || '').trim().toLowerCase();
      const isPrintOnlyOption = (value) => {
        const normalized = normalizeValue(value);
        return normalized.includes('print only') || (normalized.includes('print') && normalized.includes('no frame'));
      };
      const isSmallOption = (value) => {
        const normalized = normalizeValue(value);
        return normalized.includes('small') || normalized.includes('8 x 12') || normalized.includes('8x12');
      };
      const hasExplicitVariantInUrl = (() => {
        try {
          return new URL(window.location.href).searchParams.has('variant');
        } catch (err) {
          return false;
        }
      })();
      let autoSelectedDefaultVariant = false;

      const resolveVariantFieldset = (selectors) => {
        for (const selector of selectors) {
          const fieldset = sectionRoot.querySelector(selector);
          if (fieldset) return fieldset;
        }
        return null;
      };

      const ensureDesiredVariantOption = (fieldset, matcher) => {
        if (!(fieldset instanceof Element) || typeof matcher !== 'function') return 'missing';

        const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
        if (checkedInput && matcher(checkedInput.value)) {
          return 'ready';
        }

        const select = fieldset.querySelector('select');
        if (select && matcher(select.value)) {
          return 'ready';
        }

        const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
        const desiredRadio = radios.find((input) => {
          if (!matcher(input.value)) return false;
          if (input.disabled) return false;
          if (input.getAttribute('aria-disabled') === 'true') return false;
          return true;
        });

        if (desiredRadio) {
          if (typeof desiredRadio.click === 'function') {
            desiredRadio.click();
          } else {
            desiredRadio.checked = true;
            desiredRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return 'changed';
        }

        if (select) {
          const desiredOption = Array.from(select.options).find((option) => matcher(option.value));
          if (desiredOption) {
            select.value = desiredOption.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            return 'changed';
          }
        }

        return 'missing';
      };

      const defaultToPrintSmall = () => {
        if (autoSelectedDefaultVariant) return;
        if (sectionRoot.dataset.styleInteracted === 'true') {
          autoSelectedDefaultVariant = true;
          return;
        }
        if (hasExplicitVariantInUrl) {
          autoSelectedDefaultVariant = true;
          return;
        }

        const variantPicker = sectionRoot.querySelector('variant-picker');
        if (
          !(variantPicker instanceof HTMLElement) ||
          typeof variantPicker.updateSelectedOption !== 'function'
        ) {
          return;
        }

        const styleFieldset = resolveVariantFieldset([
          '.variant-option[data-option-name="style"]',
          '.variant-option[data-option-name="frame"]',
          '.variant-option[data-option-name="finish"]',
          '.variant-option[data-option-position="2"]',
        ]);
        const sizeFieldset = resolveVariantFieldset([
          '.variant-option[data-option-name="size"]',
          '.variant-option[data-option-position="1"]',
        ]);

        if (!styleFieldset || !sizeFieldset) return;

        const styleStatus = ensureDesiredVariantOption(styleFieldset, isPrintOnlyOption);
        if (styleStatus === 'changed') return;

        const sizeStatus = ensureDesiredVariantOption(sizeFieldset, isSmallOption);
        if (sizeStatus === 'changed') return;

        if (
          (styleStatus === 'ready' || styleStatus === 'missing') &&
          (sizeStatus === 'ready' || sizeStatus === 'missing')
        ) {
          autoSelectedDefaultVariant = true;
        }
      };

      const setStatus = (message, variant) => {
        if (!statusEl) return;
        statusEl.textContent = message || '';
        statusEl.classList.remove('is-error', 'is-success');
        if (variant === 'error') statusEl.classList.add('is-error');
        if (variant === 'success') statusEl.classList.add('is-success');
      };

      const setUploadFieldErrorState = (hasError) => {
        if (!uploadFieldWrappers.length) return;
        uploadFieldWrappers.forEach((field) => field.classList.toggle('has-error', Boolean(hasError)));
      };

      const hasUploadedImage = () => {
        if (!hasUploadInputs) return true;
        return uploadInputs.some((input) => input && input.files && input.files.length > 0) ||
          Boolean(config.portraitShapesEnabled && selectedShapeArtwork?.url) ||
          /^https:\/\//i.test(String(originalUploadOutputInput?.value || ''));
      };

      const hasDisplayPortraitReady = () => {
        if (!hasCurrentPortraitDetails()) return false;
        if (syncPersistedPortraitOutputFromState()) return true;
        const portraitValue = String(outputInput?.value || '').trim();
        return Boolean(portraitValue || getGeneratedImageUrl());
      };

      const hasPersistedPortraitUrl = () => {
        if (!hasCurrentPortraitDetails()) return false;
        if (syncPersistedPortraitOutputFromState()) return true;
        const portraitValue = String(outputInput?.value || '').trim();
        return isPersistedPortraitValue(portraitValue) || isPersistedPortraitValue(getGeneratedImageUrl());
      };

      const showCartValidationError = (message) => {
        setUploadFieldErrorState(true);
        setStatus(message, 'error');
        const uploadField = uploadFieldWrappers[0] || getUploadInput();
        if (uploadField && typeof uploadField.scrollIntoView === 'function') {
          uploadField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        const focusTarget = getUploadInput();
        if (focusTarget && typeof focusTarget.focus === 'function') {
          try {
            focusTarget.focus({ preventScroll: true });
          } catch (err) {
            focusTarget.focus();
          }
        }
      };

      const clearCartValidationError = () => {
        setUploadFieldErrorState(false);
      };

      const getMissingUploadMessage = () => config.missingUploadMessage;
      const getCompleteFieldsBeforePreviewMessage = () => config.referenceLayout === true ? 'Please complete the required fields, then click Create Print.' : 'Please complete the required fields, then click Preview My Portrait.';
      const clearMissingUploadMessage = () => {
        if (!statusEl) return;
        if (String(statusEl.textContent || '').trim() !== getMissingUploadMessage()) return;
        setStatus('', '');
      };
      const clearCompleteFieldsBeforePreviewMessage = () => {
        if (!statusEl) return;
        if (String(statusEl.textContent || '').trim() !== getCompleteFieldsBeforePreviewMessage()) return;
        setStatus('', '');
      };
      const clearGenerateButtonHighlight = () => {
        if (!button) return;
        if (uploadButtonHighlightTimer) {
          window.clearTimeout(uploadButtonHighlightTimer);
          uploadButtonHighlightTimer = null;
        }
        button.classList.remove('is-upload-highlighted');
      };
      const focusGenerateButtonAfterUpload = () => {
        if (!button || hideGenerateButton) return;
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            if (button.hidden) return;
            clearGenerateButtonHighlight();
            button.classList.add('is-upload-highlighted');
            uploadButtonHighlightTimer = window.setTimeout(() => {
              button.classList.remove('is-upload-highlighted');
              uploadButtonHighlightTimer = null;
            }, 3600);
            if (typeof button.scrollIntoView === 'function') {
              button.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'center' });
            }
            if (typeof button.focus === 'function') {
              try {
                button.focus({ preventScroll: true });
              } catch (err) {
                button.focus();
              }
            }
          });
        });
      };

      const syncGenerateButtonState = () => {
        syncPortraitStyleChoices();
        if (!button) return;
        const isBusy = wrapper.classList.contains('is-loading');
        const ready = hasUploadedImage();
        const shouldHide = hideGenerateButton || (autoGeneratePreviewOnUpload && hasUploadInputs && !ready && !isBusy);
        const shouldDisable = hideGenerateButton || isBusy || (config.referenceLayout === true && hasUploadInputs && !ready) || (autoGeneratePreviewOnUpload && hasUploadInputs && !ready && !isBusy);
        if (shouldHide) {
          clearGenerateButtonHighlight();
        }
        button.hidden = shouldHide;
        button.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
        button.disabled = shouldDisable;
        button.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
        button.classList.toggle('is-awaiting-upload', !ready && !isBusy);
        if (!ready) {
          clearCartValidationError();
        }
      };

      if (compareSlider) {
        compareSlider.addEventListener('input', updateComparisonSplit);
        compareSlider.addEventListener('change', updateComparisonSplit);
      }

      if (howOpenButtons.length) {
        howOpenButtons.forEach((element) => {
          element.addEventListener('click', (event) => {
            event.preventDefault();
            openHowModal();
          });
        });
      }

      if (howCloseElements.length) {
        howCloseElements.forEach((element) => {
          element.addEventListener('click', closeHowModal);
        });
      }

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (!howModal || howModal.hidden) return;
        closeHowModal();
      });

      const progressMessages = progressUsesPreviewOverlay
        ? [
            { at: 0, message: 'Getting your photo ready' },
            { at: 24, message: 'Creating your personalised artwork' },
            { at: 56, message: 'Refining the composition and details' },
            { at: 77, message: 'Adding the finishing touches' },
            { at: 89, message: 'Almost there—finishing your preview' },
          ]
        : [
            { at: 0, message: 'Getting your photo ready...' },
            { at: 20, message: 'Creating your personalised artwork...' },
            { at: 40, message: 'Refining the composition and details...' },
            { at: 60, message: 'Adding the finishing touches...' },
            { at: 80, message: 'Preparing your preview...' },
            { at: 92, message: 'Almost ready to reveal your artwork...' },
          ];
      const amendProgressMessages = progressUsesPreviewOverlay
        ? [
            { at: 0, message: 'Preparing your current artwork' },
            { at: 24, message: 'Reading your requested change' },
            { at: 56, message: 'Applying your requested change' },
            { at: 77, message: 'Blending the update carefully' },
            { at: 89, message: 'Almost there—finishing your update' },
          ]
        : [
            { at: 0, message: 'Reading your edit note...' },
            { at: 20, message: 'Loading the current artwork...' },
            { at: 40, message: 'Applying your requested change...' },
            { at: 60, message: 'Keeping the artwork consistent...' },
            { at: 80, message: 'Finishing your updated artwork...' },
            { at: 92, message: 'Almost ready to review your edit...' },
          ];
      const PROGRESS_EMAIL_DRAFT_KEY = `popPrints.previewOverlayEmailDraft.${String(config.productId || 'default')}`;
      const PROGRESS_DEFAULT_TITLE = 'Creating your free preview';
      const PROGRESS_DEFAULT_SUBTEXT = 'Turning your photo into art.';
      const PROGRESS_LONG_WAIT_REASSURANCE = 'Still working—detailed artwork can take a little longer. Your photo is safe.';
      const PROGRESS_EXTENDED_WAIT_REASSURANCE = 'This is taking longer than usual, but we’re still working. Please keep this page open.';
      const PROGRESS_READY_TITLE = 'Your preview is ready';
      const PROGRESS_READY_SUBTEXT = 'Your artwork is ready.';
      const previewEmailCaptureEnabled = false;
      let activeProgressMessages = progressMessages;
      let progressValue = 0;
      let progressTimer = null;
      let progressOverlayRevision = 0;
      let progressStartedAt = 0;
      let progressLongWaitShown = false;
      let progressExtendedWaitShown = false;
      let progressCurrentStage = -1;
      let progressLastAriaValue = -1;
      let progressRetryAction = null;
      let progressReturnFocusEl = null;
      let progressManagedInertEls = [];
      let progressOwnsScrollLock = false;
      let progressEmailShown = false;
      let progressEmailInteracted = false;
      let progressEmailSubmitted = false;
      let progressEmailDismissed = false;
      let progressEmailStartedTracked = false;
      let progressReadyStateReached = false;
      let progressReadyVisible = false;
      let progressFocusTarget = null;

      const getProgressSessionStorage = () => {
        try {
          return window.sessionStorage || null;
        } catch (err) {
          return null;
        }
      };

      const readProgressEmailDraft = () => {
        const storage = getProgressSessionStorage();
        if (!storage) return '';
        try {
          return String(storage.getItem(PROGRESS_EMAIL_DRAFT_KEY) || '').trim();
        } catch (err) {
          return '';
        }
      };

      const writeProgressEmailDraft = (value) => {
        const storage = getProgressSessionStorage();
        if (!storage) return;
        try {
          const normalized = String(value || '').trim();
          if (normalized) {
            storage.setItem(PROGRESS_EMAIL_DRAFT_KEY, normalized);
          } else {
            storage.removeItem(PROGRESS_EMAIL_DRAFT_KEY);
          }
        } catch (err) {}
      };

      const dispatchProgressEmailEvent = (eventName, detail = {}) => {
        document.dispatchEvent(
          new CustomEvent(eventName, {
            bubbles: true,
            detail: {
              requestId: activeGenerationRequestId || '',
              productId: String(config.productId || ''),
              productHandle: String(window.location.pathname || '').split('/').pop() || '',
              ...detail,
            },
          })
        );
      };

      const getCurrentProductHandle = () => {
        const segments = String(window.location.pathname || '').split('/').filter(Boolean);
        return segments.length ? segments[segments.length - 1] : '';
      };

      const getCurrentProductTitle = () => {
        const titleLink =
          sectionRoot.querySelector('[ref="productTitleLink"]') ||
          document.querySelector('[ref="productTitleLink"]');
        const titleText = titleLink ? String(titleLink.textContent || '').trim() : '';
        if (titleText) return titleText;
        return String(document.title || '').replace(/\s*[|\-]\s*[^|\-]+$/, '').trim();
      };

      const submitPreviewReadyEmailCapture = async (email, options = {}) => {
        const captureType = String(options.captureType || '').trim().toLowerCase() === 'discount_offer'
          ? 'discount_offer'
          : 'preview_ready';
        const previewUrl = String(options.previewUrl || '').trim();
        const discountCode = String(options.discountCode || '').trim();
        const response = await fetch('/apps/pop-prints-backend/preview-email', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'x-request-id': activeGenerationRequestId || '',
          },
          body: JSON.stringify({
            requestId: activeGenerationRequestId || '',
            email,
            pageUrl: window.location.href,
            productHandle: getCurrentProductHandle(),
            productTitle: getCurrentProductTitle(),
            captureType,
            ...(captureType === 'preview_ready' && progressEmailSectionEl?.dataset.followupConsent === 'overlay-sequence-v1'
              ? { followupConsent: 'overlay-sequence-v1' } : {}),
            previewUrl,
            discountCode,
          }),
        });

        const data = await response.json().catch(() => ({}));
        if (!response.ok || data?.ok === false) {
          throw new Error(data?.error || 'We could not save your email just now.');
        }
        return data;
      };

      const updateProgressStage = () => {
        if (progressFillEl) {
          progressFillEl.style.width = `${Math.max(0, Math.min(100, progressValue))}%`;
        }
        const messages = Array.isArray(activeProgressMessages) && activeProgressMessages.length
          ? activeProgressMessages
          : progressMessages;
        let activeStage = messages[0] || { message: '' };
        let activeStageIndex = 0;
        for (let index = messages.length - 1; index >= 0; index -= 1) {
          if (progressValue >= messages[index].at) {
            activeStage = messages[index];
            activeStageIndex = index;
            break;
          }
        }

        const activeMessage = progressValue >= 100
          ? 'Your portrait preview is ready'
          : String(activeStage.message || 'Getting your photo ready');
        const roundedProgress = Math.round(Math.max(0, Math.min(100, progressValue)));

        if (progressMessageEl && progressMessageEl.textContent !== activeMessage) {
          progressMessageEl.textContent = activeMessage;
        }

        const shouldUpdateProgressAria = Boolean(
          progressBarEl &&
          (
            progressLastAriaValue < 0 ||
            roundedProgress >= 100 ||
            Math.abs(roundedProgress - progressLastAriaValue) >= 5 ||
            progressCurrentStage !== activeStageIndex
          )
        );
        if (shouldUpdateProgressAria) {
          progressBarEl.setAttribute('aria-valuenow', String(roundedProgress));
          progressBarEl.setAttribute(
            'aria-valuetext',
            progressValue >= 100
              ? 'Your portrait preview is ready'
              : `${activeMessage}. Estimated progress ${roundedProgress}%`
          );
          progressLastAriaValue = roundedProgress;
        }
        progressCurrentStage = activeStageIndex;

        const elapsedProgressTime = progressStartedAt ? Date.now() - progressStartedAt : 0;
        const hasReachedExtendedWait = Boolean(
          progressUsesPreviewOverlay &&
          progressValue < 100 &&
          elapsedProgressTime >= 75000
        );
        const hasReachedLongWait = Boolean(
          progressUsesPreviewOverlay &&
          progressValue < 100 &&
          elapsedProgressTime >= 45000
        );
        if (hasReachedExtendedWait && !progressExtendedWaitShown && progressReassuranceEl) {
          progressExtendedWaitShown = true;
          progressLongWaitShown = true;
          progressReassuranceEl.textContent = PROGRESS_EXTENDED_WAIT_REASSURANCE;
          progressReassuranceEl.classList.add('is-long-wait');
        } else if (hasReachedLongWait && !progressLongWaitShown && progressReassuranceEl) {
          progressLongWaitShown = true;
          progressReassuranceEl.textContent = PROGRESS_LONG_WAIT_REASSURANCE;
          progressReassuranceEl.classList.add('is-long-wait');
        }
      };

      const setProgressTitleState = ({ title = PROGRESS_DEFAULT_TITLE, subtext = PROGRESS_DEFAULT_SUBTEXT } = {}) => {
        if (progressTitleEl) progressTitleEl.textContent = title;
        if (progressSubtextEl) progressSubtextEl.textContent = subtext;
      };

      const lockProgressExperience = () => {
        if (!progressEl || !progressCardEl) return;
        if (!progressReturnFocusEl && document.activeElement instanceof HTMLElement) {
          progressReturnFocusEl = document.activeElement;
        }

        const root = document.documentElement;
        progressOwnsScrollLock = !root.hasAttribute('scroll-lock');
        if (progressOwnsScrollLock) root.setAttribute('scroll-lock', '');
        root.classList.add('personalisation-progress-open');

        progressManagedInertEls = [];
        let activeBranch = progressEl;
        while (activeBranch && activeBranch !== document.body) {
          const parent = activeBranch.parentElement;
          if (!parent) break;
          Array.from(parent.children).forEach((sibling) => {
            if (sibling === activeBranch || sibling.hasAttribute('inert')) return;
            sibling.setAttribute('inert', '');
            progressManagedInertEls.push(sibling);
          });
          activeBranch = parent;
        }

        window.requestAnimationFrame(() => {
          if (!progressEl.hidden) progressCardEl.focus({ preventScroll: true });
        });
      };

      const unlockProgressExperience = () => {
        progressManagedInertEls.forEach((element) => {
          if (element?.isConnected) element.removeAttribute('inert');
        });
        progressManagedInertEls = [];

        const root = document.documentElement;
        root.classList.remove('personalisation-progress-open');
        if (progressOwnsScrollLock) root.removeAttribute('scroll-lock');
        progressOwnsScrollLock = false;
      };

      const getProgressPetImage = () => getUploadFile()
        ? uploadPreviewObjectUrl
        : String(originalUploadOutputInput?.value || '').trim();

      const setProgressIconImage = (src = '') => {
        if (!progressIconEl || !progressIconImageEl) return;
        const resolvedSrc = String(src || '').trim();
        const hasImage = Boolean(resolvedSrc);
        if (hasImage) {
          progressIconImageEl.src = resolvedSrc;
        } else {
          progressIconImageEl.removeAttribute('src');
        }
        progressIconEl.classList.toggle('has-image', hasImage);
      };

      const setProgressEmailVisible = (visible) => {
        if (!progressEmailSectionEl) return;
        progressEmailShown = Boolean(visible);
        progressEmailSectionEl.hidden = !visible;
        progressEmailSectionEl.classList.toggle('is-visible', Boolean(visible));
      };

      const setProgressReadyVisible = (visible) => {
        if (!progressReadyEl) return;
        progressReadyVisible = Boolean(visible);
        progressReadyEl.hidden = !visible;
        progressReadyEl.classList.toggle('is-visible', Boolean(visible));
        progressCardEl?.classList.toggle('is-ready', Boolean(visible));
        if (progressCardEl) progressCardEl.setAttribute('aria-busy', visible ? 'false' : 'true');
      };

      const setProgressErrorVisible = (visible, message = '') => {
        if (!progressErrorEl) return;
        progressErrorEl.hidden = !visible;
        progressCardEl?.classList.toggle('is-error', Boolean(visible));
        if (progressCardEl) progressCardEl.setAttribute('aria-busy', visible ? 'false' : 'true');
        if (visible && progressErrorMessageEl) {
          progressErrorMessageEl.textContent = message || 'We hit a temporary problem, but your photo is still here.';
        }
      };

      const setProgressEmailSubmittedState = (submitted) => {
        progressEmailSubmitted = Boolean(submitted);
        if (progressEmailSectionEl) {
          progressEmailSectionEl.classList.toggle('is-submitted', progressEmailSubmitted);
        }
        if (progressEmailFormEl) progressEmailFormEl.hidden = submitted;
        if (progressEmailSkipEl) progressEmailSkipEl.hidden = submitted;
        if (progressEmailSuccessEl) {
          progressEmailSuccessEl.hidden = !submitted;
          progressEmailSuccessEl.classList.toggle('is-visible', submitted);
        }
      };

      const resetProgressOverlayState = ({
        title = PROGRESS_DEFAULT_TITLE,
        subtext = PROGRESS_DEFAULT_SUBTEXT,
        iconSrc = getProgressPetImage(),
        messages = progressMessages,
        retryAction = null,
        reassurance = 'Usually ready in about 30 seconds.',
      } = {}) => {
        activeProgressMessages = Array.isArray(messages) && messages.length
          ? messages
          : progressMessages;
        progressValue = 4;
        progressStartedAt = Date.now();
        progressLongWaitShown = false;
        progressExtendedWaitShown = false;
        progressCurrentStage = -1;
        progressLastAriaValue = -1;
        progressRetryAction = typeof retryAction === 'function' ? retryAction : null;
        progressEmailShown = false;
        progressEmailInteracted = false;
        progressEmailSubmitted = false;
        progressEmailDismissed = false;
        progressEmailStartedTracked = false;
        progressReadyStateReached = false;
        progressReadyVisible = false;
        progressFocusTarget = null;
        setProgressTitleState({ title, subtext });
        setProgressIconImage(iconSrc);
        setProgressReadyVisible(false);
        setProgressErrorVisible(false);
        setProgressEmailVisible(previewEmailCaptureEnabled);
        setProgressEmailSubmittedState(false);
        if (progressCardEl) progressCardEl.setAttribute('aria-busy', 'true');
        if (progressReassuranceEl) {
          progressReassuranceEl.classList.remove('is-long-wait');
          progressReassuranceEl.textContent = reassurance;
        }
        if (progressEmailInputEl) {
          progressEmailInputEl.value = readProgressEmailDraft();
          progressEmailInputEl.setAttribute('aria-invalid', 'false');
        }
        if (progressEmailSubmitEl) {
          progressEmailSubmitEl.disabled = false;
          progressEmailSubmitEl.textContent = 'Email me';
        }
        updateProgressStage();
      };

      const showProgressEmailCapture = () => {
        if (!previewEmailCaptureEnabled) return;
        if (progressEmailDismissed || progressEmailShown) return;
        setProgressEmailVisible(true);
      };

      const startProgressTicker = () => {
        if (progressTimer) clearInterval(progressTimer);
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const tickProgress = () => {
          const elapsedSeconds = Math.max(0, (Date.now() - progressStartedAt) / 1000);
          const estimatedProgress = 4 + 94 * (1 - Math.exp(-elapsedSeconds / 13));
          progressValue = Math.max(progressValue, Math.min(98, estimatedProgress));
          updateProgressStage();


        };
        tickProgress();
        progressTimer = setInterval(tickProgress, prefersReducedMotion ? 1000 : 220);
      };

      const shouldHoldOverlayOpenOnReady = () => {
        if (!progressUsesPreviewOverlay) return false;
        if (!previewEmailCaptureEnabled) return false;
        return (progressEmailInteracted || progressEmailSubmitted || document.activeElement === progressEmailInputEl || Boolean(String(progressEmailInputEl?.value || '').trim())) && !progressEmailDismissed;
      };

      const dismissProgressOverlay = ({ restoreFocus = true } = {}) => {
        const overlayRevision = ++progressOverlayRevision;
        const detailsRevision = personalisationRevision;
        if (progressTimer) clearInterval(progressTimer);
        progressTimer = null;
        if (!progressEl) return;
        progressEl.hidden = true;
        if (progressUsesPreviewOverlay) {
          progressEl.setAttribute('aria-hidden', 'true');
        }
        unlockProgressExperience();

        const focusTarget = progressFocusTarget || progressReturnFocusEl;
        progressFocusTarget = null;
        progressReturnFocusEl = null;
        progressRetryAction = null;

        if (restoreFocus && focusTarget instanceof HTMLElement && focusTarget.isConnected) {
          window.requestAnimationFrame(() => {
            if (overlayRevision !== progressOverlayRevision || detailsRevision !== personalisationRevision) return;
            if (focusTarget.matches('img')) {
              focusUpdatedImage(focusTarget);
              return;
            }
            try {
              focusTarget.focus({ preventScroll: true });
            } catch (err) {
              focusTarget.focus();
            }
          });
        }
      };

      const showProgressReadyState = () => {
        if (!progressUsesPreviewOverlay) return;
        if (progressTimer) clearInterval(progressTimer);
        progressTimer = null;
        progressReadyStateReached = true;
        progressValue = 100;
        updateProgressStage();
        if (progressCardEl) progressCardEl.setAttribute('aria-busy', 'false');
        setProgressTitleState({
          title: PROGRESS_READY_TITLE,
          subtext: previewEmailCaptureEnabled && progressEmailSubmitted
            ? 'Your preview is ready, and we\'ll email you a link back to it.'
            : PROGRESS_READY_SUBTEXT,
        });
        setProgressReadyVisible(previewEmailCaptureEnabled ? progressEmailSubmitted : true);
        dispatchProgressEmailEvent('personalisation:email-overlay-ready', {
          emailCaptured: progressEmailSubmitted,
        });
      };

      const showProgressErrorState = (message = '') => {
        if (!progressUsesPreviewOverlay || !progressEl) {
          dismissProgressOverlay();
          return;
        }
        if (progressTimer) clearInterval(progressTimer);
        progressTimer = null;
        const safeMessage = String(message || '').trim();
        const displayMessage = safeMessage && safeMessage.length <= 180
          ? safeMessage
          : 'We hit a temporary problem, but your photo is still here.';
        setProgressReadyVisible(false);
        setProgressEmailVisible(false);
        setProgressTitleState({
          title: "We couldn't create your preview",
          subtext: 'Your photo is still here. Please try again.',
        });
        setProgressErrorVisible(true, displayMessage);
        const overlayRevision = progressOverlayRevision;
        window.requestAnimationFrame(() => {
          if (overlayRevision === progressOverlayRevision) progressRetryEl?.focus({ preventScroll: true });
        });
      };

      const applyForcedProgressOverlay = () => {
        const forcedOverlayState = getForcedProgressOverlayState();
        if (!forcedOverlayState || !progressUsesPreviewOverlay || !progressEl) return;

        activeGenerationRequestId =
          activeGenerationRequestId ||
          `debug-overlay-${Date.now().toString(36)}`;

        showProgress({
          retryAction: forcedOverlayState === 'error' ? () => showProgress() : null,
        });

        if (forcedOverlayState === 'ready') {
          showProgressEmailCapture();
          showProgressReadyState();
        } else if (forcedOverlayState === 'error') {
          showProgressErrorState('We hit a temporary problem, but your photo is still here.');
        }
      };

      const showProgress = (options = {}) => {
        if (!progressEl) return;
        progressOverlayRevision += 1;
        const wasHidden = progressEl.hidden;
        if (wasHidden && !progressReturnFocusEl && document.activeElement instanceof HTMLElement) {
          progressReturnFocusEl = document.activeElement;
        }
        progressEl.hidden = false;
        if (progressUsesPreviewOverlay) {
          progressEl.setAttribute('aria-hidden', 'false');
          resetProgressOverlayState(options);
          if (wasHidden) lockProgressExperience();
          startProgressTicker();
          return;
        }

        activeProgressMessages = Array.isArray(options.messages) && options.messages.length
          ? options.messages
          : progressMessages;
        setProgressTitleState({
          title: options.title || PROGRESS_DEFAULT_TITLE,
          subtext: options.subtext || PROGRESS_DEFAULT_SUBTEXT,
        });
        setProgressIconImage(options.iconSrc || getProgressPetImage());
        progressValue = 20;
        updateProgressStage();
        if (progressTimer) clearInterval(progressTimer);
        progressTimer = setInterval(() => {
          progressValue += 16;
          if (progressValue > 92) progressValue = 20;
          updateProgressStage();
        }, 5000);
      };

      const hideProgress = (complete) => {
        if (!progressEl) return;
        const overlayRevision = progressOverlayRevision;
        if (progressTimer) clearInterval(progressTimer);
        progressTimer = null;

        if (!progressUsesPreviewOverlay) {
          if (complete && progressFillEl) {
            progressFillEl.style.width = '100%';
          }
          setTimeout(() => {
            if (overlayRevision !== progressOverlayRevision) return;
            progressEl.hidden = true;
            activeProgressMessages = progressMessages;
          }, complete ? 200 : 0);
          return;
        }

        if (!complete) {
          dismissProgressOverlay();
          activeProgressMessages = progressMessages;
          return;
        }

        progressValue = 100;
        updateProgressStage();
        if (progressCardEl) progressCardEl.setAttribute('aria-busy', 'false');

        if (shouldHoldOverlayOpenOnReady()) {
          showProgressReadyState();
          return;
        }

        setTimeout(() => {
          if (overlayRevision !== progressOverlayRevision) return;
          if (shouldHoldOverlayOpenOnReady()) {
            showProgressReadyState();
            return;
          }
          dismissProgressOverlay();
          activeProgressMessages = progressMessages;
        }, 720);
      };

      if (progressEmailInputEl) {
        progressEmailInputEl.addEventListener('input', () => {
          progressEmailInteracted = true;
          if (!progressEmailStartedTracked) {
            progressEmailStartedTracked = true;
            dispatchProgressEmailEvent('personalisation:email-capture-started');
          }
          progressEmailInputEl.setAttribute('aria-invalid', 'false');
          writeProgressEmailDraft(progressEmailInputEl.value);
        });
      }

      if (progressEmailSubmitEl && progressEmailInputEl) {
        progressEmailSubmitEl.addEventListener('click', async () => {
          const value = String(progressEmailInputEl.value || '').trim();
          const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
          progressEmailInteracted = true;

          if (!progressEmailStartedTracked) {
            progressEmailStartedTracked = true;
            dispatchProgressEmailEvent('personalisation:email-capture-started');
          }

          if (!isValid) {
            progressEmailInputEl.setAttribute('aria-invalid', 'true');
            progressEmailInputEl.focus();
            return;
          }

          const originalLabel = progressEmailSubmitEl.textContent;
          progressEmailSubmitEl.disabled = true;
          progressEmailSubmitEl.textContent = 'Saving...';

          try {
            await submitPreviewReadyEmailCapture(value);
            writeProgressEmailDraft(value);
            setProgressEmailSubmittedState(true);
            dispatchProgressEmailEvent('personalisation:email-capture-submitted', {
              email: value,
            });

            if (progressReadyStateReached) {
              setProgressTitleState({
                title: PROGRESS_READY_TITLE,
                subtext: 'Your preview is ready, and we\'ll email you a link back to it.',
              });
              setProgressReadyVisible(true);
            }
          } catch (err) {
            progressEmailInputEl.setAttribute('aria-invalid', 'true');
            progressEmailInputEl.focus();
            if (progressSubtextEl && !progressReadyStateReached) {
              progressSubtextEl.textContent = 'We could not save your email just now. Please try again.';
            }
          } finally {
            progressEmailSubmitEl.disabled = false;
            progressEmailSubmitEl.textContent = originalLabel;
          }
        });
      }

      if (progressEmailSkipEl) {
        progressEmailSkipEl.addEventListener('click', () => {
          progressEmailDismissed = true;
          setProgressEmailVisible(false);
          dispatchProgressEmailEvent('personalisation:email-capture-skipped');
          if (progressReadyStateReached) {
            dismissProgressOverlay();
            if (progressFocusTarget) {
              focusUpdatedImage(progressFocusTarget);
            }
          }
        });
      }

      if (progressViewButtonEl) {
        progressViewButtonEl.addEventListener('click', () => {
          dismissProgressOverlay();
        });
      }

      if (progressRetryEl) {
        progressRetryEl.addEventListener('click', () => {
          const retryAction = progressRetryAction;
          const returnFocusEl = progressReturnFocusEl;
          dismissProgressOverlay({ restoreFocus: false });
          progressReturnFocusEl = returnFocusEl;
          if (typeof retryAction === 'function') {
            window.setTimeout(() => retryAction(), 0);
          }
        });
      }

      if (progressBackEl) {
        progressBackEl.addEventListener('click', () => dismissProgressOverlay());
      }

      if (progressEl) {
        progressEl.addEventListener('keydown', (event) => {
          if (progressEl.hidden) return;

          const canDismiss = Boolean(
            (progressErrorEl && !progressErrorEl.hidden) ||
            (progressReadyEl && !progressReadyEl.hidden)
          );
          if (event.key === 'Escape' && canDismiss) {
            event.preventDefault();
            dismissProgressOverlay();
            return;
          }
          if (event.key !== 'Tab') return;

          const focusableEls = Array.from(
            progressCardEl?.querySelectorAll(
              'button:not([disabled]):not([hidden]), input:not([disabled]):not([hidden]), [href], [tabindex]:not([tabindex="-1"])'
            ) || []
          ).filter((element) => element instanceof HTMLElement && element.offsetParent !== null);

          if (!focusableEls.length) {
            event.preventDefault();
            progressCardEl?.focus({ preventScroll: true });
            return;
          }

          const first = focusableEls[0];
          const last = focusableEls[focusableEls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });
      }

      const ensureFieldsValid = () => {
        for (const input of inputs) {
          if (!input.checkValidity()) {
            input.reportValidity();
            return false;
          }
        }
        return true;
      };

      const syncTextFieldValidity = (input) => {
        if (!input || input.type === 'file') return true;
        const value = String(input.value || '').trim();
        const message = input.required && !value ? 'Please fill in this field.'
          : value && input.minLength > 0 && value.length < input.minLength ? `Please use at least ${input.minLength} characters.`
          : input.maxLength >= 0 && value.length > input.maxLength ? `Please use no more than ${input.maxLength} characters.` : '';
        input.setCustomValidity(message);
        return input.checkValidity();
      };

      const ensureTextFieldsValid = () => {
        for (const input of inputs) {
          if (input.type === 'file') continue;
          if (!syncTextFieldValidity(input)) {
            if (typeof input.scrollIntoView === 'function') {
              input.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            input.reportValidity();
            return false;
          }
        }
        return true;
      };

      const hasIncompleteRequiredFields = () => {
        for (const input of inputs) {
          if (input.type === 'file') continue;
          if (!syncTextFieldValidity(input)) {
            return true;
          }
        }
        return false;
      };

      const invalidatePortraitForInputChange = ({ message = 'Your details changed. Create a new preview before ordering.', force = false, preserveShapeSource = false, preserveProgressOverlay = false } = {}) => {
        const keepReady = Boolean(preserveShapeSource && selectedShapeArtwork && sectionRoot.classList.contains('personalisation-ready'));
        if (!preserveShapeSource) selectedShapeArtwork = null;
        const hadPortrait = Boolean(getGeneratedImageUrl() || outputInput?.value || activePersonalisationOperation ||
          sectionRoot.classList.contains('personalisation-ready'));
        personalisationRevision += 1;
        activePersonalisationOperation = null;
        portraitDetailsSnapshot = null;
        if (hasTextInputs) uploadRequiredStates.forEach((required, input) => { input.required = required; });
        activeGenerationRequestId = '';
        activePreviewWatermarkToken += 1;
        checkoutDesignId = '';
        checkoutDesignToken = '';
        window.PopPrintsPersonalizedCheckout?.cancelWarm?.();
        storeGeneratedImage('');
        setPortraitOutputValue('');
        setPersistedPortraitPending(false);
        wrapper.classList.remove('is-loading', 'is-amending');
        wrapper.classList.toggle('personalisation-complete', keepReady);
        sectionRoot.classList.toggle('personalisation-ready', keepReady);
        sectionRoot.classList.toggle('personalisation-resizing', keepReady);
        sectionRoot.classList.add('personalisation-locked');
        if (!preserveProgressOverlay) hideProgress(false);
        clearCartValidationError();
        syncDigitalDownloadUpsell({ resetSelection: true });
        syncAmendPanelState();
        if (button) button.textContent = config.referenceLayout === true ? 'Create Print' : 'Preview My Portrait';
        syncGenerateButtonState();
        updateMobileUploadDock();
        if (hadPortrait || force) setStatus(message, '');
      };

      const CLIENT_UPLOAD_MAX_DIM = 1600;
      const CLIENT_UPLOAD_MAX_BYTES = 1500000;
      const CLIENT_UPLOAD_QUALITY = 0.86;

      const estimateBase64Bytes = (base64) => {
        const value = String(base64 || '');
        if (!value) return 0;
        return Math.floor((value.length * 3) / 4);
      };

      const parseDataUrl = (dataUrl) => {
        const raw = String(dataUrl || '');
        const match = raw.match(/^data:([^;,]+)?(?:;[^,]*)?,(.*)$/);
        if (!match) return { mimeType: '', base64: raw };
        return {
          mimeType: match[1] || '',
          base64: match[2] || ''
        };
      };

      const readBlobAsDataUrl = (blob) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(String(reader.result || ''));
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      const loadImageFromDataUrl = (dataUrl) => new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error('Unable to decode selected image.'));
        img.src = dataUrl;
      });

      const canClientOptimizeMime = (mimeType) => /^image\/(png|jpe?g|webp)$/i.test(String(mimeType || '').trim());

      const optimizeClientImagePayload = async (dataUrl, mimeType) => {
        const parsed = parseDataUrl(dataUrl);
        const base64 = parsed.base64 || '';
        const sourceMime = (mimeType || parsed.mimeType || 'image/png').toString().trim() || 'image/png';
        if (!base64 || !canClientOptimizeMime(sourceMime)) {
          return { base64, mimeType: sourceMime, changed: false };
        }

        const originalBytes = estimateBase64Bytes(base64);
        let image;
        try {
          image = await loadImageFromDataUrl(dataUrl);
        } catch (err) {
          return { base64, mimeType: sourceMime, changed: false };
        }

        const width = image.naturalWidth || image.width || 0;
        const height = image.naturalHeight || image.height || 0;
        if (!width || !height) {
          return { base64, mimeType: sourceMime, changed: false };
        }

        const maxDim = Math.max(width, height);
        const needsResize = maxDim > CLIENT_UPLOAD_MAX_DIM;
        const needsCompression = originalBytes > CLIENT_UPLOAD_MAX_BYTES;
        if (!needsResize && !needsCompression) {
          return { base64, mimeType: sourceMime, changed: false };
        }

        const scale = needsResize ? (CLIENT_UPLOAD_MAX_DIM / maxDim) : 1;
        const targetWidth = Math.max(1, Math.round(width * scale));
        const targetHeight = Math.max(1, Math.round(height * scale));
        const canvas = document.createElement('canvas');
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        const context = canvas.getContext('2d');
        if (!context) {
          return { base64, mimeType: sourceMime, changed: false };
        }
        context.drawImage(image, 0, 0, targetWidth, targetHeight);

        const outputMime = /png/i.test(sourceMime) ? 'image/png' : 'image/jpeg';
        let optimizedDataUrl = '';
        try {
          optimizedDataUrl = outputMime === 'image/png'
            ? canvas.toDataURL(outputMime)
            : canvas.toDataURL(outputMime, CLIENT_UPLOAD_QUALITY);
        } catch (err) {
          return { base64, mimeType: sourceMime, changed: false };
        }

        const optimizedParsed = parseDataUrl(optimizedDataUrl);
        const optimizedBase64 = optimizedParsed.base64 || '';
        if (!optimizedBase64) {
          return { base64, mimeType: sourceMime, changed: false };
        }

        const optimizedBytes = estimateBase64Bytes(optimizedBase64);
        const changed = needsResize || optimizedBytes < originalBytes;
        if (!changed) {
          return { base64, mimeType: sourceMime, changed: false };
        }

        return {
          base64: optimizedBase64,
          mimeType: outputMime,
          changed: true,
          width: targetWidth,
          height: targetHeight
        };
      };

      const fetchBase64Image = async (url) => {
        const response = await fetch(url, { cache: 'no-store', credentials: 'same-origin' });
        if (!response.ok) {
          throw new Error('Unable to load base image.');
        }
        const blob = await response.blob();
        const mimeType = blob.type || 'image/png';
        const dataUrl = await readBlobAsDataUrl(blob);
        const optimized = await optimizeClientImagePayload(dataUrl, mimeType);
        return { base64: optimized.base64, mimeType: optimized.mimeType };
      };

      const fetchBase64File = async (file) => {
        if (!file) throw new Error('No file selected.');
        const dataUrl = await readBlobAsDataUrl(file);
        const mimeType = file.type || parseDataUrl(dataUrl).mimeType || 'image/png';
        const optimized = await optimizeClientImagePayload(dataUrl, mimeType);
        return { base64: optimized.base64, mimeType: optimized.mimeType };
      };

      const getUploadInput = () => inputs.find((input) => input.type === 'file');
      const getUploadFile = () => {
        const input = getUploadInput();
        if (!input || !input.files || !input.files.length) return null;
        return input.files[0];
      };
      const buildUploadSignature = (file) => (
        file ? [file.name || '', file.size || 0, file.lastModified || 0].join(':') : ''
      );

      const updateUploadFieldUi = (input, file, previewUrl) => {
        const field = input ? input.closest('.personalisation-field--upload') : null;
        if (!field) return;

        const filenameEl = field.querySelector('[data-personalisation-upload-filename]');
        const previewWrap = field.querySelector('[data-personalisation-upload-preview]');
        const previewImage = field.querySelector('[data-personalisation-upload-thumb]');
        const fallbackText =
          field.getAttribute('data-upload-default-text') ||
          "We'll turn your photo into artwork you can check before ordering.";

        if (filenameEl) {
          if (file) {
            filenameEl.textContent = String(file.name || 'Photo selected');
            filenameEl.hidden = false;
          } else {
            filenameEl.textContent = fallbackText;
            filenameEl.hidden = true;
          }
        }

        if (previewWrap && previewImage) {
          if (file && previewUrl) {
            previewImage.src = previewUrl;
            previewImage.alt = file.name ? 'Preview of ' + file.name : config.uploadPreviewAlt;
            previewWrap.hidden = false;
          } else {
            previewImage.removeAttribute('src');
            previewImage.alt = config.uploadPreviewAlt;
            previewWrap.hidden = true;
          }
        }
      };

      let hadUploadedImage = hasUploadedImage();
      let lastSelectedUploadFile = getUploadFile();
      uploadInputs.forEach((input) => {
        const onUploadChanged = ({ focusGenerateButton = true } = {}) => {
          const hadUploadBefore = hadUploadedImage;
          clearCartValidationError();
          const file = input && input.files && input.files.length ? input.files[0] : getUploadFile();
          const photoChanged = focusGenerateButton && file !== lastSelectedUploadFile;
          if (photoChanged && !restoringPortraitDetails) {
            invalidatePortraitForInputChange({ message: 'Your photo changed. Create a new preview before ordering.' });
            cachedUploadSignature = '';
            cachedUploadBase64 = '';
          }
          lastSelectedUploadFile = file;
          if (file) {
            clearMissingUploadMessage();
          }
          if (uploadPreviewObjectUrl && uploadPreviewObjectUrl.startsWith('blob:')) {
            try {
              URL.revokeObjectURL(uploadPreviewObjectUrl);
            } catch (err) {
              // ignore
            }
          }
          uploadPreviewObjectUrl = '';
          if (file) {
            uploadPreviewObjectUrl = URL.createObjectURL(file);
            setComparisonImages({ before: uploadPreviewObjectUrl });
          } else {
            setComparisonImages({ before: '' });
          }
          setProgressIconImage(uploadPreviewObjectUrl);
          updateUploadFieldUi(input, file, uploadPreviewObjectUrl);
          syncGenerateButtonState();
          const hasUploadNow = hasUploadedImage();
          const uploadSignature = buildUploadSignature(file);
          if (!hasUploadNow) {
            autoGenerateUploadSignature = '';
            setOriginalUploadOutputValue('');
          } else if (file) {
            setOriginalUploadOutputValue('');
          }
          if (focusGenerateButton && hasUploadNow && (!hadUploadBefore || photoChanged)) {
            if (autoGeneratePreviewOnUpload && ensureFieldsValid() && uploadSignature && uploadSignature !== autoGenerateUploadSignature) {
              autoGenerateUploadSignature = uploadSignature;
              window.requestAnimationFrame(() => {
                if (!wrapper.classList.contains('is-loading')) {
                  handleGenerate();
                }
              });
            } else {
              if (!autoGeneratePreviewOnUpload && hasIncompleteRequiredFields()) {
                setStatus(getCompleteFieldsBeforePreviewMessage(), 'error');
                ensureTextFieldsValid();
              } else {
                focusGenerateButtonAfterUpload();
              }
            }
          }
          hadUploadedImage = hasUploadNow;        };
        input.addEventListener('change', () => onUploadChanged());
        onUploadChanged({ focusGenerateButton: false });
      });

      inputs.forEach((input) => {
        if (input.type === 'file') return;
        const onFieldUpdated = () => {
          if (restoringPortraitDetails) return;
          const nextSignature = currentDetailsSignature();
          if (nextSignature !== lastTextDetailsSignature) {
            lastTextDetailsSignature = nextSignature;
            invalidatePortraitForInputChange();
          }
          syncTextFieldValidity(input);
          updateMobileUploadDock();
          if (!hasUploadedImage()) {
            clearCompleteFieldsBeforePreviewMessage();
            return;
          }
          if (hasIncompleteRequiredFields()) {
            return;
          }
          clearCompleteFieldsBeforePreviewMessage();
        };
        input.addEventListener('input', onFieldUpdated);
        input.addEventListener('change', onFieldUpdated);
      });

      if (mobileUploadDock && hasTextInputs) {
        mobileUploadDock.addEventListener('click', (event) => {
          if (!hasUploadedImage()) return;
          event.preventDefault();
          if (ensureTextFieldsValid()) focusGenerateButtonAfterUpload();
        });
      }
      editDetailsButton?.addEventListener('click', () => {
        if (digitalDownloadCartSubmitting || window.PopPrintsPersonalizedCheckout?.isBusy?.()) return;
        invalidatePortraitForInputChange({ force: true, message: 'Update your details, then create a new preview before ordering.' });
        const firstInput = textInputs[0];
        if (firstInput) {
          firstInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstInput.focus({ preventScroll: true });
        }
      });

      const normalizeKey = (value) => String(value || '').toLowerCase().replace(/[^a-z]/g, '');
      const namesProductIds = new Set(['15608200036730']);
      const isNamesProduct = () => namesProductIds.has(String(config.productId || ''));

      const extractPropertyName = (input) => {
        if (!input) return '';
        const raw = String(input.getAttribute('name') || '');
        const match = raw.match(/properties\[(.+?)\]/i);
        return match ? match[1] : '';
      };

      const isNamesField = (labelText, input) => {
        if (isNamesProduct()) return true;
        const labelKey = normalizeKey(labelText);
        if (labelKey === 'name' || labelKey.includes('name')) return true;
        const propertyKey = normalizeKey(extractPropertyName(input));
        return propertyKey === 'name' || propertyKey.includes('name');
      };

      const normalizeNamesValue = (value) => {
        return String(value || '').trim();
      };

      const sanitizeNamesInputs = () => {
        inputs.forEach((input) => {
          if (input.type === 'file') return;
          const labelEl = wrapper.querySelector('label[for="' + input.id + '"]');
          const labelText = labelEl ? labelEl.textContent.replace('*', '').trim() : input.name;
          if (!isNamesField(labelText, input)) return;
          const normalized = normalizeNamesValue(input.value);
          if (normalized) {
            input.value = normalized;
          }
        });
      };

      const buildPrompt = () => {
        const lines = [];
        if (config.styleImageUrl) {
          lines.push('Use the provided style reference image to guide the visual style.');
        }
        if (config.prompt) {
          lines.push(String(config.prompt).trim());
        }

        const fieldLines = [];
        inputs.forEach((input) => {
          if (input.type === 'file') return;
          const labelEl = wrapper.querySelector('label[for="' + input.id + '"]');
          const labelText = labelEl ? labelEl.textContent.replace('*', '').trim() : input.name;
          let value = String(input.value || '').trim();
          if (!value) {
            if (!input.required) fieldLines.push(labelText + ': No customer text supplied. Omit this text from the portrait; do not copy any names or text from the reference image.');
            return;
          }
          if (isNamesField(labelText, input)) {
            value = normalizeNamesValue(value);
          }
          fieldLines.push(labelText + ': ' + value);
        });
        if (fieldLines.length) {
          lines.push('Personalisation details:\n' + fieldLines.join('\n'));
          lines.push('Reproduce supplied customer text exactly, preserving spelling, capitalisation and punctuation. Do not replace it with names or text from the reference image.');
        }

        if (!lines.length) {
          lines.push('Create a personalised print based on the provided style reference image.');
        }
        return lines.join('\n\n');
      };

      const getGenerationEndpoint = () => {
        const modelKey = (config.imageModel || 'gemini').toString().toLowerCase();
        if (modelKey === 'seedream') return '/apps/pop-prints-backend/seedream';
        if (modelKey === 'openai') return '/apps/pop-prints-backend/openai';
        return '/apps/pop-prints-backend/gemini';
      };
      const generationEndpointForModel = (model) => {
        const modelKey = String(model || 'gemini').toLowerCase();
        if (modelKey === 'seedream') return '/apps/pop-prints-backend/seedream';
        if (modelKey === 'openai') return '/apps/pop-prints-backend/openai';
        return '/apps/pop-prints-backend/gemini';
      };

      const PREVIEW_IMAGE_VARIANTS = Object.freeze({
        main: { maxWidth: 1600, minFontSize: 20 },
        styleCard: { maxWidth: 192, minFontSize: 10 },
        styleModal: { maxWidth: 960, minFontSize: 18 },
        styleWall: { maxWidth: 420, minFontSize: 12 },
      });

      const resolvePreviewVariant = (variant) => PREVIEW_IMAGE_VARIANTS[variant] || PREVIEW_IMAGE_VARIANTS.main;

      const buildShopifySizedUrl = (imageSrc, variant = 'main') => {
        const source = String(imageSrc || '').trim();
        if (!source || variant === 'main' || /^(data|blob):/i.test(source)) return source;

        const variantConfig = resolvePreviewVariant(variant);
        if (!variantConfig.maxWidth) return source;

        let parsedUrl = null;
        try {
          parsedUrl = new URL(source, window.location.origin);
        } catch (err) {
          return source;
        }

        const hostname = String(parsedUrl.hostname || '').toLowerCase();
        const pathname = String(parsedUrl.pathname || '');
        const isShopifyHost = /(^|\.)cdn\.shopify\.com$/i.test(hostname) || /(^|\.)pop-prints\.com$/i.test(hostname);
        const supportsWidthParam =
          /\/cdn\/shop\/(files|products)\//i.test(pathname) ||
          /\/s\/files\//i.test(pathname);

        if (!isShopifyHost || !supportsWidthParam) return source;

        parsedUrl.searchParams.set('width', String(variantConfig.maxWidth));
        return parsedUrl.toString();
      };

      const scalePreviewDimensions = (width, height, maxWidth) => {
        if (!width || !height || !maxWidth || width <= maxWidth) {
          return {
            width: Math.max(1, Math.round(width || 0)),
            height: Math.max(1, Math.round(height || 0)),
          };
        }

        const ratio = maxWidth / width;
        return {
          width: Math.max(1, Math.round(width * ratio)),
          height: Math.max(1, Math.round(height * ratio)),
        };
      };

      const syncCanvasFrameImage = (img, url) => {
        if (!(img instanceof HTMLImageElement)) return;
        const productMedia = img.closest('.product-media');
        const nextUrl = String(url || '').trim();
        if (!productMedia || !nextUrl) return;
        const value = 'url(' + JSON.stringify(nextUrl) + ')';
        if (productMedia.style.getPropertyValue('--frame-image-url') !== value) productMedia.style.setProperty('--frame-image-url', value);
      };

      const updateImageElement = (img, url, options = {}) => {
        if (!img) return false;
        const originalSource = String(options.originalSource || '').trim();
        const existingSource = String(
          img.getAttribute('data-current-source') ||
            img.getAttribute('data-original-src') ||
            img.getAttribute('data-max-resolution') ||
            img.getAttribute('data_max_resolution') ||
            img.currentSrc ||
            img.src ||
            ''
        ).trim();
        const stableSource =
          originalSource ||
          (/^(data|blob):/i.test(existingSource) ? '' : existingSource);
        const maxResolution = String(options.maxResolution || originalSource || url || '').trim();

        const attributes = { src: url, srcset: url + ' 1x', 'data_max_resolution': maxResolution || url, 'data-max-resolution': maxResolution || url };
        if (stableSource) Object.assign(attributes, { 'data-current-source': stableSource, 'data-original-src': stableSource });
        Object.entries(attributes).forEach(([name, value]) => {
          if (img.getAttribute(name) !== value) img.setAttribute(name, value);
        });
        syncCanvasFrameImage(img, url);
        return true;
      };

      const loadPreviewSourceImage = (imageSrc) => {
        const source = String(imageSrc || '').trim();
        if (!source) return Promise.resolve(null);

        if (previewSourceImageCache.has(source)) {
          return Promise.resolve(previewSourceImageCache.get(source));
        }

        if (previewSourceImageInflight.has(source)) {
          return previewSourceImageInflight.get(source);
        }

        const promise = new Promise((resolve) => {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.decoding = 'async';
          img.referrerPolicy = 'no-referrer';

          img.onload = () => {
            previewSourceImageCache.set(source, img);
            previewSourceImageInflight.delete(source);
            resolve(img);
          };

          img.onerror = () => {
            previewSourceImageInflight.delete(source);
            resolve(null);
          };

          img.src = source;
        });

        previewSourceImageInflight.set(source, promise);
        return promise;
      };

      const canvasToObjectUrl = (canvas) => {
        return new Promise((resolve) => {
          if (typeof canvas.toBlob !== 'function') {
            try {
              resolve(canvas.toDataURL('image/png'));
            } catch (err) {
              resolve('');
            }
            return;
          }

          canvas.toBlob(
            (blob) => {
              if (!blob) {
                resolve('');
                return;
              }

              const objectUrl = URL.createObjectURL(blob);
              previewWatermarkObjectUrls.add(objectUrl);
              resolve(objectUrl);
            },
            'image/png'
          );
        });
      };

      const applyWatermark = (canvas, imageSrc, variant = 'main') => {
        const source = String(imageSrc || '').trim();
        const variantConfig = resolvePreviewVariant(variant);
        if (!source) return Promise.resolve('');

        return loadPreviewSourceImage(source)
          .then((img) => {
            if (!(img instanceof HTMLImageElement)) return '';

            const ctx = canvas.getContext('2d');
            if (!ctx) return '';

            const sourceWidth = img.naturalWidth || img.width;
            const sourceHeight = img.naturalHeight || img.height;
            const scaled = scalePreviewDimensions(sourceWidth, sourceHeight, variantConfig.maxWidth);

            canvas.width = scaled.width;
            canvas.height = scaled.height;

            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            const fontSize = Math.max(canvas.width * 0.045, variantConfig.minFontSize || 12);
            ctx.font = '700 ' + fontSize + 'px sans-serif';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            ctx.save();
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(-30 * Math.PI / 180);

            const wmText = 'POP PRINTS      POP PRINTS      POP PRINTS';

            ctx.fillStyle = 'rgba(0, 0, 0, 0.10)';
            ctx.fillText(wmText, 1.5, 1.5);

            ctx.fillStyle = 'rgba(255, 255, 255, 0.30)';
            ctx.fillText(wmText, 0, 0);

            ctx.restore();

            return canvasToObjectUrl(canvas);
          })
          .catch(() => '');
      };

      const buildWatermarkedPreviewUrl = (imageSrc, variant = 'main') => {
        const source = String(imageSrc || '').trim();
        const cacheKey = variant + '::' + source;
        if (!source) return Promise.resolve('');
        if (previewWatermarkCache.has(cacheKey)) {
          return Promise.resolve(previewWatermarkCache.get(cacheKey));
        }
        if (previewWatermarkInflight.has(cacheKey)) {
          return previewWatermarkInflight.get(cacheKey);
        }

        const canvas = document.createElement('canvas');
        const promise = applyWatermark(canvas, source, variant)
          .then((watermarkedUrl) => {
            const resolved = watermarkedUrl || source;
            previewWatermarkCache.set(cacheKey, resolved);
            previewWatermarkInflight.delete(cacheKey);
            return resolved;
          })
          .catch(() => {
            previewWatermarkInflight.delete(cacheKey);
            return source;
          });

        previewWatermarkInflight.set(cacheKey, promise);
        return promise;
      };

      const updateMainImage = (url, options = {}) => {
        // Keep the watermark pipeline available for now, but disable it on the main hero image.
        const watermarked = false; // Boolean(options.watermarked) && shouldWatermarkImage(url);
        const currentWatermarkToken = ++activePreviewWatermarkToken;
        const scope = wrapper.closest('[data-testid="product-information"]') || document;
        const personalisedReady =
          scope instanceof Element && scope.classList.contains('personalisation-ready') && Boolean(url);
        const gallery = scope.querySelector('media-gallery');
        const targets = new Set();
        const addTarget = (img) => {
          if (img) targets.add(img);
        };
        let firstUpdated = null;

        if (gallery) {
          if (personalisedReady) {
            gallery.querySelectorAll('img.product-media__image').forEach((img) => addTarget(img));
          } else {
            let mediaId = null;
            const activeMedia = gallery.querySelector('slideshow-slide[aria-hidden="false"] .product-media[data-media-id]');
            if (activeMedia) mediaId = activeMedia.getAttribute('data-media-id');

            if (!mediaId) {
              const gridMedia = gallery.querySelector('.media-gallery__grid .product-media[data-media-id]');
              if (gridMedia) mediaId = gridMedia.getAttribute('data-media-id');
            }

            if (mediaId) {
              const selector = '.product-media[data-media-id="' + mediaId + '"] img.product-media__image';
              gallery.querySelectorAll(selector).forEach((img) => addTarget(img));
            } else {
              addTarget(gallery.querySelector('slideshow-slide[aria-hidden="false"] img.product-media__image'));
              addTarget(gallery.querySelector('.media-gallery__grid .product-media-container--image:first-child img.product-media__image'));
              gallery.querySelectorAll('.dialog-zoomed-gallery img.product-media__image').forEach((img) => addTarget(img));
            }
          }
        }

        if (!targets.size) {
          addTarget(scope.querySelector('img.product-media__image'));
        }

        if (personalisedReady) {
          const productSection = sectionRoot.closest('.shopify-section') || document;
          const stickyImage = productSection.querySelector(
            'sticky-add-to-cart[data-product-id="' + String(config.productId || '') + '"] img[ref="productImage"]'
          );
          if (stickyImage instanceof HTMLImageElement) {
            stickyImage.alt = 'Your portrait preview';
            addTarget(stickyImage);
          }
        }

        const targetList = Array.from(targets);
        firstUpdated = targetList[0] || null;
        primePreviewImageRenditions(url, { watermarked });

        if (watermarked && url) {
          void buildWatermarkedPreviewUrl(url, 'main').then((watermarkedUrl) => {
            if (!watermarkedUrl || currentWatermarkToken !== activePreviewWatermarkToken) return;
            targetList.forEach((img) => {
              updateImageElement(img, watermarkedUrl, {
                originalSource: url,
                maxResolution: url,
              });
            });
          });
        } else {
          targetList.forEach((img) => {
            if (
              updateImageElement(img, url, {
                originalSource: url,
                maxResolution: url,
              }) &&
              !firstUpdated
            ) {
              firstUpdated = img;
            }
          });
        }

        return firstUpdated;
      };

      let portraitFocusRequest = 0;
      const focusUpdatedImage = async (img) => {
        if (!img) return;
        const request = ++portraitFocusRequest;
        const revision = personalisationRevision;
        const interaction = new AbortController();
        const cancel = () => interaction.abort();
        ['pointerdown', 'wheel', 'touchmove', 'keydown'].forEach((eventName) => {
          window.addEventListener(eventName, cancel, { once: true, passive: true, signal: interaction.signal });
        });
        let decodeTimer;
        try {
          await window.PopPrintsPortraitReady?.whenSettled(sectionRoot);
          // The ready layout and its image settle before one deliberate move.
          // A new selection or customer interaction cancels a late focus request.
          if (typeof img.decode === 'function') {
            await Promise.race([
              img.decode().catch(() => {}),
              new Promise((resolve) => { decodeTimer = window.setTimeout(resolve, 1500); }),
            ]);
          }
          await new Promise((resolve) => window.requestAnimationFrame(() => window.requestAnimationFrame(resolve)));
          if (interaction.signal.aborted || request !== portraitFocusRequest || revision !== personalisationRevision ||
              !sectionRoot.isConnected || (progressEl && !progressEl.hidden)) return;
          const visibleImage = [...sectionRoot.querySelectorAll('.product-information__media img.product-media__image')]
            .find((candidate) => candidate.getClientRects().length && !candidate.closest('[hidden], [aria-hidden="true"]'));
          const target = visibleImage || (img.isConnected && img.getClientRects().length ? img : null);
          if (!target) return;
          target.setAttribute('tabindex', '-1');
          const header = document.querySelector('#header-component, header-component');
          const headerBottom = header ? Math.max(0, Math.min(window.innerHeight, header.getBoundingClientRect().bottom)) : 0;
          const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerBottom - 16);
          const scrollRoot = document.documentElement;
          const previousScrollBehavior = scrollRoot.style.scrollBehavior;
          scrollRoot.style.scrollBehavior = 'auto';
          window.scrollTo({ top, behavior: 'auto' });
          scrollRoot.style.scrollBehavior = previousScrollBehavior;
          try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
        } finally {
          window.clearTimeout(decodeTimer);
          interaction.abort();
        }
      };

      const isDebugMode = () => {
        const params = new URLSearchParams(window.location.search);
        const raw = params.get('personalisation_debug') ?? params.get('pp_debug');
        if (raw === null) return false;
        if (raw === '') return true;
        const normalized = String(raw).toLowerCase();
        return normalized === '1' || normalized === 'true' || normalized === 'yes';
      };

      const getForcedPersonalisationState = () => {
        const params = new URLSearchParams(window.location.search);
        const raw = params.get('personalisation_state') ?? params.get('pp_state');
        if (raw === null) return '';
        const normalized = String(raw).toLowerCase();
        if (normalized === 'after' || normalized === 'ready' || normalized === 'complete') return 'ready';
        if (normalized === 'before' || normalized === 'default' || normalized === 'locked') return 'before';
        return '';
      };

      const getForcedProgressOverlayState = () => {
        const params = new URLSearchParams(window.location.search);
        const raw = params.get('personalisation_overlay') ?? params.get('pp_overlay');
        if (raw === null) return '';
        const normalized = String(raw).toLowerCase();
        if (
          normalized === '' ||
          normalized === '1' ||
          normalized === 'true' ||
          normalized === 'yes' ||
          normalized === 'show' ||
          normalized === 'loading'
        ) {
          return 'loading';
        }
        if (normalized === 'ready' || normalized === 'complete') return 'ready';
        if (normalized === 'error' || normalized === 'failed' || normalized === 'retry') return 'error';
        return '';
      };

      const getForcedDiscountFlyoutState = () => {
        const params = new URLSearchParams(window.location.search);
        const raw = params.get('personalisation_discount') ?? params.get('pp_discount');
        if (raw === null) return '';
        if (raw === '') return 'form';
        const normalized = String(raw).toLowerCase();
        if (
          normalized === '1' ||
          normalized === 'true' ||
          normalized === 'yes' ||
          normalized === 'show' ||
          normalized === 'open' ||
          normalized === 'form'
        ) {
          return 'form';
        }
        if (normalized === 'success' || normalized === 'code' || normalized === 'claimed') {
          return 'success';
        }
        return '';
      };

      const setDescriptionText = (message) => {
        if (!message) return;
        removeDuplicateReviewMessages();
        const scope = wrapper.closest('[data-testid="product-information"]') || document;
        let descriptionBlock =
          scope.querySelector('.product-description-content') ||
          scope.querySelector('.text-block--text_aEtTtq') ||
          scope.querySelector('[data-block-id="text_aEtTtq"]');
        if (!descriptionBlock) {
          const sibling = wrapper.previousElementSibling;
          if (sibling && (sibling.matches('.text-block') || sibling.matches('rte-formatter'))) {
            descriptionBlock = sibling;
          }
        }
        if (!descriptionBlock) {
          descriptionBlock = scope.querySelector('.text-block.rte') || scope.querySelector('rte-formatter.text-block');
        }
        if (reviewMessageEl) {
          if (String(message).indexOf('<') !== -1) {
            reviewMessageEl.innerHTML = message;
          } else {
            reviewMessageEl.textContent = message;
          }
          reviewMessageEl.hidden = false;
        }
        removeDuplicateReviewMessages();
        if (!descriptionBlock) return;
        descriptionBlock.style.display = 'none';
        descriptionBlock.setAttribute('aria-hidden', 'true');
      };

      const buildReviewReadyMessage = () => {
        return (
            '<span class="personalisation-review-message__icon" aria-hidden="true">&#10003;</span>' +
            '<span class="personalisation-review-message__copy">' +
              '<strong>Your pet&rsquo;s portrait is ready to review</strong>' +
              '<span>Take your time and check every detail. You can request changes, <a class="personalisation-review-message__question-link" href="/pages/contact?enquiry=portrait-preview" data-personalisation-question-link>ask us a question</a>, or choose your size and finish when you&rsquo;re completely happy.</span>' +
            '</span>'
          );
      };

      const DISCOUNT_FLYOUT_CODE = 'POPPRINTS10';
      const DISCOUNT_FLYOUT_IDLE_MS = 60000;
      const DISCOUNT_FLYOUT_RETURNING_IDLE_MS = 25000;
      const DISCOUNT_FLYOUT_DISMISS_DAYS = 7;
      const DISCOUNT_FLYOUT_CLAIM_DAYS = 30;
      const forcedDiscountFlyoutState = getForcedDiscountFlyoutState();
      const DISCOUNT_FLYOUT_DISMISS_KEY = `popPrints.discountFlyout.dismissed.${String(config.productId || 'default')}`;
      const DISCOUNT_FLYOUT_CLAIM_KEY = `popPrints.discountFlyout.claimed.${String(config.productId || 'default')}`;
      let discountFlyoutTimer = null;
      let discountFlyoutVisible = false;
      let discountFlyoutFocusTimer = null;
      let discountFlyoutPreviousFocus = null;
      const discountFlyoutInertElements = new Set();
      let discountFlyoutSubmitted = false;
      let discountFlyoutAddToCartIntent = false;
      let discountFlyoutLastSource = 'generated';

      let cachedBase64 = null;
      let cachedMime = 'image/png';
      let cachedUploadBase64 = null;
      let cachedUploadMime = 'image/png';
      let cachedUploadSignature = '';
      const debugEnabled = isDebugMode();
      let generatedImageUrl = '';
      let activeGenerationRequestId = '';
      let awaitingPersistedPortrait = false;
      const SAVED_PORTRAITS_KEY = config.portraitShapesEnabled ? 'popPrints.savedPortraits.shapes-preview.v1' : 'popPrints.savedPortraits.v1';
      const CONTACT_PORTRAIT_STORAGE_KEY = 'popPrints.contactPortrait.v1';
      const SAVED_PORTRAIT_QUERY_KEY = 'pp_saved';
      const SAVED_PORTRAIT_URL_QUERY_KEY = 'pp_saved_url';
      const SHOPIFY_PORTRAIT_URL_QUERY_KEY = 'pp_shopify_image';
      const LANDING_PAGE_IMAGE_QUERY_KEY = 'pp_landing_image';
      const GENERATION_VISITOR_KEY = 'popPrints.generationVisitorId.v1';
      const MAX_DATA_URL_LENGTH = 200000;
      const previewWatermarkCache = new Map();
      const previewWatermarkInflight = new Map();
      const previewSourceImageCache = new Map();
      const previewSourceImageInflight = new Map();
      const previewWatermarkObjectUrls = new Set();
      let activePreviewWatermarkToken = 0;
      let requestedSavedPortraitApplied = false;

      window.addEventListener(
        'pagehide',
        () => {
          previewWatermarkObjectUrls.forEach((objectUrl) => {
            try {
              URL.revokeObjectURL(objectUrl);
            } catch (err) {}
          });
          previewWatermarkObjectUrls.clear();
        },
        { once: true }
      );

      const storeGeneratedImage = (url) => {
        if (!url || generatedImageUrl !== url) {
          try {
            delete wrapper.dataset.popArtReady;
            delete wrapper.dataset.popArtReadyTrackedId;
          } catch {}
        }
        if (generatedImageUrl !== url) checkoutArtworkSource = '';
        if (generatedImageUrl && generatedImageUrl !== url) {
          checkoutDesignId = '';
          checkoutDesignToken = '';
        }
        generatedImageUrl = url;
        wrapper.dataset.generatedImageUrl = url;
      };

      const getGeneratedImageUrl = () => {
        return generatedImageUrl || wrapper.dataset.generatedImageUrl || '';
      };

      const setAmendStatus = (message, variant) => {
        if (!amendStatusEl) return;
        amendStatusEl.textContent = message || '';
        amendStatusEl.classList.remove('is-error', 'is-success');
        if (variant === 'error') amendStatusEl.classList.add('is-error');
        if (variant === 'success') amendStatusEl.classList.add('is-success');
      };

      const getAmendSourceImageUrl = () => {
        const persistedPortraitUrl = String(outputInput?.value || '').trim();
        const generatedPortraitUrl = String(getGeneratedImageUrl() || '').trim();
        if (getPortraitShape() !== 'portrait' && !/^https:\/\/cdn\.shopify\.com\//i.test(persistedPortraitUrl)) return '';
        return persistedPortraitUrl || generatedPortraitUrl;
      };

      const setAmendExpanded = (isExpanded, { focusPrompt = false } = {}) => {
        if (!amendPanelEl) return;
        const expanded = Boolean(isExpanded);
        amendPanelEl.classList.toggle('is-expanded', expanded);
        if (amendToggleEl) amendToggleEl.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (amendBodyEl) amendBodyEl.hidden = !expanded;
        if (expanded && focusPrompt && amendPromptEl && typeof amendPromptEl.focus === 'function') {
          window.setTimeout(() => amendPromptEl.focus(), 0);
        }
      };

      const syncAmendPanelState = () => {
        if (!amendPanelEl) return;
        const canAmend = false;
        amendPanelEl.hidden = !canAmend;
        amendPanelEl.setAttribute('aria-hidden', canAmend ? 'false' : 'true');
        if (!canAmend) {
          setAmendStatus('', '');
          if (amendPromptEl) amendPromptEl.value = '';
          setAmendExpanded(false);
        }
      };

      const setAmendBusy = (isBusy) => {
        if (isBusy) setAmendExpanded(true);
        if (amendSubmitEl) {
          amendSubmitEl.disabled = Boolean(isBusy);
          amendSubmitEl.setAttribute('aria-disabled', isBusy ? 'true' : 'false');
          amendSubmitEl.textContent = isBusy ? 'Updating your portrait...' : 'Update my portrait';
        }
        if (amendPromptEl) amendPromptEl.disabled = Boolean(isBusy);
        wrapper.classList.toggle('is-amending', Boolean(isBusy));
      };

      const buildAmendPrompt = (instruction) => {
        const requestedChange = String(instruction || '').trim();
        return [
          'Edit the provided finished portrait image only.',
          'Keep the same subject identity, composition, crop, aspect ratio, painting style, and any existing names or text unless the requested change specifically says otherwise.',
          'Do not restart from the original photo. Use this returned portrait as the only image input.',
          'Requested change:\n' + requestedChange,
        ].join('\n\n');
      };

      const buildAmendFilename = (instruction) => {
        const baseName = config.productId ? 'amend-product-' + config.productId : 'amended-portrait';
        const changeSlug = String(instruction || '')
          .trim()
          .toLowerCase()
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/&/g, ' and ')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '')
          .slice(0, 70)
          .replace(/-+$/g, '');
        return changeSlug ? baseName + '-change-' + changeSlug : baseName;
      };

      const getCurrentPreviewEmailUrl = () => {
        const persistedPortraitUrl = String(outputInput?.value || '').trim();
        if (isPersistedPortraitValue(persistedPortraitUrl)) return persistedPortraitUrl;

        const generatedPortraitUrl = String(getGeneratedImageUrl() || '').trim();
        if (isPersistedPortraitValue(generatedPortraitUrl)) return generatedPortraitUrl;

        return '';
      };

      const fetchActiveGenerationStatusSnapshot = async () => {
        const requestId = String(activeGenerationRequestId || '').trim();
        if (!requestId) {
          return {
            status: '',
            url: '',
            b64: '',
            pendingUrl: false,
            originalUploadUrl: '',
            error: '',
          };
        }

        const statusResponse = await fetch(`/apps/pop-prints-backend/status/${requestId}`, {
          method: 'GET',
          headers: { Accept: 'application/json' },
        });
        const statusData = await statusResponse.json().catch(() => ({}));
        const statusUrl = statusData?.url || '';
        const statusB64 = statusData?.b64
          ? 'data:' + (statusData.mimeType || 'image/png') + ';base64,' + statusData.b64
          : '';

        return {
          status: statusData?.status || '',
          accepted: statusData?.accepted,
          retryable: statusData?.retryable,
          code: statusData?.code || '',
          url: statusUrl,
          b64: statusB64,
          pendingUrl: Boolean(statusData?.pendingUrl || statusData?.status === 'uploading'),
          originalUploadUrl: statusData?.originalUploadUrl || '',
          error: statusData?.error || '',
        };
      };

      const setPortraitOutputValue = (value) => {
        const normalizedValue = (value || '').toString();
        const syncInputValue = (input, nextValue) => {
          if (!input) return;
          input.value = nextValue;
          input.dispatchEvent(
            new Event('input', {
              bubbles: true,
            })
          );
          input.dispatchEvent(
            new Event('change', {
              bubbles: true,
            })
          );
        };

        syncInputValue(outputInput, normalizedValue);
        syncInputValue(fulfillmentOutputInput, normalizedValue);
      };

      const syncPersistedPortraitOutputFromState = () => {
        if (!hasCurrentPortraitDetails()) return false;
        const currentValue = String(outputInput?.value || '').trim();
        if (isPersistedPortraitValue(currentValue)) {
          if (fulfillmentOutputInput) fulfillmentOutputInput.value = currentValue;
          return true;
        }

        const generatedPortraitUrl = String(getGeneratedImageUrl() || '').trim();
        if (!isPersistedPortraitValue(generatedPortraitUrl)) return false;

        setPortraitOutputValue(generatedPortraitUrl);
        clearCartValidationError();
        return true;
      };

      let readinessNotificationIndex = 0;
      const notifyDeliveryEstimateRefresh = (source, portraitUrl) => {
        const detail = {
          source: source || 'unknown',
          productId: String(config.productId || ''),
          portraitUrl: (portraitUrl || outputInput?.value || '').toString(),
        };
        // A saved portrait can become ready before the page's tracking listener loads.
        // Keep only this block's current notification; live listeners still receive it.
        try {
          delete wrapper.dataset.popArtReady;
          delete wrapper.dataset.popArtReadyTrackedId;
          if (typeof detail.source === 'string' && detail.source.length <= 80 &&
              /^[0-9]{1,24}$/.test(detail.productId) && detail.portraitUrl.length > 0 && detail.portraitUrl.length <= 4000 &&
              ['http:', 'https:'].includes(new URL(detail.portraitUrl).protocol)) {
            const readyEventId = `ready_${createGenerationVisitorId()}_${++readinessNotificationIndex}`;
            const marker = JSON.stringify({ version: 1, readyEventId, ...detail });
            if (marker.length <= 9000) {
              wrapper.dataset.popArtReady = marker;
              detail.readyEventId = readyEventId;
            }
          }
        } catch {}
        wrapper.dispatchEvent(
          new CustomEvent('personalisation:art-ready', {
            bubbles: true,
            detail,
          })
        );
      };

      const getStorage = () => {
        try {
          return window.localStorage || null;
        } catch (err) {
          return null;
        }
      };

      const createGenerationVisitorId = () => {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') {
          return window.crypto.randomUUID();
        }
        return 'pp-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      };

      let cachedGenerationVisitorId = '';
      const getGenerationVisitorId = () => {
        if (cachedGenerationVisitorId) return cachedGenerationVisitorId;

        const storage = getStorage();
        if (storage) {
          try {
            const existing = String(storage.getItem(GENERATION_VISITOR_KEY) || '').trim();
            if (existing) {
              cachedGenerationVisitorId = existing;
              return cachedGenerationVisitorId;
            }
          } catch (err) {
            if (debugEnabled && console && console.warn) {
              console.warn('[personalisation] visitor id read failed', err);
            }
          }
        }

        cachedGenerationVisitorId = createGenerationVisitorId();
        if (storage) {
          try {
            storage.setItem(GENERATION_VISITOR_KEY, cachedGenerationVisitorId);
          } catch (err) {
            if (debugEnabled && console && console.warn) {
              console.warn('[personalisation] visitor id write failed', err);
            }
          }
        }
        return cachedGenerationVisitorId;
      };

      const isDiscountFlyoutMobileViewport = () => {
        if (typeof window.matchMedia !== 'function') return false;
        return window.matchMedia('(max-width: 768px)').matches;
      };

      const readStorageTimestamp = (key) => {
        const storage = getStorage();
        if (!storage) return 0;
        try {
          const value = Number.parseInt(String(storage.getItem(key) || ''), 10);
          return Number.isFinite(value) ? value : 0;
        } catch (err) {
          return 0;
        }
      };

      const writeStorageTimestamp = (key, timestamp = Date.now()) => {
        const storage = getStorage();
        if (!storage) return;
        try {
          storage.setItem(key, String(timestamp));
        } catch (err) {}
      };

      const hasRecentDiscountFlyoutTimestamp = (key, days) => {
        const timestamp = readStorageTimestamp(key);
        if (!timestamp) return false;
        return Date.now() - timestamp < days * 24 * 60 * 60 * 1000;
      };

      const clearDiscountFlyoutTimer = () => {
        if (discountFlyoutTimer) {
          window.clearTimeout(discountFlyoutTimer);
          discountFlyoutTimer = null;
        }
      };

      const hasSavedPortraitSession = () => {
        const params = getRequestedSavedPortraitParams();
        return Boolean(requestedSavedPortraitApplied || params.cacheId || params.portraitUrl);
      };

      const shouldSuppressDiscountFlyout = () => {
        // The 10% email offer is enabled independently of the retired automatic sale.
        if (forcedDiscountFlyoutState) return false;
        return (
          window.PopFlashSale?.isActive() ||
          !discountFlyoutEl ||
          !isDiscountFlyoutMobileViewport() ||
          !hasRealCustomerPortraitLoaded() ||
          discountFlyoutAddToCartIntent ||
          discountFlyoutSubmitted ||
          hasRecentDiscountFlyoutTimestamp(DISCOUNT_FLYOUT_DISMISS_KEY, DISCOUNT_FLYOUT_DISMISS_DAYS) ||
          hasRecentDiscountFlyoutTimestamp(DISCOUNT_FLYOUT_CLAIM_KEY, DISCOUNT_FLYOUT_CLAIM_DAYS)
        );
      };

      const resetDiscountFlyoutPresentation = () => {
        if (!discountFlyoutEl) return;
        if (discountFlyoutCodeEl) {
          discountFlyoutCodeEl.textContent = DISCOUNT_FLYOUT_CODE;
        }
        if (discountFlyoutFormEl) {
          discountFlyoutFormEl.hidden = false;
        }
        if (discountFlyoutSuccessEl) {
          discountFlyoutSuccessEl.hidden = true;
        }
        if (discountFlyoutEmailEl) {
          discountFlyoutEmailEl.setAttribute('aria-invalid', 'false');
        }
        if (discountFlyoutHintEl) {
          discountFlyoutHintEl.textContent = '';
          discountFlyoutHintEl.hidden = true;
        }
        if (discountFlyoutCopyEl) {
          discountFlyoutCopyEl.textContent = 'Copy code';
        }
        if (forcedDiscountFlyoutState === 'success') {
          if (discountFlyoutFormEl) {
            discountFlyoutFormEl.hidden = true;
          }
          if (discountFlyoutSuccessEl) {
            discountFlyoutSuccessEl.hidden = false;
          }
        }
      };

      const discountFlyoutFocusable = () => [...discountFlyoutEl.querySelectorAll(
        'button, input, select, textarea, a[href], [tabindex]'
      )].filter((element) => !element.disabled && element.tabIndex >= 0 &&
        !element.closest('[hidden], [inert]') && element.getClientRects().length);

      const focusDiscountFlyout = () => {
        if (!discountFlyoutVisible) return;
        const controls = discountFlyoutFocusable();
        const target = controls.includes(discountFlyoutEmailEl) ? discountFlyoutEmailEl : controls[0];
        target?.focus({ preventScroll: true });
      };

      const containDiscountFlyoutFocus = (event) => {
        if (discountFlyoutVisible && !discountFlyoutEl.contains(event.target)) focusDiscountFlyout();
      };

      const discountFlyoutKeyboard = (event) => {
        if (!discountFlyoutVisible) return;
        if (event.key === 'Escape') {
          event.preventDefault(); event.stopImmediatePropagation(); closeDiscountFlyout();
        } else if (event.key === 'Tab') {
          const controls = discountFlyoutFocusable();
          const index = controls.indexOf(document.activeElement);
          if (!controls.length) { event.preventDefault(); return; }
          if (event.shiftKey && index <= 0) {
            event.preventDefault(); controls[controls.length - 1].focus();
          } else if (!event.shiftKey && (index < 0 || index === controls.length - 1)) {
            event.preventDefault(); controls[0].focus();
          }
        }
      };

      const closeDiscountFlyout = ({ persistDismissal = true } = {}) => {
        clearDiscountFlyoutTimer();
        window.clearTimeout(discountFlyoutFocusTimer);
        if (!discountFlyoutEl) return;
        const wasVisible = discountFlyoutVisible;
        discountFlyoutVisible = false;
        discountFlyoutEl.hidden = true;
        discountFlyoutEl.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('personalisation-discount-flyout-open');
        document.removeEventListener('keydown', discountFlyoutKeyboard, true);
        document.removeEventListener('focusin', containDiscountFlyoutFocus, true);
        for (const element of discountFlyoutInertElements) element.inert = false;
        discountFlyoutInertElements.clear();
        if (wasVisible && discountFlyoutPreviousFocus?.isConnected && !discountFlyoutPreviousFocus.closest('[inert], [hidden]')) {
          discountFlyoutPreviousFocus.focus({ preventScroll: true });
        }
        discountFlyoutPreviousFocus = null;
        if (persistDismissal && !discountFlyoutSubmitted && !forcedDiscountFlyoutState) {
          writeStorageTimestamp(DISCOUNT_FLYOUT_DISMISS_KEY);
        }
      };

      const openDiscountFlyout = () => {
        clearDiscountFlyoutTimer();
        if (!forcedDiscountFlyoutState && shouldSuppressDiscountFlyout()) return;
        if (!discountFlyoutEl) return;
        if (discountFlyoutVisible) return;

        resetDiscountFlyoutPresentation();
        discountFlyoutPreviousFocus = document.activeElement;
        discountFlyoutVisible = true;
        discountFlyoutEl.hidden = false;
        discountFlyoutEl.setAttribute('aria-hidden', 'false');
        document.body.classList.add('personalisation-discount-flyout-open');
        for (let branch = discountFlyoutEl; branch && branch !== document.body; branch = branch.parentElement) {
          for (const sibling of branch.parentElement?.children || []) {
            if (sibling !== branch && !sibling.inert) {
              sibling.inert = true;
              discountFlyoutInertElements.add(sibling);
            }
          }
        }
        document.addEventListener('keydown', discountFlyoutKeyboard, true);
        document.addEventListener('focusin', containDiscountFlyoutFocus, true);
        discountFlyoutFocusTimer = window.setTimeout(focusDiscountFlyout, 30);
      };

      const scheduleDiscountFlyout = (source = 'generated') => {
        discountFlyoutLastSource = source || discountFlyoutLastSource || 'generated';
        clearDiscountFlyoutTimer();
        if (shouldSuppressDiscountFlyout() || discountFlyoutVisible) return;
        const isReturningPreview = discountFlyoutLastSource !== 'generated' || hasSavedPortraitSession();
        const delay = isReturningPreview ? DISCOUNT_FLYOUT_RETURNING_IDLE_MS : DISCOUNT_FLYOUT_IDLE_MS;
        discountFlyoutTimer = window.setTimeout(() => {
          openDiscountFlyout();
        }, delay);
      };

      const noteDiscountFlyoutActivity = () => {
        if (discountFlyoutVisible || shouldSuppressDiscountFlyout()) return;
        scheduleDiscountFlyout(discountFlyoutLastSource || 'generated');
      };

      const normalizeComparableUrl = (value) => {
        const raw = String(value || '').trim();
        if (!raw) return '';
        if (/^data:/i.test(raw)) {
          return raw.slice(0, 96);
        }
        try {
          const parsed = new URL(raw, window.location.origin);
          return (parsed.origin + parsed.pathname).replace(/\/+$/, '').toLowerCase();
        } catch (err) {
          return raw.toLowerCase();
        }
      };

      const stockPortraitUrlSet = new Set();
      const addStockPortraitUrl = (value) => {
        const normalized = normalizeComparableUrl(value);
        if (normalized) {
          stockPortraitUrlSet.add(normalized);
        }
      };

      const isConfiguredStockPortraitUrl = (value) => {
        const normalized = normalizeComparableUrl(value);
        if (!normalized) return false;

        return [
          config.baseImageUrl,
          config.styleImageUrl,
          config.howItWorksBeforeUrl,
          config.howItWorksAfterUrl,
        ]
          .map((candidate) => normalizeComparableUrl(candidate))
          .filter(Boolean)
          .includes(normalized);
      };

      const getActivePersonalisedPortraitUrlSet = () => {
        const urls = new Set();
        const add = (value) => {
          const normalized = normalizeComparableUrl(value);
          if (!normalized || isConfiguredStockPortraitUrl(normalized)) return;
          urls.add(normalized);
        };

        add(outputInput?.value || '');
        add(getGeneratedImageUrl());
        add(wrapper.dataset.generatedImageUrl || '');
        add(sectionRoot.querySelector('[data-personalisation-block]')?.getAttribute('data-generated-image-url') || '');

        const displayedImage =
          sectionRoot.querySelector('slideshow-slide[aria-hidden="false"] img.product-media__image') ||
          sectionRoot.querySelector('.media-gallery__grid .product-media-container--image:first-child img.product-media__image') ||
          sectionRoot.querySelector('img.product-media__image');

        if (displayedImage instanceof HTMLImageElement) {
          add(displayedImage.getAttribute('data-current-source') || '');
          add(displayedImage.getAttribute('data-original-src') || '');
          add(displayedImage.getAttribute('data-max-resolution') || '');
          add(displayedImage.getAttribute('data_max_resolution') || '');
        }

        return urls;
      };

      const isActivePersonalisedPortraitUrl = (value) => {
        const normalized = normalizeComparableUrl(value);
        if (!normalized) return false;
        return getActivePersonalisedPortraitUrlSet().has(normalized);
      };

      const getOriginalImageSource = (img) => {
        if (!img) return '';

        const candidates = [
          img.getAttribute('data-current-source'),
          img.dataset ? img.dataset.currentSource : '',
          img.getAttribute('data-original-src'),
          img.getAttribute('data-max-resolution'),
          img.getAttribute('data_max_resolution'),
          img.currentSrc,
          img.src,
        ];

        for (const candidate of candidates) {
          const value = String(candidate || '').trim();
          if (!value || value.startsWith('data:image/')) continue;
          return value;
        }

        return '';
      };

      const captureStockPortraitUrls = () => {
        portraitStyleChoices.forEach((choice) => addStockPortraitUrl(choice.imageUrl));
        addStockPortraitUrl(config.baseImageUrl);
        addStockPortraitUrl(config.styleImageUrl);
        addStockPortraitUrl(config.howItWorksBeforeUrl);
        addStockPortraitUrl(config.howItWorksAfterUrl);
        sectionRoot.querySelectorAll('img.product-media__image').forEach((img) => {
          const source = getOriginalImageSource(img);
          if (isActivePersonalisedPortraitUrl(source)) return;
          addStockPortraitUrl(source);
        });
      };

      const shouldWatermarkImage = (url) => {
        // Keep the watermark helper in place for now, but disable all preview watermarking.
        return false;
      };

      const buildPreviewImageUrl = (imageSrc, options = {}) => {
        const source = String(imageSrc || '').trim();
        const variant = String(options.variant || 'main');
        if (!source) return Promise.resolve('');

        // Watermark rendering is temporarily disabled across style cards, selected-style preview, and wall mockups.
        // if (Boolean(options.watermarked) && shouldWatermarkImage(source)) {
        //   return buildWatermarkedPreviewUrl(source, variant);
        // }

        return Promise.resolve(buildShopifySizedUrl(source, variant));
      };

      const primePreviewImageRenditions = (imageSrc, options = {}) => {
        const source = String(imageSrc || '').trim();
        if (!source) return;

        ['styleCard', 'styleModal', 'styleWall'].forEach((variant) => {
          void buildPreviewImageUrl(source, {
            variant,
            watermarked: Boolean(options.watermarked),
          });
        });
      };

      window.PopPrintsPreviewImageService = {
        buildUrl: buildPreviewImageUrl,
        prime: primePreviewImageRenditions,
        shouldWatermark: shouldWatermarkImage,
      };

      document.dispatchEvent(new CustomEvent('pop:preview-image-service-ready'));

      const createDigitalDownloadKey = () => {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') {
          return window.crypto.randomUUID();
        }
        return 'pp-digital-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      };

      const ensureDigitalDownloadKey = () => {
        if (!digitalDownloadKey) {
          digitalDownloadKey = createDigitalDownloadKey();
        }
        return digitalDownloadKey;
      };

      const dispatchSyntheticInputEvents = (input) => {
        if (!input) return;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };

      const hasRealCustomerPortraitLoaded = () => {
        const portraitValue = String(outputInput?.value || '').trim();
        const candidate = portraitValue || String(getGeneratedImageUrl() || '').trim();
        if (!candidate) return false;
        const normalized = normalizeComparableUrl(candidate);
        if (!normalized) return false;
        return !stockPortraitUrlSet.has(normalized);
      };

      const ensureDigitalDownloadPlacement = () => {
        if (!digitalDownloadUpsell || !sectionRoot) return;
        const buyButtonsBlock = sectionRoot.querySelector('.buy-buttons-block');
        if (!buyButtonsBlock || !buyButtonsBlock.parentNode) return;
        if (digitalDownloadUpsell.parentNode !== buyButtonsBlock.parentNode || digitalDownloadUpsell.nextElementSibling !== buyButtonsBlock) {
          buyButtonsBlock.parentNode.insertBefore(digitalDownloadUpsell, buyButtonsBlock);
        }
      };

      const renderDigitalDownloadSelection = () => {
        if (!digitalDownloadToggle) return;
        digitalDownloadToggle.classList.toggle('is-selected', digitalDownloadSelected);
        digitalDownloadToggle.setAttribute('aria-pressed', digitalDownloadSelected ? 'true' : 'false');
      };

      const syncDigitalDownloadInputs = () => {
        const labelValue = digitalDownloadSelected ? 'Yes' : '';
        const keyValue = digitalDownloadSelected ? ensureDigitalDownloadKey() : '';

        if (!digitalDownloadSelected) {
          digitalDownloadKey = '';
        }

        if (digitalDownloadLabelInput && digitalDownloadLabelInput.value !== labelValue) {
          digitalDownloadLabelInput.value = labelValue;
          dispatchSyntheticInputEvents(digitalDownloadLabelInput);
        }

        if (digitalDownloadKeyInput && digitalDownloadKeyInput.value !== keyValue) {
          digitalDownloadKeyInput.value = keyValue;
          dispatchSyntheticInputEvents(digitalDownloadKeyInput);
        }
      };

      const syncDigitalDownloadUpsell = ({ resetSelection = false } = {}) => {
        if (!digitalDownloadEnabled || !digitalDownloadUpsell) return;

        ensureDigitalDownloadPlacement();
        const shouldShow = hasRealCustomerPortraitLoaded();

        if (!shouldShow && resetSelection) {
          digitalDownloadSelected = false;
          digitalDownloadKey = '';
        }

        digitalDownloadUpsell.hidden = !shouldShow;
        digitalDownloadUpsell.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        renderDigitalDownloadSelection();
        syncDigitalDownloadInputs();
      };

      const isDataUrl = (value) => /^data:/i.test(String(value || ''));
      const isPersistedPortraitValue = (value) => {
        const normalized = String(value || '').trim();
        return Boolean(normalized) && !isDataUrl(normalized);
      };
      const shouldSkipStorage = (value) => isDataUrl(value) && String(value || '').length > MAX_DATA_URL_LENGTH;
      const setPersistedPortraitPending = (isPending) => {
        awaitingPersistedPortrait = Boolean(isPending);
        sectionRoot.classList.toggle('personalisation-persisting', awaitingPersistedPortrait);
      };

      const tryResolvePortraitForCheckout = async (timeoutMs = 12000) => {
        if (!hasCurrentPortraitDetails()) return false;
        if (hasPersistedPortraitUrl()) return true;
        if (!hasDisplayPortraitReady()) return false;

        const requestId = String(activeGenerationRequestId || '').trim();
        if (!requestId) return false;
        const operation = activePersonalisationOperation;
        if (!isCurrentPersonalisationOperation(operation)) return false;

        const previewImageUrl = String(getGeneratedImageUrl() || '').trim();
        const startedAt = Date.now();
        setPersistedPortraitPending(true);
        setStatus('Finalising your portrait for checkout...', '');

        while (Date.now() - startedAt < timeoutMs && isCurrentPersonalisationOperation(operation)) {
          try {
            const snapshot = await fetchGenerationStatusSnapshotById(requestId, operation);
            if (!isCurrentPersonalisationOperation(operation)) return false;
            if (snapshot.portraitShapeRejected) {
              invalidatePortraitForInputChange({ force: true, message: snapshot.error });
              return false;
            }
            if (snapshot.originalUploadUrl) {
              setOriginalUploadOutputValue(snapshot.originalUploadUrl);
            }
            if (snapshot.url && applyPersistedPortraitResult(snapshot.url, previewImageUrl, requestId, operation)) {
              return true;
            }
            if (snapshot.url && syncPersistedPortraitOutputFromState()) {
              setPersistedPortraitPending(false);
              setStatus('Your portrait is ready. Choose your finish and size.', 'success');
              return true;
            }
            if (snapshot.status === 'error' && snapshot.error) {
              break;
            }
          } catch (err) {
            // Retry briefly before failing.
          }
          await new Promise((resolve) => setTimeout(resolve, 1500));
        }

        if (!isCurrentPersonalisationOperation(operation)) return false;
        if (syncPersistedPortraitOutputFromState()) {
          setPersistedPortraitPending(false);
          setStatus('Your portrait is ready. Choose your finish and size.', 'success');
          return true;
        }

        setPersistedPortraitPending(false);
        setStatus('Your preview is still being finalised. Please wait a moment and try again.', 'error');
        return false;
      };

      const isShareableContactPortraitUrl = (value) => {
        try {
          const raw = String(value || '').trim();
          if (!raw) return false;
          const parsed = new URL(raw, window.location.origin);
          return parsed.protocol === 'https:' || parsed.protocol === 'http:';
        } catch (err) {
          return false;
        }
      };

      const storeContactPortraitContext = (portraitUrl) => {
        const productHeading =
          sectionRoot.querySelector('.pop-pdp-title') ||
          sectionRoot.querySelector('h1') ||
          document.querySelector('h1');
        const productPage = new URL(window.location.href);
        ['cb', 'personalisation_debug', 'pp_debug', 'personalisation_state', 'pp_state'].forEach((key) => {
          productPage.searchParams.delete(key);
        });
        const context = {
          version: 1,
          portraitUrl,
          productTitle: String(productHeading?.textContent || document.title || '').trim(),
          productUrl: productPage.toString(),
          productId: String(config.productId || ''),
          createdAt: new Date().toISOString(),
        };

        try {
          window.sessionStorage.setItem(CONTACT_PORTRAIT_STORAGE_KEY, JSON.stringify(context));
          return true;
        } catch (err) {
          return false;
        }
      };

      let portraitQuestionNavigationInProgress = false;
      const openPortraitQuestion = async (link) => {
        if (portraitQuestionNavigationInProgress) return;
        portraitQuestionNavigationInProgress = true;
        link.setAttribute('aria-busy', 'true');

        let portraitUrl = String(getCurrentPreviewEmailUrl() || '').trim();
        if (!isShareableContactPortraitUrl(portraitUrl)) {
          setStatus('Attaching your portrait to the question...', '');
          await tryResolvePortraitForCheckout(15000);
          portraitUrl = String(getCurrentPreviewEmailUrl() || '').trim();
        }

        if (!isShareableContactPortraitUrl(portraitUrl)) {
          portraitQuestionNavigationInProgress = false;
          link.removeAttribute('aria-busy');
          setStatus('Your portrait is still saving. Please wait a moment, then ask your question again.', 'error');
          return;
        }

        const contactUrl = new URL('/pages/contact', window.location.origin);
        contactUrl.searchParams.set('enquiry', 'portrait-preview');
        if (!storeContactPortraitContext(portraitUrl)) {
          portraitQuestionNavigationInProgress = false;
          link.removeAttribute('aria-busy');
          setStatus('We could not attach your portrait just now. Please try asking your question again.', 'error');
          return;
        }
        window.location.assign(contactUrl.toString());
      };

      const readSavedPortraits = () => {
        const storage = getStorage();
        if (!storage) return [];
        const read = (key) => {
          try {
            const parsed = JSON.parse(storage.getItem(key) || '[]');
            return Array.isArray(parsed) ? parsed.filter((entry) => entry && typeof entry.url === 'string') : [];
          } catch (err) {
            if (debugEnabled && console && console.warn) console.warn('[personalisation] saved portraits read failed', err);
            return [];
          }
        };
        const entries = read(SAVED_PORTRAITS_KEY);
        if (!config.portraitShapesEnabled) return entries;
        const legacy = read('popPrints.savedPortraits.v1');
        return [...legacy.filter((entry) => (!entry.portraitShape || entry.portraitShape === 'portrait') &&
          !entries.some((item) => item.url === entry.url)), ...entries];
      };

      const writeSavedPortraits = (entries) => {
        const storage = getStorage();
        if (!storage) return;
        try {
          storage.setItem(SAVED_PORTRAITS_KEY, JSON.stringify(entries || []));
          document.dispatchEvent(new CustomEvent('pop:saved-portraits-change'));
        } catch (err) {
          if (debugEnabled && console && console.warn) {
            console.warn('[personalisation] saved portraits write failed', err);
          }
        }
      };

      const normalizeSavedPortraitCacheId = (value) => String(value || '').trim();

      const isAllowedShopifySeededPortraitUrl = (value) => {
        const raw = String(value || '').trim();
        if (!raw) return false;
        try {
          const parsed = new URL(raw, window.location.origin);
          const hostname = String(parsed.hostname || '').toLowerCase();
          const pathname = String(parsed.pathname || '');
          const currentHostname = String(window.location.hostname || '').toLowerCase();
          const isCurrentStoreCdn = hostname === currentHostname && pathname.startsWith('/cdn/');
          const isShopifyCdn =
            hostname === 'cdn.shopify.com' ||
            hostname.endsWith('.shopifycdn.net') ||
            hostname.endsWith('.myshopify.com');
          const looksLikeShopifyImage =
            pathname.startsWith('/cdn/') ||
            pathname.includes('/files/') ||
            pathname.includes('/products/') ||
            /\.(avif|gif|jpe?g|png|webp)(?:$|\?)/i.test(pathname);
          return Boolean((isCurrentStoreCdn || isShopifyCdn) && looksLikeShopifyImage);
        } catch (err) {
          return false;
        }
      };

      const normalizeShopifySeededPortraitFilename = (value) => {
        const raw = String(value || '').trim();
        if (!raw) return '';
        try {
          const decoded = decodeURIComponent(raw).trim();
          const withoutQuery = decoded.split('#')[0].split('?')[0].trim();
          if (!withoutQuery) return '';
          if (/[\/\\]/.test(withoutQuery)) return '';
          if (!/\.(avif|gif|jpe?g|png|webp)$/i.test(withoutQuery)) return '';
          return withoutQuery.slice(0, 220);
        } catch (err) {
          const withoutQuery = raw.split('#')[0].split('?')[0].trim();
          if (!withoutQuery) return '';
          if (/[\/\\]/.test(withoutQuery)) return '';
          if (!/\.(avif|gif|jpe?g|png|webp)$/i.test(withoutQuery)) return '';
          return withoutQuery.slice(0, 220);
        }
      };

      const resolveShopifySeededPortraitUrl = (value) => {
        const raw = String(value || '').trim();
        if (!raw) return '';
        if (isAllowedShopifySeededPortraitUrl(raw)) return raw;
        const filename = normalizeShopifySeededPortraitFilename(raw);
        if (!filename) return '';
        try {
          return new URL(`/cdn/shop/files/${encodeURIComponent(filename)}`, window.location.origin).toString();
        } catch (err) {
          return '';
        }
      };

      const normalizeLandingPageImageKey = (value) => {
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      };

      const resolveLandingPagePortraitUrl = (value) => {
        const requestedKey = normalizeLandingPageImageKey(value);
        if (!requestedKey) return '';
        const entries = Array.isArray(config.landingPageImages) ? config.landingPageImages : [];
        for (const entry of entries) {
          const entryKey = normalizeLandingPageImageKey(entry && entry.key);
          if (!entryKey || entryKey !== requestedKey) continue;
          const resolvedUrl = resolveShopifySeededPortraitUrl(entry && entry.imageUrl);
          if (resolvedUrl) return resolvedUrl;
        }
        return '';
      };

      const getRequestedSavedPortraitParams = () => {
        const params = new URLSearchParams(window.location.search);
        const savedPortraitUrl = String(params.get(SAVED_PORTRAIT_URL_QUERY_KEY) || '').trim();
        const shopifyPortraitUrl = String(params.get(SHOPIFY_PORTRAIT_URL_QUERY_KEY) || '').trim();
        const landingPageImageKey = String(params.get(LANDING_PAGE_IMAGE_QUERY_KEY) || '').trim();
        const seededShopifyPortraitUrl = resolveShopifySeededPortraitUrl(shopifyPortraitUrl);
        const landingPagePortraitUrl = resolveLandingPagePortraitUrl(landingPageImageKey);
        const portraitUrl = savedPortraitUrl || seededShopifyPortraitUrl || landingPagePortraitUrl;
        const isShopifyLinkedPortrait = !savedPortraitUrl && Boolean(seededShopifyPortraitUrl);
        const isLandingPageLinkedPortrait = !savedPortraitUrl && !seededShopifyPortraitUrl && Boolean(landingPagePortraitUrl);
        return {
          cacheId: normalizeSavedPortraitCacheId(params.get(SAVED_PORTRAIT_QUERY_KEY) || ''),
          designId: String(params.get('pp_design_id') || '').trim(),
          designToken: String(params.get('pp_design_token') || '').trim(),
          portraitShape: ['square', 'horizontal'].includes(params.get('portrait_shape')) ? params.get('portrait_shape') : 'portrait',
          portraitUrl,
          displayOnly: isLandingPageLinkedPortrait,
          source: isLandingPageLinkedPortrait
            ? 'landing-page-image'
            : isShopifyLinkedPortrait
              ? 'shopify-linked-portrait'
              : 'emailed-preview',
          statusMessage: isLandingPageLinkedPortrait
            ? 'Loaded your landing page portrait. Choose size and add to cart.'
            : isShopifyLinkedPortrait
              ? 'Loaded your linked portrait. Choose size and add to cart.'
              : 'Loaded your emailed portrait. Choose size and add to cart.',
        };
      };

      const applyLandingPagePortraitContext = (portraitUrl) => {
        const url = String(portraitUrl || '').trim();
        if (!url) return null;
        invalidatePortraitForInputChange();
        activeGenerationRequestId = '';
        setPersistedPortraitPending(false);
        wrapper.classList.remove('personalisation-complete');
        sectionRoot.classList.remove('personalisation-ready');
        sectionRoot.classList.add('personalisation-locked');
        storeGeneratedImage('');
        setPortraitOutputValue('');
        clearCartValidationError();
        setStatus('', '');
        syncAmendPanelState();
        if (button) button.textContent = config.referenceLayout === true ? 'Create Print' : 'Preview My Portrait';
        syncDigitalDownloadUpsell({ resetSelection: true });
        return updateMainImage(url, { watermarked: true });
      };

      const findSavedPortraitEntryByCacheId = (entries, cacheId) => {
        const normalizedCacheId = normalizeSavedPortraitCacheId(cacheId);
        if (!normalizedCacheId || !Array.isArray(entries)) return null;
        return entries.find((entry) => normalizeSavedPortraitCacheId(entry?.cacheId || '') === normalizedCacheId) || null;
      };

      const applySavedPortraitEntry = (entry, { source = 'saved-image', statusMessage = 'Loaded your saved portrait. Choose a size and add to cart.', focus = true, preserveProgressOverlay = false } = {}) => {
        const displayUrl = String(entry?.previewUrl || entry?.url || '').trim();
        const portraitUrl = String(entry?.url || displayUrl || '').trim();
        const url = portraitUrl || displayUrl;
        if (!url) return null;

        if (selectedPortraitStyle) {
          const savedStyleId = styleIdForDetails(entry?.personalisation);
          const savedChoice = portraitStyleChoices.find((choice) => choice.id === savedStyleId);
          if (!savedChoice) {
            setStatus('This saved portrait uses another style. Open it from your saved portraits to continue.', 'error');
            return null;
          }
          configurePortraitStyle(savedChoice);
        }
        invalidatePortraitForInputChange({ preserveProgressOverlay });
        const savedShape = entry?.personalisation?.portraitShape || entry?.portraitShape || 'portrait';
        if (!['portrait', 'square', 'horizontal'].includes(savedShape)) return null;
        window.PopPrintsPortraitShapes?.setShape(wrapper, savedShape, { restore: true });
        if ((hasTextInputs || (config.portraitShapesEnabled && entry?.personalisation)) && !isCompatiblePersonalisationDetails(entry?.personalisation)) {
          restoringPortraitDetails = true;
          textInputs.forEach((input) => { input.value = ''; syncTextFieldValidity(input); });
          restoringPortraitDetails = false;
          lastTextDetailsSignature = currentDetailsSignature();
          setStatus('This saved portrait does not have its original name or text details. Enter your details and choose a photo to create a new preview.', 'error');
          textInputs[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          textInputs[0]?.focus({ preventScroll: true });
          return null;
        }
        if (hasTextInputs) {
          restoringPortraitDetails = true;
          textInputs.forEach((input, index) => {
            input.value = entry.personalisation.fields[index].value;
            syncTextFieldValidity(input);
          });
          restoringPortraitDetails = false;
        }
        {
          uploadInputs.forEach((input) => { input.value = ''; updateUploadFieldUi(input, null, ''); });
          uploadInputs.forEach((input) => { input.required = false; });
          lastSelectedUploadFile = null;
          hadUploadedImage = false;
          cachedUploadBase64 = '';
          cachedUploadSignature = '';
          autoGenerateUploadSignature = '';
          restoringPortraitDetails = false;
          lastTextDetailsSignature = currentDetailsSignature();
        }

        activeGenerationRequestId = normalizeSavedPortraitCacheId(entry?.cacheId || '');
        const operation = beginPersonalisationOperation(activeGenerationRequestId,
          hasTextInputs ? { ...entry.personalisation, ...portraitStyleDetails(), portraitShape: savedShape } : capturePersonalisationDetails());
        portraitDetailsSnapshot = operation.details;
        if (config.portraitShapesEnabled) selectedShapeArtwork = { ...entry, url: portraitUrl || url,
          personalisation: operation.details, portraitShape: savedShape };
        setOriginalUploadOutputValue(String(entry?.originalUploadUrl || ''));
        if (hasTextInputs) setComparisonImages({ before: String(entry?.originalUploadUrl || '') });
        setPersistedPortraitPending(false);
        sectionRoot.classList.remove('personalisation-locked');
        sectionRoot.classList.add('personalisation-ready');
        wrapper.classList.add('personalisation-complete');
        const updatedImage = updateMainImage(url, { watermarked: true });
        storeGeneratedImage(url);
        checkoutDesignId = String(entry?.designId || '');
        checkoutDesignToken = String(entry?.designToken || '');
        checkoutArtworkSource = source === 'shopify-linked-portrait' || entry?.artworkSource === 'shopify-linked-portrait'
          ? 'shopify-linked-portrait' : '';
        setPortraitOutputValue(portraitUrl || url);
        setDescriptionText(buildReviewReadyMessage());
        syncAmendPanelState();
        notifyDeliveryEstimateRefresh(source, portraitUrl || url);
        if (focus) focusUpdatedImage(updatedImage);
        clearCartValidationError();
        setStatus(statusMessage, 'success');
        if (button) button.textContent = 'Create a new preview';
        syncDigitalDownloadUpsell();
        return updatedImage;
      };

      const applyRequestedSavedPortraitFromUrl = () => {
        if (requestedSavedPortraitApplied) return;
        const { cacheId, portraitUrl, source, statusMessage, displayOnly, designId, designToken, portraitShape } = getRequestedSavedPortraitParams();
        if (!cacheId && !portraitUrl) return;

        if (displayOnly && portraitUrl) {
          requestedSavedPortraitApplied = true;
          applyLandingPagePortraitContext(portraitUrl);
          return;
        }

        let entries = readSavedPortraits();
        // An artwork URL identifies the selected portrait even when old entries reuse or lack a cache ID.
        let entry = portraitUrl
          ? entries.find((item) => String(item.url || '').trim() === portraitUrl) || null
          : findSavedPortraitEntryByCacheId(entries, cacheId);

        if (!entry && portraitUrl) {
          entry = {
            cacheId: cacheId || `emailed-${Date.now().toString(36)}`,
            url: portraitUrl,
            previewUrl: portraitUrl,
            designId,
            designToken,
            portraitShape,
            artworkSource: source === 'shopify-linked-portrait' ? source : '',
            createdAt: new Date().toISOString()
          };
          // A valid saved link must also work when browser storage is full or unavailable.
          persistSavedPortrait(entry);
        }

        if (!entry) return;
        if (source === 'shopify-linked-portrait' && entry.artworkSource !== source) {
          entry = { ...entry, artworkSource: source };
          persistSavedPortrait(entry);
        }
        if (designId || designToken) entry = { ...entry, designId: designId || entry.designId, designToken: designToken || entry.designToken };
        requestedSavedPortraitApplied = true;
        applySavedPortraitEntry(entry, {
          source,
          statusMessage,
          focus: false,
        });
      };

      const persistSavedPortrait = (entry) => {
        if (!entry || !entry.url) return;
        if (shouldSkipStorage(entry.url) && (!entry.previewUrl || shouldSkipStorage(entry.previewUrl))) return;
        const saved = readSavedPortraits();
        const previous = saved.find((item) => item && item.url === entry.url);
        const entries = saved.filter((item) => item && item.url !== entry.url);
        const productId = String(entry.personalisation?.productId || entry.productId ||
          previous?.personalisation?.productId || previous?.productId || config.productId || '');
        const belongsToCurrentProduct = productId === String(config.productId || '');
        entries.push({
          cacheId: normalizeSavedPortraitCacheId(entry.cacheId || previous?.cacheId || ''),
          url: entry.url,
          productId,
          productUrl: String(entry.productUrl || previous?.productUrl || (belongsToCurrentProduct ? config.productUrl : '') || ''),
          productTitle: String(entry.productTitle || previous?.productTitle || (belongsToCurrentProduct ? config.productTitle : '') || ''),
          previewUrl: entry.previewUrl && !shouldSkipStorage(entry.previewUrl) ? entry.previewUrl : '',
          designId: String(entry.designId || previous?.designId || ''),
          designToken: String(entry.designToken || previous?.designToken || ''),
          artworkSource: (entry.artworkSource || previous?.artworkSource) === 'shopify-linked-portrait'
            ? 'shopify-linked-portrait' : '',
          personalisation: entry.personalisation || previous?.personalisation || null,
          portraitShape: entry.portraitShape || entry.personalisation?.portraitShape || previous?.portraitShape || getPortraitShape(),
          previewThemeId: String(config.previewThemeId || ''),
          originalUploadUrl: String(entry.originalUploadUrl || previous?.originalUploadUrl || ''),
          sourcePhotoKey: String(entry.sourcePhotoKey || previous?.sourcePhotoKey || ''),
          firstCreatedArtUrl: String(entry.firstCreatedArtUrl || previous?.firstCreatedArtUrl || ''),
          firstCreatedShape: String(entry.firstCreatedShape || previous?.firstCreatedShape || ''),
          createdAt: entry.createdAt || previous?.createdAt || new Date().toISOString()
        });
        writeSavedPortraits(entries);
      };

      const applyPersistedPortraitResult = (finalUrl, previewUrl, cacheId = '', operation = activePersonalisationOperation) => {
        if (!isCurrentPersonalisationOperation(operation) || (cacheId && cacheId !== operation.requestId)) return false;
        const resolvedFinalUrl = String(finalUrl || '').trim();
        if (!isPersistedPortraitValue(resolvedFinalUrl)) return false;
        const resolvedPreviewUrl = String(previewUrl || '').trim();

        setPersistedPortraitPending(false);
        portraitDetailsSnapshot = operation.details;
        storeGeneratedImage(resolvedFinalUrl);
        setPortraitOutputValue(resolvedFinalUrl);
        setDescriptionText(buildReviewReadyMessage());
        syncAmendPanelState();

        if (resolvedPreviewUrl && resolvedPreviewUrl !== resolvedFinalUrl) {
          const preload = new Image();
          preload.onload = () => {
            if (isCurrentPersonalisationOperation(operation) && getGeneratedImageUrl() === resolvedFinalUrl) updateMainImage(resolvedFinalUrl, { watermarked: true });
          };
          preload.src = resolvedFinalUrl;
        } else {
          updateMainImage(resolvedFinalUrl, { watermarked: true });
        }

        persistSavedPortrait({
          cacheId: normalizeSavedPortraitCacheId(cacheId || activeGenerationRequestId),
          url: resolvedFinalUrl,
          previewUrl: resolvedPreviewUrl || '',
          personalisation: operation.details,
          originalUploadUrl: String(originalUploadOutputInput?.value || ''),
          createdAt: new Date().toISOString()
        });
        notifyDeliveryEstimateRefresh('generated', resolvedFinalUrl);
        clearCartValidationError();
        setStatus('Your portrait is ready. Choose your finish and size.', 'success');
        syncDigitalDownloadUpsell();
        return true;
      };

      const getForcedPreviewImage = () => {
        const entries = readSavedPortraits();
        for (let idx = entries.length - 1; idx >= 0; idx -= 1) {
          const entry = entries[idx] || {};
          const displayUrl = entry.previewUrl || entry.url || '';
          const portraitUrl = entry.url || displayUrl;
          if (displayUrl) {
            return { displayUrl, portraitUrl };
          }
        }

        const fallbackUrl =
          config.howItWorksAfterUrl ||
          config.styleImageUrl ||
          config.baseImageUrl ||
          '';

        return {
          displayUrl: fallbackUrl,
          portraitUrl: fallbackUrl,
        };
      };

      const getDisplayPortraitUrl = () => getGeneratedImageUrl() ||
        (sectionRoot.classList.contains('personalisation-resizing') ? selectedShapeArtwork?.url || '' : '');
      const reapplyGeneratedImage = () => {
        const url = getDisplayPortraitUrl();
        if (!url) {
          if (selectedPortraitStyle && !sectionRoot.classList.contains('personalisation-ready')) updateMainImage(selectedPortraitStyle.imageUrl);
          return;
        }
        updateMainImage(url, { watermarked: true });
      };

      const resolveDisplayedPortraitImage = () => {
        return (
          sectionRoot.querySelector('slideshow-slide[aria-hidden="false"] img.product-media__image') ||
          sectionRoot.querySelector('.media-gallery__grid .product-media-container--image:first-child img.product-media__image') ||
          sectionRoot.querySelector('img.product-media__image')
        );
      };

      const preservePersonalisedMediaInVariantHtml = (event) => {
        const target = event.target;
        if (!(target instanceof Element) || !sectionRoot.contains(target)) return;

        const nextHtml = event.detail && event.detail.data ? event.detail.data.html : null;
        if (!nextHtml || typeof nextHtml.querySelectorAll !== 'function') return;

        const portraitUrl = String(outputInput?.value || getDisplayPortraitUrl() || '').trim();
        if (!sectionRoot.classList.contains('personalisation-ready') || !portraitUrl) return;

        const displayedImage = resolveDisplayedPortraitImage();
        if (!(displayedImage instanceof HTMLImageElement)) return;

        const displaySrc = String(displayedImage.currentSrc || displayedImage.getAttribute('src') || '').trim();
        if (!displaySrc) return;

        const objectPosition =
          displayedImage.style.objectPosition || window.getComputedStyle(displayedImage).objectPosition || '';
        const currentSource = String(displayedImage.getAttribute('data-current-source') || '').trim();
        const originalSource = String(displayedImage.getAttribute('data-original-src') || '').trim();
        const maxResolution = String(
          displayedImage.getAttribute('data-max-resolution') ||
            displayedImage.getAttribute('data_max_resolution') ||
            displaySrc
        ).trim();

        nextHtml
          .querySelectorAll(
            'media-gallery img.product-media__image, sticky-add-to-cart[data-product-id="' +
              String(config.productId || '') +
              '"] img[ref="productImage"]'
          )
          .forEach((img) => {
            if (!(img instanceof HTMLImageElement)) return;

            img.src = displaySrc;
            img.setAttribute('src', displaySrc);
            img.setAttribute('srcset', displaySrc + ' 1x');
            img.removeAttribute('sizes');
            img.setAttribute('data-max-resolution', maxResolution || displaySrc);
            img.setAttribute('data_max_resolution', maxResolution || displaySrc);
            syncCanvasFrameImage(img, displaySrc);

            if (currentSource) {
              img.setAttribute('data-current-source', currentSource);
            }

            if (originalSource) {
              img.setAttribute('data-original-src', originalSource);
            }

            if (objectPosition) {
              img.style.objectPosition = objectPosition;
            }

            if (img.matches('sticky-add-to-cart img[ref="productImage"]')) {
              img.alt = 'Your portrait preview';
            }
          });
      };

      let reapplyFrame = 0;
      const scheduleReapply = () => {
        if ((!getDisplayPortraitUrl() && !selectedPortraitStyle) || reapplyFrame) return;
        reapplyFrame = window.requestAnimationFrame(() => {
          reapplyFrame = 0;
          reapplyGeneratedImage();
        });
      };

      const applyForcedPersonalisationState = () => {
        if (!debugEnabled) return;

        const forcedState = getForcedPersonalisationState();
        if (!forcedState) return;

        sectionRoot.dataset.personalisationPreviewState = forcedState;

        if (forcedState === 'ready') {
          const previewImage = getForcedPreviewImage();
          const displayUrl = previewImage.displayUrl || '';
          const portraitUrl = previewImage.portraitUrl || displayUrl;

          sectionRoot.classList.remove('personalisation-locked');
          sectionRoot.classList.add('personalisation-ready');
          wrapper.classList.add('personalisation-complete');

          if (displayUrl) {
            updateMainImage(displayUrl, { watermarked: true });
          }

          storeGeneratedImage(portraitUrl);
          setPortraitOutputValue(portraitUrl);
          clearCartValidationError();
          clearMissingUploadMessage();
          setDescriptionText(buildReviewReadyMessage());
          if (button) button.textContent = 'Create a new preview';
          notifyDeliveryEstimateRefresh('debug-forced', portraitUrl);
          syncAmendPanelState();
          syncDigitalDownloadUpsell();
          return;
        }

        wrapper.classList.remove('personalisation-complete');
        sectionRoot.classList.remove('personalisation-ready');
        sectionRoot.classList.add('personalisation-locked');
        storeGeneratedImage('');
        setPortraitOutputValue('');
        clearCartValidationError();
        if (button) button.textContent = config.referenceLayout === true ? 'Create Print' : 'Preview My Portrait';
        syncAmendPanelState();

        if (config.baseImageUrl) {
          updateMainImage(config.baseImageUrl);
        }
        syncDigitalDownloadUpsell({ resetSelection: true });
      };

      const checkPortraitShapeResponse = (data, operation) => {
        const shape = operation?.details?.portraitShape || 'portrait';
        if (shape === 'portrait') return data;
        const ratio = shape === 'square' ? '1:1' : '3:2';
        const failed = data?.status === 'error' || Boolean(data?.error);
        const matches = data?.portraitShape === shape && String(data?.previewThemeId || '') === String(operation?.previewThemeId || config.previewThemeId || '') &&
          (data?.aspectRatio === undefined || data.aspectRatio === ratio);
        if (!failed && (!(data?.url || data?.b64) || matches)) return data;
        return { ...data, status: 'error', url: '', b64: '', pendingUrl: false, portraitShapeRejected: true,
          error: data?.error || 'This preview does not match your selected shape. Please create a new preview.' };
      };

      const shapeReuseGroups = new Map();
      const shapeReuseTasks = new WeakMap();
      const shapePhotoHashes = new WeakMap();
      const shapeReuseStorageKey = SAVED_PORTRAITS_KEY + '.groups.v1';
      const shapeRequestBodies = new Map();
      const shapeRequestStorageKey = (requestId) => shapeReuseStorageKey + '.request.' + requestId;
      const readShapeRequest = (requestId) => {
        if (shapeRequestBodies.has(requestId)) return shapeRequestBodies.get(requestId);
        try { return JSON.parse(getStorage()?.getItem(shapeRequestStorageKey(requestId)) || 'null'); } catch { return null; }
      };
      const saveShapeRequest = (requestId, request) => {
        shapeRequestBodies.set(requestId, request);
        // Store the replay body separately: a photo exceeding quota must not prevent saving its request ID.
        try { getStorage()?.setItem(shapeRequestStorageKey(requestId), JSON.stringify(request)); } catch {}
      };
      const forgetShapeRequest = (requestId) => {
        shapeRequestBodies.delete(requestId);
        try { getStorage()?.removeItem(shapeRequestStorageKey(requestId)); } catch {}
      };
      const shapeSourceIdentity = (value) => {
        try { const url = new URL(String(value || '')); return url.origin + url.pathname; } catch { return ''; }
      };
      const mergeShapeReuseGroup = (group, saved, retryShape) => {
        if (!saved) return group;
        const rank = { waiting: 0, pending: 1, error: 2, ready: 3 };
        Object.entries(saved.slots || {}).forEach(([shape, slot]) => {
          slot.previewThemeId ||= String(['pending', 'error'].includes(slot.state) ? config.portraitShapeLegacyThemeId : config.previewThemeId);
          const current = group.slots[shape];
          if (shape === retryShape && current && slot.state !== 'ready') return;
          if (!current) group.slots[shape] = slot;
          else if (rank[slot.state] > rank[current.state] && !(shape === retryShape && slot.state === 'error' && current.state === 'waiting')) Object.assign(current, slot);
        });
        ['firstCreatedArtUrl', 'firstCreatedShape', 'masterShape', 'originalUploadUrl'].forEach((key) => { if (saved[key]) group[key] = saved[key]; });
        return group;
      };
      const readShapeReuseGroups = () => {
        try {
          const saved = JSON.parse(getStorage()?.getItem(shapeReuseStorageKey) || '[]');
          if (Array.isArray(saved)) saved.forEach((group) => {
            if (group?.key && group.productId && Array.isArray(group.fields) && group.slots) {
              shapeReuseGroups.set(group.key, mergeShapeReuseGroup(shapeReuseGroups.get(group.key) || group, group));
            }
          });
        } catch {}
        return [...shapeReuseGroups.values()];
      };
      const saveShapeReuseGroup = (group, retryShape) => {
        shapeReuseGroups.set(group.key, group);
        try {
          const storage = getStorage();
          const saved = JSON.parse(storage?.getItem(shapeReuseStorageKey) || '[]');
          mergeShapeReuseGroup(group, Array.isArray(saved) ? saved.find((item) => item?.key === group.key) : null, retryShape);
          storage?.setItem(shapeReuseStorageKey, JSON.stringify([...(Array.isArray(saved) ? saved : []).filter((item) => item?.key !== group.key), group]));
        } catch {}
      };
      const shapePhotoKey = async (file) => {
        if (!shapePhotoHashes.has(file)) shapePhotoHashes.set(file, (async () => {
          const bytes = await new Promise((resolve, reject) => {
            const reader = new FileReader(); reader.onload = () => resolve(reader.result); reader.onerror = reject; reader.readAsArrayBuffer(file);
          });
          const digest = await window.crypto.subtle.digest('SHA-256', bytes);
          return 'sha256:' + [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
        })());
        return shapePhotoHashes.get(file);
      };
      const shapeGroupForOperation = async (operation) => {
        const groups = readShapeReuseGroups();
        const original = shapeSourceIdentity(operation.originalUploadUrl);
        const saved = readSavedPortraits();
        const selected = operation.savedArtwork;
        if (selected) saved.push(selected);
        const artwork = shapeSourceIdentity(selected?.firstCreatedArtUrl || selected?.url);
        const knownSource = original && (groups.find((group) => shapeSourceIdentity(group.originalUploadUrl) === original)?.sourcePhotoKey ||
          saved.find((entry) => entry.sourcePhotoKey && shapeSourceIdentity(entry.originalUploadUrl) === original)?.sourcePhotoKey);
        const sourcePhotoKey = operation.uploadFile ? await shapePhotoKey(operation.uploadFile) : selected?.sourcePhotoKey || knownSource ||
          (original ? 'url:' + original : artwork ? 'art:' + artwork : '');
        if (!sourcePhotoKey) throw new Error('Choose your pet photo to continue.');
        const details = operation.details;
        const legacyKey = JSON.stringify([details.productId, sourcePhotoKey, details.fields]);
        const key = details.portraitStyleKey
          ? JSON.stringify([details.productId, sourcePhotoKey, details.fields, details.portraitStyleKey]) : legacyKey;
        let group = shapeReuseGroups.get(key);
        // Keep old default-style receipts and replay bodies under their original identity.
        // A theme update must not replace a pending request with a second paid request.
        if (!group && styleIdForDetails(details) === originalPortraitStyleId) {
          const legacyGroup = shapeReuseGroups.get(legacyKey);
          if (legacyGroup && !legacyGroup.portraitStyleKey) group = legacyGroup;
        }
        if (!group) {
          group = { key, sourcePhotoKey, productId: details.productId, fields: details.fields,
            ...(details.portraitStyleKey ? { portraitStyleId: details.portraitStyleId, portraitStyleKey: details.portraitStyleKey,
              stylePrompt: operation.prompt, styleImageUrl: operation.styleImageUrl, imageModel: operation.imageModel } : {}),
            originalUploadUrl: operation.originalUploadUrl, firstCreatedArtUrl: '', firstCreatedShape: '', masterShape: '', slots: {} };
          const candidates = saved.filter((entry) => entry?.url && !isDataUrl(entry.url) &&
            entry.personalisation?.productId === details.productId && JSON.stringify(entry.personalisation.fields) === JSON.stringify(details.fields) &&
            (!details.portraitStyleKey || (styleIdForDetails(entry.personalisation) === details.portraitStyleId &&
              (entry.personalisation.portraitStyleKey === details.portraitStyleKey ||
                (!entry.personalisation.portraitStyleKey && details.portraitStyleId === originalPortraitStyleId)))) &&
            (entry.sourcePhotoKey === sourcePhotoKey || (original && shapeSourceIdentity(entry.originalUploadUrl) === original) ||
              (artwork && [entry.url, entry.firstCreatedArtUrl].some((value) => shapeSourceIdentity(value) === artwork))))
            .sort((left, right) => String(left.createdAt || '').localeCompare(String(right.createdAt || '')));
          candidates.forEach((entry) => {
            const shape = entry.portraitShape || entry.personalisation.portraitShape || 'portrait';
            if (!['portrait', 'square', 'horizontal'].includes(shape) || group.slots[shape]) return;
            group.slots[shape] = { state: 'ready', requestId: entry.cacheId, shape, url: entry.url,
              createdAt: entry.createdAt, designId: entry.designId || '', designToken: entry.designToken || '' };
            if (!group.firstCreatedArtUrl) {
              group.firstCreatedArtUrl = entry.firstCreatedArtUrl || entry.url;
              group.firstCreatedShape = entry.firstCreatedShape || shape;
              group.masterShape = group.firstCreatedShape;
            }
          });
          saveShapeReuseGroup(group);
        }
        return group;
      };
      const shapeEntryForSlot = (group, slot) => ({
        cacheId: slot.requestId, url: slot.url, portraitShape: slot.shape, previewThemeId: String(config.previewThemeId || ''),
        originalUploadUrl: group.originalUploadUrl, sourcePhotoKey: group.sourcePhotoKey,
        firstCreatedArtUrl: group.firstCreatedArtUrl, firstCreatedShape: group.firstCreatedShape,
        personalisation: { version: 1, productId: group.productId, portraitShape: slot.shape, fields: group.fields,
          ...(group.portraitStyleKey ? { portraitStyleId: group.portraitStyleId, portraitStyleKey: group.portraitStyleKey } : {}) },
        designId: slot.designId || '', designToken: slot.designToken || '', createdAt: slot.createdAt,
      });
      const collectShapeSlot = (group, slot, data) => {
        let checked = checkPortraitShapeResponse(data, { details: { portraitShape: slot.shape }, previewThemeId: slot.previewThemeId });
        if ((data.url || data.b64) && (data.portraitShape !== slot.shape || String(data.previewThemeId || '') !== slot.previewThemeId)) {
          checked = { status: 'error', error: 'This preview does not match the requested shape.' };
        }
        if (checked.accepted === true) { slot.accepted = true; forgetShapeRequest(slot.requestId); }
        if (checked.portraitShapeRejected || checked.status === 'error' || checked.error) {
          slot.retryable = checked.retryable === true; slot.code = String(checked.code || '');
          slot.state = 'error'; slot.error = String(checked.error || 'This preview could not be completed.');
          saveShapeReuseGroup(group); throw new Error(slot.error);
        }
        if (checked.originalUploadUrl) group.originalUploadUrl = String(checked.originalUploadUrl);
        if (checked.url && !isDataUrl(checked.url)) {
          forgetShapeRequest(slot.requestId);
          slot.state = 'ready'; slot.url = String(checked.url); slot.createdAt ||= new Date().toISOString();
          if (!group.firstCreatedArtUrl) {
            group.firstCreatedArtUrl = slot.url; group.firstCreatedShape = slot.shape; group.masterShape = slot.shape;
          }
          saveShapeReuseGroup(group);
          const entry = shapeEntryForSlot(group, slot); persistSavedPortrait(entry); return entry;
        }
        saveShapeReuseGroup(group);
        return null;
      };
      const ensureShapeSlot = (group, shape, source, retryFailed = false) => {
        readShapeReuseGroups();
        let slot = group.slots[shape];
        if (slot?.state === 'ready') return Promise.resolve(shapeEntryForSlot(group, slot));
        if (slot?.state === 'error' && !retryFailed) return Promise.reject(new Error(slot.error));
        let tasks = shapeReuseTasks.get(group);
        if (!tasks) { tasks = new Map(); shapeReuseTasks.set(group, tasks); }
        if (tasks.has(shape)) return tasks.get(shape);
        if (!slot) {
          slot = group.slots[shape] = { shape, requestId: window.crypto.randomUUID(), state: 'waiting', previewThemeId: String(config.previewThemeId || '') };
          if (!group.firstCreatedArtUrl && !group.masterShape) group.masterShape = shape;
          saveShapeReuseGroup(group);
        }
        const run = async () => {
          readShapeReuseGroups();
          slot = group.slots[shape];
          if (slot.state === 'ready') return shapeEntryForSlot(group, slot);
          const status = () => fetchGenerationStatusSnapshotById(slot.requestId,
            { details: { portraitShape: shape }, previewThemeId: slot.previewThemeId });
          if (slot.state === 'error') {
            if (!retryFailed) throw new Error(slot.error);
            // Only a fresh, confirmed terminal failure may start a new paid attempt on explicit Retry.
            const fresh = await status();
            if (fresh.status === 'error' && fresh.accepted === true && fresh.retryable === true) {
              const previousRequestId = slot.requestId;
              forgetShapeRequest(slot.requestId);
              slot.requestId = window.crypto.randomUUID();
              if (source?.requestId === previousRequestId && isCurrentPersonalisationOperation(source)) {
                source.requestId = slot.requestId;
                activeGenerationRequestId = slot.requestId;
              }
              slot.state = 'waiting'; slot.accepted = false;
              delete slot.error; delete slot.code; delete slot.retryable;
              delete slot.submittedAt; delete slot.lastSubmittedAt;
              saveShapeReuseGroup(group, shape);
            } else {
              if (fresh.status === 'error' || fresh.error) collectShapeSlot(group, slot, fresh);
              slot.state = 'pending'; delete slot.error;
              if (fresh.accepted === true) slot.accepted = true;
              saveShapeReuseGroup(group, shape);
              const entry = collectShapeSlot(group, slot, fresh);
              if (entry) return entry;
            }
          }
          const prepareRequest = async () => {
            const saved = readShapeRequest(slot.requestId);
            if (saved?.body && saved.endpoint) return saved;
            if (!group.firstCreatedArtUrl && group.masterShape !== shape) await ensureShapeSlot(group, group.masterShape, source, retryFailed);
            let payload;
            const shared = { portraitShape: shape, previewThemeId: slot.previewThemeId, requestId: slot.requestId,
              aspectRatio: { portrait: '2:3', square: '1:1', horizontal: '3:2' }[shape],
              visitorId: getGenerationVisitorId(), productId: group.productId, fileName: 'product-' + group.productId,
              ...(group.portraitStyleKey ? { imageModel: group.imageModel } : {}),
              includeBase64: Boolean(config.fastPreviewResponseEnabled), deferPersistence: Boolean(config.fastPreviewResponseEnabled) };
            if (group.firstCreatedArtUrl) {
              payload = { ...shared, includeBase64: false, deferPersistence: false,
                inputImageSource: 'generated_portrait_reformat', sourceArtworkUrl: slot.sourceArtworkUrl || group.firstCreatedArtUrl,
                uploadedPhotoUrl: group.originalUploadUrl };
            } else {
              const image = source?.uploadFile ? await fetchBase64File(source.uploadFile)
                : group.originalUploadUrl ? await fetchBase64Image(group.originalUploadUrl) : null;
              if (!image?.base64) throw new Error('Choose the same pet photo to finish this preview.');
              payload = { ...shared, base64Image: image.base64, mimeType: image.mimeType || 'image/jpeg',
                inputImageSource: 'upload', uploadedPhotoUrl: group.originalUploadUrl,
                uploadFileName: source?.uploadFile?.name || '',
                prompt: group.portraitStyleKey ? group.stylePrompt || '' : source?.prompt || '',
                referenceImageUrl: group.portraitStyleKey ? group.styleImageUrl || '' : config.styleImageUrl || '' };
            }
            slot.sourceArtworkUrl = payload.sourceArtworkUrl || '';
            const request = { endpoint: group.portraitStyleKey ? generationEndpointForModel(group.imageModel) : getGenerationEndpoint(), body: JSON.stringify(payload) };
            saveShapeRequest(slot.requestId, request);
            return request;
          };
          const post = async () => {
            const request = await prepareRequest();
            slot.state = 'pending'; slot.submittedAt ||= Date.now(); slot.lastSubmittedAt = Date.now();
            saveShapeReuseGroup(group, shape);
            const controller = new AbortController();
            const timer = setTimeout(() => controller.abort(), 60000);
            let data;
            try {
              const response = await fetch(request.endpoint, { method: 'POST', signal: controller.signal,
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'x-request-id': slot.requestId }, body: request.body });
              data = await response.json().catch(() => ({}));
              if (response.status === 409) {
                // This ID belongs to accepted work. Poll it; never replace it with a new request.
                slot.accepted = true; slot.code = String(data.code || 'request_conflict');
                saveShapeReuseGroup(group); return null;
              }
            } catch {} finally { clearTimeout(timer); }
            return data ? collectShapeSlot(group, slot, data) : null;
          };
          if (slot.state === 'waiting') {
            const entry = await post();
            if (entry) return entry;
          }
          const started = Date.now();
          let missingCount = 0, replayed = false;
          while (Date.now() - started < 180000) {
            let data;
            try { data = await status(); } catch {}
            if (data) {
              const entry = collectShapeSlot(group, slot, data);
              if (entry) return entry;
              const missing = data.status === 'missing' && data.accepted === false;
              missingCount = missing ? missingCount + 1 : 0;
              if (missingCount >= 2 && !slot.accepted && Date.now() - (slot.lastSubmittedAt || 0) >= 4000) {
                if (replayed) throw new Error('Your preview request has not reached us. Please try again to resume this same preview.');
                replayed = true; missingCount = 0;
                const recovered = await post();
                if (recovered) return recovered;
              }
            }
            await new Promise((resolve) => setTimeout(resolve, 2000));
          }
          throw new Error(slot.accepted
            ? 'Your preview is still being checked. Please return shortly to resume it without creating another request.'
            : 'Your preview could not be confirmed. Please try again to resume this same preview.');
        };
        const task = Promise.resolve().then(() => window.navigator.locks?.request
          ? window.navigator.locks.request('pop-portrait:' + group.key + ':' + shape, run) : run())
          .finally(() => { if (tasks.get(shape) === task) tasks.delete(shape); });
        tasks.set(shape, task);
        return task;
      };
      const handleShapeGenerate = async ({ retryFailed = false } = {}) => {
        if (!button || wrapper.classList.contains('is-loading') || digitalDownloadCartSubmitting) return;
        if (!ensureTextFieldsValid() || !hasUploadedImage()) {
          setStatus('Complete your details and choose your pet photo to continue.', 'error'); return;
        }
        const selectionId = 'shape-' + window.crypto.randomUUID();
        const operation = beginPersonalisationOperation(selectionId);
        operation.originalUploadUrl = String(originalUploadOutputInput?.value || '').trim();
        operation.savedArtwork = selectedShapeArtwork;
        operation.prompt = buildPrompt();
        operation.styleImageUrl = config.styleImageUrl || '';
        operation.imageModel = config.imageModel || 'gemini';
        activeGenerationRequestId = selectionId;
        wrapper.classList.add('is-loading'); button.disabled = true;
        setStatus('Loading this portrait shape...', '');
        try {
          const group = await shapeGroupForOperation(operation);
          if (!isCurrentPersonalisationOperation(operation)) return;
          const shape = operation.details.portraitShape;
          const pending = ensureShapeSlot(group, shape, operation, retryFailed);
          const slot = group.slots[shape];
          operation.requestId = slot.requestId; operation.previewThemeId = slot.previewThemeId; activeGenerationRequestId = slot.requestId;
          const resizing = Boolean(group.firstCreatedArtUrl || group.masterShape !== shape);
          if (resizing && slot.state !== 'ready') showProgress({
            title: 'Resizing your portrait', subtext: 'Adapting your first artwork to your selected shape.',
            reassurance: 'Usually ready in about 10 seconds.',
            messages: [{ at: 0, message: 'Resizing your portrait' }, { at: 56, message: 'Preserving your artwork and details' }, { at: 89, message: 'Finishing your resized preview' }],
            retryAction: () => handleShapeGenerate({ retryFailed: true }),
          });
          else if (slot.state !== 'ready') showProgress({ retryAction: () => handleShapeGenerate({ retryFailed: true }) });
          setStatus(slot.state === 'ready' ? 'Loading your saved portrait...' : resizing
            ? 'Resizing your portrait...' : 'Creating your portrait...', '');
          const entry = await pending;
          if (!isCurrentPersonalisationOperation(operation)) return;
          // Completing this generation must not discard an email being entered in its overlay.
          const preserveProgressOverlay = Boolean(progressEl && !progressEl.hidden);
          const updatedImage = applySavedPortraitEntry(entry, { source: 'shape-reuse', statusMessage: 'Your portrait is ready. Choose your finish and size.', focus: !preserveProgressOverlay, preserveProgressOverlay });
          if (preserveProgressOverlay) progressFocusTarget = updatedImage;
          hideProgress(true);
        } catch (error) {
          if (!isCurrentPersonalisationOperation(operation)) return;
          const message = error?.message || 'Unable to load this portrait shape.';
          showProgressErrorState(message); setStatus(message, 'error');
        } finally {
          if (isCurrentPersonalisationOperation(operation)) { wrapper.classList.remove('is-loading'); syncGenerateButtonState(); }
        }
      };

      const legacyInitialAttempts = new Map();
      const legacyInitialAttemptStorageKey = (key) => SAVED_PORTRAITS_KEY + '.initial.v1.' + key;
      const legacyInitialRequestKey = async (endpoint, payload, details) => {
        const stable = { ...payload };
        // These fields may change when a saved original photo replaces the local
        // file. Keep their exact original values in the small attempt record.
        for (const field of ['requestId', 'visitorId', 'uploadedPhotoUrl', 'uploadFileName']) delete stable[field];
        const value = JSON.stringify([endpoint, details, stable]);
        if (!window.crypto?.subtle) return value;
        const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value));
        return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
      };
      const readLegacyInitialAttempt = (key) => {
        try {
          const saved = JSON.parse(getStorage()?.getItem(legacyInitialAttemptStorageKey(key)) || 'null');
          if (saved?.key === key && saved.requestId) {
            const current = legacyInitialAttempts.get(key);
            const rank = { waiting: 0, pending: 1, error: 2, ready: 3 };
            if (current?.requestId === saved.requestId && (current.accepted && !saved.accepted ||
                rank[current.state] > rank[saved.state] || (current.lastSubmittedAt || 0) > (saved.lastSubmittedAt || 0))) return current;
            legacyInitialAttempts.set(key, saved);
            return saved;
          }
        } catch {}
        return legacyInitialAttempts.get(key) || null;
      };
      const saveLegacyInitialAttempt = (attempt) => {
        legacyInitialAttempts.set(attempt.key, attempt);
        // The photo body is stored separately so quota pressure cannot prevent
        // the small request identity from being saved whenever space remains.
        try { getStorage()?.setItem(legacyInitialAttemptStorageKey(attempt.key), JSON.stringify(attempt)); } catch {}
      };
      const ensureLegacyInitialGeneration = async ({ endpoint, payload, operation, retryFailed = false, onRequestId }) => {
        const key = await legacyInitialRequestKey(endpoint, payload, operation.details);
        const run = async () => {
          if (!isCurrentPersonalisationOperation(operation)) return null;
          let attempt = readLegacyInitialAttempt(key);
          const newAttempt = () => ({ key, requestId: window.crypto?.randomUUID?.() || createGenerationVisitorId(),
            state: 'waiting', accepted: false,
            requestProperties: { visitorId: payload.visitorId, uploadedPhotoUrl: payload.uploadedPhotoUrl, uploadFileName: payload.uploadFileName } });
          if (!attempt) { attempt = newAttempt(); saveLegacyInitialAttempt(attempt); }
          else if (attempt.state === 'waiting') { attempt.state = 'pending'; saveLegacyInitialAttempt(attempt); }
          const bind = () => {
            operation.requestId = attempt.requestId; activeGenerationRequestId = attempt.requestId;
            onRequestId?.(attempt.requestId);
          };
          bind();
          const collect = (data) => {
            if (data.accepted === true || data.url || data.b64) {
              attempt.accepted = true;
              forgetShapeRequest(attempt.requestId);
            }
            if (data.status === 'error' && data.accepted === true) {
              attempt.state = 'error'; attempt.retryable = data.retryable === true;
              attempt.error = String(data.error || 'Your preview could not be completed.');
              saveLegacyInitialAttempt(attempt);
              throw new Error(attempt.error);
            }
            if (data.url || data.b64) {
              if (data.url && !isDataUrl(data.url)) {
                attempt.state = 'ready';
                attempt.result = { status: data.status || 'done', accepted: true, url: data.url,
                  originalUploadUrl: data.originalUploadUrl || '' };
              } else attempt.state = 'pending';
              saveLegacyInitialAttempt(attempt);
              return data;
            }
            saveLegacyInitialAttempt(attempt);
            return null;
          };
          const status = async () => {
            const snapshot = await fetchGenerationStatusSnapshotById(attempt.requestId, operation);
            if (!snapshot.b64) return snapshot;
            const image = parseDataUrl(snapshot.b64);
            return { ...snapshot, b64: image.base64, mimeType: image.mimeType || 'image/png' };
          };
          if (attempt.state === 'ready' && attempt.result?.url) return attempt.result;
          if (attempt.state !== 'waiting') {
            let fresh;
            try { fresh = await status(); } catch {}
            if (!isCurrentPersonalisationOperation(operation)) return null;
            // A button click can authorize another paid attempt only after the
            // server freshly confirms a terminal, explicitly retryable failure.
            if (retryFailed && fresh?.status === 'error' && fresh.accepted === true && fresh.retryable === true) {
              forgetShapeRequest(attempt.requestId);
              attempt = newAttempt(); saveLegacyInitialAttempt(attempt); bind();
            } else if (fresh) {
              const complete = collect(fresh);
              if (complete) return complete;
            }
          }
          const post = async () => {
            if (!isCurrentPersonalisationOperation(operation)) return null;
            let request = readShapeRequest(attempt.requestId);
            if (!request?.body || !request.endpoint) {
              request = { endpoint, body: JSON.stringify({ ...payload, ...attempt.requestProperties, requestId: attempt.requestId }) };
              saveShapeRequest(attempt.requestId, request);
            }
            attempt.state = 'pending'; attempt.lastSubmittedAt = Date.now();
            saveLegacyInitialAttempt(attempt);
            const controller = new AbortController();
            const timer = setTimeout(() => controller.abort(), 60000);
            let data;
            try {
              const response = await fetch(request.endpoint, { method: 'POST', signal: controller.signal,
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'x-request-id': attempt.requestId }, body: request.body });
              data = await response.json().catch(() => ({}));
              if (response.status === 409) {
                attempt.accepted = true; attempt.state = 'pending';
                forgetShapeRequest(attempt.requestId); saveLegacyInitialAttempt(attempt);
                return null;
              }
            } catch {} finally { clearTimeout(timer); }
            return data ? collect(data) : null;
          };
          if (attempt.state === 'waiting') {
            const complete = await post();
            if (complete) return complete;
          }
          const started = Date.now();
          let missingCount = 0, replayed = false;
          while (Date.now() - started < 60000 && isCurrentPersonalisationOperation(operation)) {
            let snapshot;
            try { snapshot = await status(); } catch {}
            if (snapshot) {
              const complete = collect(snapshot);
              if (complete) return complete;
              const missing = snapshot.status === 'missing' && snapshot.accepted === false;
              missingCount = missing ? missingCount + 1 : 0;
              if (missingCount >= 2 && !attempt.accepted && Date.now() - (attempt.lastSubmittedAt || 0) >= 4000) {
                if (replayed) throw new Error('Your preview has not reached us yet. Retry will resume this same request.');
                replayed = true; missingCount = 0;
                const recovered = await post();
                if (recovered) return recovered;
              }
            }
            await new Promise((resolve) => setTimeout(resolve, 2000));
          }
          if (!isCurrentPersonalisationOperation(operation)) return null;
          throw new Error(attempt.accepted
            ? 'Your preview is still being checked. Please return shortly to resume it without creating another request.'
            : 'Your preview could not be confirmed. Retry will resume this same request.');
        };
        return window.navigator.locks?.request
          ? window.navigator.locks.request('pop-initial-preview:' + key, run) : run();
      };

      const handleGenerate = async (event) => {
        if (config.portraitShapesEnabled) return handleShapeGenerate({ retryFailed: event?.type === 'click' });
        if (!button || wrapper.classList.contains('is-loading') || digitalDownloadCartSubmitting) return;
        if (!ensureTextFieldsValid()) {
          clearCartValidationError();
          setStatus('Please complete the required fields.', 'error');
          return;
        }
        if (!hasUploadedImage()) {
          showCartValidationError(getMissingUploadMessage());
          syncGenerateButtonState();
          return;
        }
        if (String(originalUploadOutputInput?.value || '').startsWith('https://')) {
          uploadInputs.forEach((input) => { if (!input.files?.length) input.required = false; });
        }
        if (!ensureFieldsValid()) {
          clearCartValidationError();
          setStatus('Please complete the required fields.', 'error');
          return;
        }

        sanitizeNamesInputs();

        if (!config.baseImageUrl) {
          clearCartValidationError();
          setStatus('Missing base image for this product.', 'error');
          return;
        }

        let requestId = debugEnabled ? createGenerationVisitorId() : '';

        const operation = beginPersonalisationOperation(requestId);
        const generationPrompt = buildPrompt();
        const sourceUploadUrl = String(originalUploadOutputInput?.value || '').trim();

        button.disabled = true;
        clearCartValidationError();
        setStatus('Creating your portrait...', '');
        activeGenerationRequestId = requestId;
        if (debugEnabled) showProgress({ retryAction: () => handleGenerate({ retryFailed: true }) });
        wrapper.classList.add('is-loading');

        try {
          let data = {};
          let responseOk = true;
          let responseStatus = null;
          let responseError = null;
          setPersistedPortraitPending(false);
          storeGeneratedImage('');
          setPortraitOutputValue('');

          const fetchGenerationStatusSnapshot = () => fetchGenerationStatusSnapshotById(requestId, operation);

          const pollStatus = async (timeoutMs = 60000) => {
            const start = Date.now();
            while (Date.now() - start < timeoutMs && isCurrentPersonalisationOperation(operation)) {
              try {
                const snapshot = await fetchGenerationStatusSnapshot();
                if (snapshot.url || snapshot.b64 || snapshot.portraitShapeRejected) {
                  return snapshot;
                }
              } catch (err) {
                // ignore and retry
              }
              await new Promise((resolve) => setTimeout(resolve, 3000));
            }
            return { status: '', url: '', b64: '', pendingUrl: false, error: '' };
          };

          const pollPersistedUrl = async (timeoutMs = 180000) => {
            const start = Date.now();
            while (Date.now() - start < timeoutMs && isCurrentPersonalisationOperation(operation)) {
              try {
                const snapshot = await fetchGenerationStatusSnapshot();
                if (snapshot.url || (snapshot.status === 'error' && snapshot.error)) {
                  return snapshot;
                }
              } catch (err) {
                // ignore and retry
              }
              await new Promise((resolve) => setTimeout(resolve, 3000));
            }
            return { status: 'timeout', url: '', b64: '', pendingUrl: false, error: '' };
          };

          const finalizePersistedPortraitFromStatus = (previewImageUrl) => {
            const safePreviewUrl = String(previewImageUrl || '').trim();
            void (async () => {
              const polled = await pollPersistedUrl(180000);
              if (!isCurrentPersonalisationOperation(operation)) return;
              if (polled.portraitShapeRejected) {
                invalidatePortraitForInputChange({ force: true, message: polled.error });
                return;
              }
              if (polled.url) {
                applyPersistedPortraitResult(polled.url, safePreviewUrl, requestId, operation);
                return;
              }

              console.warn('[personalisation] persisted portrait polling did not resolve a final URL', {
                requestId,
                status: polled.status || 'unknown',
                error: polled.error || '',
              });
              setStatus('Your preview is ready, but saving it is taking longer than expected. Please wait a moment before adding to cart.', 'error');
            })();
          };

          if (debugEnabled) {
            console.info('[personalisation] debug mode enabled; skipping generator call');
            const baseUrl = config.styleImageUrl || config.baseImageUrl;
            const separator = baseUrl.includes('?') ? '&' : '?';
            data = {
              url: baseUrl + separator + 'debug=' + Date.now()
            };
            await new Promise((resolve) => setTimeout(resolve, 300));
          } else {
            const uploadFile = operation.uploadFile;
            let payloadBase64 = cachedBase64;
            let payloadMime = cachedMime;

            if (uploadFile) {
              const signature = [uploadFile.name, uploadFile.size, uploadFile.lastModified].join(':');
              if (!cachedUploadBase64 || cachedUploadSignature !== signature) {
                const uploadPayload = await fetchBase64File(uploadFile);
                if (!isCurrentPersonalisationOperation(operation)) return;
                cachedUploadBase64 = uploadPayload.base64;
                cachedUploadMime = uploadPayload.mimeType || cachedUploadMime;
                cachedUploadSignature = signature;
              }
              payloadBase64 = cachedUploadBase64;
              payloadMime = cachedUploadMime;
            } else if (sourceUploadUrl) {
              const savedPhoto = await fetchBase64Image(sourceUploadUrl);
              if (!isCurrentPersonalisationOperation(operation)) return;
              payloadBase64 = savedPhoto.base64;
              payloadMime = savedPhoto.mimeType || 'image/jpeg';
            } else {
              if (hasUploadInputs) throw new Error('Please choose your pet photo to create this preview.');
              if (!cachedBase64) {
                const imagePayload = await fetchBase64Image(config.baseImageUrl);
                if (!isCurrentPersonalisationOperation(operation)) return;
                cachedBase64 = imagePayload.base64;
                cachedMime = imagePayload.mimeType || cachedMime;
              }
              payloadBase64 = cachedBase64;
              payloadMime = cachedMime;
            }

            if (!payloadBase64) {
              throw new Error('Missing image for generation.');
            }

            const payload = {
              ...portraitShapePayload(),
              base64Image: payloadBase64,
              mimeType: payloadMime,
              prompt: generationPrompt,
              referenceImageUrl: config.styleImageUrl || '',
              requestId: requestId,
              visitorId: getGenerationVisitorId(),
              productId: config.productId || '',
              fileName: config.productId ? 'product-' + config.productId : 'gemini',
              inputImageSource: uploadFile || sourceUploadUrl ? 'upload' : 'base',
              uploadedPhotoUrl: sourceUploadUrl,
              uploadFileName: uploadFile ? String(uploadFile.name || '') : '',
              includeBase64: Boolean(config.fastPreviewResponseEnabled),
              deferPersistence: Boolean(config.fastPreviewResponseEnabled)
            };

            const endpoint = getGenerationEndpoint();

            data = await ensureLegacyInitialGeneration({ endpoint, payload, operation,
              retryFailed: event?.type === 'click' || event?.retryFailed === true,
              onRequestId: (id) => {
                requestId = id;
                showProgress({ retryAction: () => handleGenerate({ retryFailed: true }) });
              } });
            requestId = operation.requestId;
          }

          if (!isCurrentPersonalisationOperation(operation)) return;
          data = checkPortraitShapeResponse(data, operation);
          if (data.portraitShapeRejected) throw new Error(data.error);
          const previewUrl = data.b64
            ? 'data:' + (data.mimeType || 'image/png') + ';base64,' + data.b64
            : '';
          const finalUrl = data.url || previewUrl;
          let resolvedFinalUrl = finalUrl;
          let resolvedPreviewUrl = previewUrl;
          let resolvedOriginalUploadUrl = data.originalUploadUrl
            ? String(data.originalUploadUrl).trim()
            : '';

          if ((!resolvedFinalUrl || !responseOk || responseError) && !debugEnabled) {
            const polled = await pollStatus(60000);
            if (!isCurrentPersonalisationOperation(operation)) return;
            if (polled.portraitShapeRejected) throw new Error(polled.error);
            resolvedFinalUrl = polled.url || polled.b64 || '';
            resolvedPreviewUrl = polled.b64 || resolvedPreviewUrl;
            resolvedOriginalUploadUrl = polled.originalUploadUrl
              ? String(polled.originalUploadUrl).trim()
              : resolvedOriginalUploadUrl;
            if (polled.pendingUrl) {
              data.pendingUrl = true;
            }
          }

          if (resolvedOriginalUploadUrl) {
            setOriginalUploadOutputValue(resolvedOriginalUploadUrl);
          }

          if (!resolvedFinalUrl) {
            throw new Error(responseError || 'No image returned from the generator. Please try again.');
          }

          if (!responseOk || responseError) {
            console.warn('[personalisation] generator returned image with error status', {
              status: responseStatus,
              error: responseError,
            });
          }

          const persistedPortraitUrl = isPersistedPortraitValue(data.url)
            ? String(data.url).trim()
            : isPersistedPortraitValue(resolvedFinalUrl)
              ? String(resolvedFinalUrl).trim()
              : '';
          const waitingForPersistedPortrait = Boolean(
            !debugEnabled &&
            (data.pendingUrl || false) &&
            resolvedPreviewUrl &&
            !persistedPortraitUrl
          );

          if (!isCurrentPersonalisationOperation(operation)) return;
          portraitDetailsSnapshot = operation.details;
          sectionRoot.classList.remove('personalisation-locked');
          sectionRoot.classList.add('personalisation-ready');
          wrapper.classList.add('personalisation-complete');

          let updatedImage = null;
          if (resolvedPreviewUrl && persistedPortraitUrl) {
            updatedImage = updateMainImage(resolvedPreviewUrl, { watermarked: true });
            storeGeneratedImage(persistedPortraitUrl);
            setPortraitOutputValue(persistedPortraitUrl);
            const preload = new Image();
            preload.onload = () => {
              if (isCurrentPersonalisationOperation(operation) && getGeneratedImageUrl() === persistedPortraitUrl) updateMainImage(persistedPortraitUrl, { watermarked: true });
            };
            preload.src = persistedPortraitUrl;
            persistSavedPortrait({
              cacheId: requestId,
              url: persistedPortraitUrl,
              previewUrl: resolvedPreviewUrl || '',
              personalisation: operation.details,
              originalUploadUrl: String(originalUploadOutputInput?.value || ''),
              createdAt: new Date().toISOString()
            });
          } else if (waitingForPersistedPortrait) {
            updatedImage = updateMainImage(resolvedPreviewUrl, { watermarked: true });
            storeGeneratedImage(resolvedPreviewUrl);
            setPortraitOutputValue('');
            setPersistedPortraitPending(true);
            finalizePersistedPortraitFromStatus(resolvedPreviewUrl);
          } else {
            updatedImage = updateMainImage(resolvedFinalUrl, { watermarked: true });
            storeGeneratedImage(resolvedFinalUrl);
            setPortraitOutputValue(data.url || resolvedFinalUrl);
            if (isPersistedPortraitValue(data.url || resolvedFinalUrl)) {
              persistSavedPortrait({
                cacheId: requestId,
                url: data.url || resolvedFinalUrl,
                previewUrl: resolvedPreviewUrl || '',
                personalisation: operation.details,
                originalUploadUrl: String(originalUploadOutputInput?.value || ''),
                createdAt: new Date().toISOString()
              });
            }
          }

          progressFocusTarget = updatedImage;
          hideProgress(true);
          setDescriptionText(buildReviewReadyMessage());
          syncAmendPanelState();
          notifyDeliveryEstimateRefresh('generated', persistedPortraitUrl || '');
          clearCartValidationError();
          setStatus(
            waitingForPersistedPortrait
              ? 'Your preview is ready. Finalising it for checkout...'
              : 'Your portrait is ready. Choose your finish and size.',
            waitingForPersistedPortrait ? '' : 'success'
          );
          button.textContent = 'Create a new preview';
          syncDigitalDownloadUpsell();
        } catch (err) {
          if (!isCurrentPersonalisationOperation(operation)) return;
          setPersistedPortraitPending(false);
          const message = err && err.message ? err.message : 'Generation failed. Please try again.';
          showProgressErrorState(message);
          setStatus(message, 'error');
        } finally {
          if (isCurrentPersonalisationOperation(operation)) {
            wrapper.classList.remove('is-loading');
            syncGenerateButtonState();
          }
        }
      };

      const fetchBase64SourceImage = async (url) => {
        const sourceUrl = String(url || '').trim();
        if (!sourceUrl) throw new Error('No portrait image is ready to amend.');
        if (/^data:/i.test(sourceUrl)) {
          const parsed = parseDataUrl(sourceUrl);
          const optimized = await optimizeClientImagePayload(sourceUrl, parsed.mimeType || 'image/png');
          return {
            base64: optimized.base64,
            mimeType: optimized.mimeType || parsed.mimeType || 'image/png'
          };
        }
        return fetchBase64Image(sourceUrl);
      };

      const fetchGenerationStatusSnapshotById = async (requestId, operation = activePersonalisationOperation) => {
        const previewQuery = config.portraitShapesEnabled ? '?previewThemeId=' + encodeURIComponent(String(operation?.previewThemeId || config.previewThemeId || '')) : '';
        const statusResponse = await fetch(`/apps/pop-prints-backend/status/${encodeURIComponent(requestId)}${previewQuery}`, {
          method: 'GET',
          headers: { 'Accept': 'application/json' },
        });
        const statusData = checkPortraitShapeResponse(await statusResponse.json().catch(() => ({})), operation);
        const statusUrl = statusData?.url || '';
        const statusB64 = statusData?.b64
          ? 'data:' + (statusData.mimeType || 'image/png') + ';base64,' + statusData.b64
          : '';
        return {
          status: statusData?.status || '',
          accepted: statusData?.accepted,
          retryable: statusData?.retryable,
          code: statusData?.code || '',
          url: statusUrl,
          b64: statusB64,
          pendingUrl: Boolean(statusData?.pendingUrl || statusData?.status === 'uploading'),
          originalUploadUrl: statusData?.originalUploadUrl || '',
          portraitShape: statusData?.portraitShape || '',
          aspectRatio: statusData?.aspectRatio,
          previewThemeId: statusData?.previewThemeId || '',
          portraitShapeRejected: Boolean(statusData?.portraitShapeRejected),
          error: statusData?.error || '',
        };
      };

      const pollGenerationStatusById = async (requestId, timeoutMs = 60000, operation = activePersonalisationOperation) => {
        const startedAt = Date.now();
        while (Date.now() - startedAt < timeoutMs && isCurrentPersonalisationOperation(operation)) {
          try {
            const snapshot = await fetchGenerationStatusSnapshotById(requestId, operation);
            if (snapshot.url || snapshot.b64 || (snapshot.status === 'error' && snapshot.error)) {
              return snapshot;
            }
          } catch (err) {
            // ignore and retry
          }
          await new Promise((resolve) => setTimeout(resolve, 3000));
        }
        return { status: 'timeout', url: '', b64: '', pendingUrl: false, error: '' };
      };

      const handleAmend = async (event) => {
        if (event) event.preventDefault();
        if (!amendFormEl || !amendPromptEl) return;

        const amendPrompt = String(amendPromptEl.value || '').trim();
        if (!amendPrompt) {
          setAmendStatus('Describe what you want changed first.', 'error');
          amendPromptEl.focus();
          return;
        }

        const sourceImageUrl = hasCurrentPortraitDetails() ? getAmendSourceImageUrl() : '';
        if (!sourceImageUrl) {
          setAmendStatus('Generate your portrait first, then request a change.', 'error');
          return;
        }

        const requestId =
          (window.crypto && typeof window.crypto.randomUUID === 'function')
            ? window.crypto.randomUUID()
            : 'amend-' + Date.now().toString(36);

        activeGenerationRequestId = requestId;
        const operation = beginPersonalisationOperation(requestId);
        wrapper.classList.add('is-loading');
        clearCartValidationError();
        setPersistedPortraitPending(false);
        setAmendBusy(true);
        setAmendStatus('Updating this portrait from your change request...', '');
        setStatus('Updating your portrait...', '');
        showProgress({
          title: 'Updating your portrait preview',
          subtext: 'Applying your requested changes.',
          iconSrc: sourceImageUrl,
          messages: amendProgressMessages,
          retryAction: handleAmend,
        });

        const finalizePersistedAmendFromStatus = (previewImageUrl) => {
          const safePreviewUrl = String(previewImageUrl || '').trim();
          void (async () => {
            const polled = await pollGenerationStatusById(requestId, 180000, operation);
            if (!isCurrentPersonalisationOperation(operation)) return;
            if (polled.portraitShapeRejected) {
              invalidatePortraitForInputChange({ force: true, message: polled.error });
              setAmendStatus(polled.error, 'error');
              return;
            }
            if (polled.url) {
              applyPersistedPortraitResult(polled.url, safePreviewUrl, requestId, operation);
              setAmendStatus('Updated. Review it above, then add to cart.', 'success');
              return;
            }
            setAmendStatus('Your updated preview is ready, but saving it is taking longer than expected. Please wait a moment before adding to cart.', 'error');
          })();
        };

        try {
          const imagePayload = await fetchBase64SourceImage(sourceImageUrl);
          if (!isCurrentPersonalisationOperation(operation)) return;
          if (!imagePayload.base64) {
            throw new Error('Unable to load the current portrait for amendment.');
          }

          const payload = {
            ...portraitShapePayload(),
            ...(/^https:\/\/cdn\.shopify\.com\//i.test(sourceImageUrl) ? {
              sourceArtworkUrl: sourceImageUrl, designId: checkoutDesignId, designToken: checkoutDesignToken,
            } : {}),
            base64Image: imagePayload.base64,
            mimeType: imagePayload.mimeType || 'image/png',
            prompt: buildAmendPrompt(amendPrompt),
            requestId,
            visitorId: getGenerationVisitorId(),
            productId: config.productId || '',
            fileName: buildAmendFilename(amendPrompt),
            inputImageSource: 'generated_portrait_amendment',
            includeBase64: Boolean(config.fastPreviewResponseEnabled),
            deferPersistence: Boolean(config.fastPreviewResponseEnabled)
          };

          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), 60000);
          const response = await fetch(getGenerationEndpoint(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'x-request-id': requestId },
            body: JSON.stringify(payload),
            signal: controller.signal
          });
          clearTimeout(timeoutId);

          const data = checkPortraitShapeResponse(await response.json().catch(() => ({})), operation);
          if (!isCurrentPersonalisationOperation(operation)) return;
          if (data.portraitShapeRejected) throw new Error(data.error);
          let responseError = data?.error || null;
          if (!response.ok && response.status === 429) {
            throw new Error(responseError || 'Preview limit reached for this visitor. Please try again later.');
          }

          const previewUrl = data.b64
            ? 'data:' + (data.mimeType || 'image/png') + ';base64,' + data.b64
            : '';
          let resolvedFinalUrl = data.url || previewUrl;
          let resolvedPreviewUrl = previewUrl;

          if ((!resolvedFinalUrl || !response.ok || responseError) && !debugEnabled) {
            const polled = await pollGenerationStatusById(requestId, 60000, operation);
            if (!isCurrentPersonalisationOperation(operation)) return;
            if (polled.portraitShapeRejected) throw new Error(polled.error);
            resolvedFinalUrl = polled.url || polled.b64 || '';
            resolvedPreviewUrl = polled.b64 || resolvedPreviewUrl;
            if (polled.pendingUrl) data.pendingUrl = true;
            if (!responseError && polled.error) responseError = polled.error;
          }

          if (!resolvedFinalUrl) {
            throw new Error(responseError || 'No updated portrait was returned. Please try again.');
          }

          const persistedPortraitUrl = isPersistedPortraitValue(data.url)
            ? String(data.url).trim()
            : isPersistedPortraitValue(resolvedFinalUrl)
              ? String(resolvedFinalUrl).trim()
              : '';
          const waitingForPersistedPortrait = Boolean(
            !debugEnabled &&
            (data.pendingUrl || false) &&
            resolvedPreviewUrl &&
            !persistedPortraitUrl
          );

          if (!isCurrentPersonalisationOperation(operation)) return;
          portraitDetailsSnapshot = operation.details;
          sectionRoot.classList.remove('personalisation-locked');
          sectionRoot.classList.add('personalisation-ready');
          wrapper.classList.add('personalisation-complete');

          let updatedImage = null;
          if (resolvedPreviewUrl && persistedPortraitUrl) {
            updatedImage = updateMainImage(resolvedPreviewUrl, { watermarked: true });
            storeGeneratedImage(persistedPortraitUrl);
            setPortraitOutputValue(persistedPortraitUrl);
            const preload = new Image();
            preload.onload = () => {
              if (isCurrentPersonalisationOperation(operation) && getGeneratedImageUrl() === persistedPortraitUrl) updateMainImage(persistedPortraitUrl, { watermarked: true });
            };
            preload.src = persistedPortraitUrl;
            persistSavedPortrait({
              cacheId: requestId,
              url: persistedPortraitUrl,
              previewUrl: resolvedPreviewUrl || '',
              personalisation: operation.details,
              originalUploadUrl: String(originalUploadOutputInput?.value || ''),
              createdAt: new Date().toISOString()
            });
          } else if (waitingForPersistedPortrait) {
            updatedImage = updateMainImage(resolvedPreviewUrl, { watermarked: true });
            storeGeneratedImage(resolvedPreviewUrl);
            setPortraitOutputValue('');
            setPersistedPortraitPending(true);
            finalizePersistedAmendFromStatus(resolvedPreviewUrl);
          } else {
            updatedImage = updateMainImage(resolvedFinalUrl, { watermarked: true });
            storeGeneratedImage(resolvedFinalUrl);
            setPortraitOutputValue(data.url || resolvedFinalUrl);
            if (isPersistedPortraitValue(data.url || resolvedFinalUrl)) {
              persistSavedPortrait({
                cacheId: requestId,
                url: data.url || resolvedFinalUrl,
                previewUrl: resolvedPreviewUrl || '',
                personalisation: operation.details,
                originalUploadUrl: String(originalUploadOutputInput?.value || ''),
                createdAt: new Date().toISOString()
              });
            }
          }

          progressFocusTarget = updatedImage;
          hideProgress(true);
          setDescriptionText(buildReviewReadyMessage());
          notifyDeliveryEstimateRefresh('amended', persistedPortraitUrl || '');
          clearCartValidationError();
          setStatus(
            waitingForPersistedPortrait
              ? 'Your updated preview is ready. Finalising it for checkout...'
              : 'Your updated portrait is ready. Choose a size and add to cart.',
            waitingForPersistedPortrait ? '' : 'success'
          );
          setAmendStatus(
            waitingForPersistedPortrait
              ? 'Updated preview ready. We are saving the final checkout image now.'
              : 'Updated. Review it above, then add to cart.',
            waitingForPersistedPortrait ? '' : 'success'
          );
          if (!waitingForPersistedPortrait) amendPromptEl.value = '';
          if (button) button.textContent = 'Create a new preview';
          syncDigitalDownloadUpsell();
        } catch (err) {
          if (!isCurrentPersonalisationOperation(operation)) return;
          setPersistedPortraitPending(false);
          const message = err && err.message ? err.message : 'Unable to update the portrait. Please try again.';
          showProgressErrorState(message);
          setAmendStatus(message, 'error');
          setStatus(message, 'error');
        } finally {
          if (isCurrentPersonalisationOperation(operation)) {
            wrapper.classList.remove('is-loading');
            setAmendBusy(false);
            syncGenerateButtonState();
            syncAmendPanelState();
          }
        }
      };

      if (button) {
        button.addEventListener('click', handleGenerate);
      }

      if (amendFormEl) {
        amendFormEl.addEventListener('submit', handleAmend);
      }

      if (amendToggleEl) {
        amendToggleEl.addEventListener('click', () => {
          const isExpanded = amendPanelEl && amendPanelEl.classList.contains('is-expanded');
          setAmendExpanded(!isExpanded, { focusPrompt: !isExpanded });
        });
      }

      if (digitalDownloadToggle) {
        digitalDownloadToggle.addEventListener('click', (event) => {
          event.preventDefault();
          if (!digitalDownloadEnabled || !hasRealCustomerPortraitLoaded() || digitalDownloadCartSubmitting) return;
          digitalDownloadSelected = !digitalDownloadSelected;
          if (!digitalDownloadSelected) {
            digitalDownloadKey = '';
          }
          syncDigitalDownloadUpsell();
        });
      }

      const productId = String(config.productId || '');
      let bypassNextProductSubmit = false;

      const handleCartValidationFailure = (event) => {
        if (!hasCurrentPortraitDetails() || (hasTextInputs && !ensureTextFieldsValid())) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation?.();
          if (sectionRoot.classList.contains('personalisation-resizing')) {
            showCartValidationError('Please wait for your selected portrait shape to finish.'); return true;
          }
          invalidatePortraitForInputChange({ force: true, message: 'Please create a preview with these details before ordering.' });
          if (hasIncompleteRequiredFields()) ensureTextFieldsValid();
          else if (hasTextInputs) focusGenerateButtonAfterUpload();
          return true;
        }
        if (hasPersistedPortraitUrl()) {
          clearCartValidationError();
          return false;
        }

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        const message = !hasUploadedImage()
          ? getMissingUploadMessage()
          : hasDisplayPortraitReady()
            ? 'Your portrait is still being finalised. Please wait a moment before adding to cart.'
            : 'Please preview your portrait before adding it to cart.';

        showCartValidationError(message);
        return true;
      };

      const isRelevantProductFormNode = (node) => {
        if (!(node instanceof Element)) return false;
        const productForm = node.closest('product-form-component');
        if (productForm && String(productForm.dataset.productId || '') === productId) return true;
        const stickyBar = node.closest('sticky-add-to-cart');
        if (stickyBar && String(stickyBar.dataset.productId || '') === productId) return true;
        return false;
      };

      const isRelevantProductForm = (form) => {
        if (!(form instanceof HTMLFormElement)) return false;
        if (config.productFormId && form.id === String(config.productFormId)) return true;
        return isRelevantProductFormNode(form);
      };

      const parsePositiveInteger = (value, fallback) => {
        const parsed = Number.parseInt(String(value || ''), 10);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
      };

      const buildCartSectionsPayload = () => {
        const sectionIds = new Set();
        document.querySelectorAll('cart-items-component').forEach((item) => {
          if (item instanceof HTMLElement && item.dataset.sectionId) {
            sectionIds.add(item.dataset.sectionId);
          }
        });
        return {
          sections: Array.from(sectionIds).join(','),
          sections_url: window.location.pathname,
        };
      };

      const buildMainCartItemFromForm = (form) => {
        if (!hasCurrentPortraitDetails()) throw new Error('Please create a preview with these details before ordering.');
        const formData = new FormData(form);
        const item = {};
        const properties = {};

        formData.forEach((rawValue, key) => {
          if (key === 'sections' || key === 'sections_url') return;

          const value = rawValue instanceof File ? rawValue.name : String(rawValue == null ? '' : rawValue);
          const propertyMatch = key.match(/^properties\[(.+)\]$/);
          if (propertyMatch) {
            if (value !== '') {
              properties[propertyMatch[1]] = value;
            }
            return;
          }

          if (key === 'quantity') {
            item.quantity = parsePositiveInteger(value, 1);
            return;
          }

          if (value !== '') {
            item[key] = value;
          }
        });

        if (!item.id) {
          throw new Error('Missing product variant.');
        }

        if (!item.quantity) {
          item.quantity = 1;
        }

        if (Object.keys(properties).length) {
          item.properties = properties;
        }

        return item;
      };

      const buildDigitalDownloadAddonItem = (mainItem) => {
        const sharedKey = ensureDigitalDownloadKey();
        const portraitUrl = String(outputInput?.value || getGeneratedImageUrl() || '').trim();

        return {
          id: digitalDownloadVariantId,
          quantity: 1,
          properties: {
            '_Digital Download Add-On': 'true',
            '_Digital Download Key': sharedKey,
            '_Digital Download Parent Variant': String(mainItem?.id || ''),
            '_Digital Download Portrait URL': portraitUrl,
          },
        };
      };

      const setCartSubmittingState = (form, isSubmitting) => {
        digitalDownloadCartSubmitting = Boolean(isSubmitting);

        if (form instanceof HTMLFormElement) {
          form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach((control) => {
            if (!(control instanceof HTMLElement)) return;
            if (isSubmitting) {
              if (!(control instanceof HTMLButtonElement || control instanceof HTMLInputElement)) return;
              if (!control.disabled) {
                control.dataset.digitalDownloadTempDisabled = 'true';
                control.disabled = true;
              }
              return;
            }

            if (
              (control instanceof HTMLButtonElement || control instanceof HTMLInputElement) &&
              control.dataset.digitalDownloadTempDisabled === 'true'
            ) {
              delete control.dataset.digitalDownloadTempDisabled;
              control.disabled = false;
            }
          });
        }

        if (digitalDownloadToggle instanceof HTMLButtonElement) {
          digitalDownloadToggle.disabled = Boolean(isSubmitting);
        }
        if (editDetailsButton) editDetailsButton.disabled = Boolean(isSubmitting);
      };

      const fetchCartSnapshot = async () => {
        const response = await fetch('/cart.js', {
          method: 'GET',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) {
          throw new Error('Failed to refresh cart.');
        }
        return response.json();
      };

      const dispatchDigitalDownloadCartUpdate = (cart, sections, sourceId, variantId, addedItemCount) => {
        const hasCartSnapshot = cart && typeof cart === 'object';
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: hasCartSnapshot ? cart : {},
              sourceId: sourceId || 'personalisation-digital-download',
              data: {
                source: hasCartSnapshot ? 'personalisation-digital-download' : 'product-form-component',
                itemCount: hasCartSnapshot ? Number(cart.item_count || 0) : addedItemCount,
                productId,
                variantId: String(variantId || ''),
                sections: sections || {},
              },
            },
          })
        );
      };

      function setOriginalUploadOutputValue(value) {
        if (!originalUploadOutputInput) return;
        originalUploadOutputInput.value = (value || '').toString();
        originalUploadOutputInput.dispatchEvent(
          new Event('input', {
            bubbles: true,
          })
        );
        originalUploadOutputInput.dispatchEvent(
          new Event('change', {
            bubbles: true,
          })
        );
      }

      const addSelectedDigitalDownloadToCart = async (form) => {
        if (!(form instanceof HTMLFormElement) || !digitalDownloadEnabled || !digitalDownloadSelected) return false;
        if (digitalDownloadCartSubmitting) return true;
        syncDigitalDownloadUpsell();
        try {
          const coordinator = window.PopPrintsPersonalizedCheckout;
          if (!coordinator?.submitOriginal) throw new Error('Your cart is still loading. Please try Add to Cart again.');
          await coordinator.submitOriginal({
            form, sourceProductId: productId,
            selection: () => ({ ...portraitShapePayload(), sourceVariantId: new FormData(form).get('id'),
              quantity: Number(new FormData(form).get('quantity') || 1), addon: true,
              artworkUrl: String(outputInput?.value || getGeneratedImageUrl() || '').trim(), countryCode: personalizedCheckoutCountry() }),
            items: () => {
              const main = buildMainCartItemFromForm(form);
              return [main, buildDigitalDownloadAddonItem(main)];
            },
            setBusy: (value) => setCartSubmittingState(form, value),
            added: () => {
              digitalDownloadSelected = false;
              digitalDownloadKey = '';
              syncDigitalDownloadUpsell({ resetSelection: true });
              clearCartValidationError();
              setStatus('Added to cart. If you purchase, your digital file will be emailed after checkout.', 'success');
            },
          });
        } catch (err) {
          setStatus(err?.message || 'Unable to add this item to cart.', 'error');
        }
        return true;
      };

      const syncPortraitCheckoutVariant = (form) => {
        const sync = sectionRoot.popSyncProductFormVariantId;
        if (typeof sync !== 'function') return getPortraitShape() === 'portrait';
        const variantId = String(sync() || '');
        return Boolean(variantId && variantId === String(new FormData(form).get('id') || ''));
      };

      const personalizedCheckoutOptions = (form) => ({
          form,
          sourceProductId: productId,
          isEnabled: personalizedCheckoutEnabled,
          canWarm: () => wrapper.isConnected && syncPortraitCheckoutVariant(form) && hasCurrentPortraitDetails() && hasRealCustomerPortraitLoaded() &&
            /^https:\/\//i.test(String(outputInput?.value || '').trim()) && !awaitingPersistedPortrait,
          ensurePortrait: () => tryResolvePortraitForCheckout(),
          mainItem: () => {
            if (!syncPortraitCheckoutVariant(form) && getPortraitShape() !== 'portrait') throw new Error('Please choose an available size and finish.');
            syncDigitalDownloadUpsell();
            return buildMainCartItemFromForm(form);
          },
          selection: () => {
            const variantReady = syncPortraitCheckoutVariant(form);
            return ({
            ...portraitShapePayload(),
            sourceVariantId: variantReady || getPortraitShape() === 'portrait' ? new FormData(form).get('id') : '',
            quantity: Number(new FormData(form).get('quantity') || 1),
            artworkUrl: String(outputInput?.value || getGeneratedImageUrl() || '').trim(),
            ...(checkoutArtworkSource ? { artworkSource: checkoutArtworkSource } : {}),
            addon: digitalDownloadEnabled && digitalDownloadSelected,
            countryCode: personalizedCheckoutCountry(),
            presentationVersion: sectionRoot.classList.contains('pop-reassurance-preview') ? 'physical-v1' : undefined,
          }); },
          design: () => ({ designId: checkoutDesignId, designToken: checkoutDesignToken }),
          saveDesign: (ready) => {
            if (!hasCurrentPortraitDetails()) return;
            if (ready.artworkUrl && ready.artworkUrl !== String(outputInput?.value || getGeneratedImageUrl() || '').trim()) return;
            checkoutDesignId = String(ready.designId || '');
            checkoutDesignToken = String(ready.designToken || '');
            const url = String(outputInput?.value || getGeneratedImageUrl() || '').trim();
            persistSavedPortrait({ cacheId: activeGenerationRequestId, url,
              designId: checkoutDesignId, designToken: checkoutDesignToken,
              personalisation: portraitDetailsSnapshot, originalUploadUrl: String(originalUploadOutputInput?.value || '') });
          },
          addon: (main) => buildDigitalDownloadAddonItem(main),
          setBusy: (value) => {
            setCartSubmittingState(form, value);
            sectionRoot.classList.toggle('personalized-checkout-busy', value);
            form.setAttribute('aria-busy', String(value));
          },
          added: () => {
            digitalDownloadSelected = false;
            digitalDownloadKey = '';
            syncDigitalDownloadUpsell({ resetSelection: true });
            clearCartValidationError();
          },
        });

      const schedulePersonalizedCheckout = () => {
        const coordinator = window.PopPrintsPersonalizedCheckout;
        if (!coordinator) return;
        const form = [...sectionRoot.querySelectorAll('form')].find(isRelevantProductForm);
        if (form) coordinator.scheduleWarm(personalizedCheckoutOptions(form));
        else coordinator.cancelWarm();
      };

      const addPersonalizedCheckoutToCart = async (form) => {
        if (!syncPortraitCheckoutVariant(form) && getPortraitShape() !== 'portrait') {
          showCartValidationError('Please choose an available size and finish.');
          return;
        }
        if (!window.PopPrintsPersonalizedCheckout) {
          showCartValidationError('Portrait checkout could not load. Please refresh the page and try again.');
          return;
        }
        await window.PopPrintsPersonalizedCheckout.submit(personalizedCheckoutOptions(form));
      };

      document.addEventListener('click', (event) => {
        if (getPortraitShape() === 'portrait' && !personalizedCheckoutConfigured()) return;
        const target = event.target instanceof Element ? event.target : null;
        const accelerated = target?.closest('shopify-accelerated-checkout, .shopify-payment-button, [data-shopify-buttoncontainer]');
        if (!accelerated || !sectionRoot.contains(accelerated)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        showCartValidationError('Please use Order My Portrait to prepare your portrait for checkout.');
      }, true);

      document.addEventListener(
        'click',
        (event) => {
          const target = event.target;
          if (!(target instanceof Element)) return;
          const submitButton = target.closest('button[type="submit"], input[type="submit"]');
          if (!submitButton) return;
          if (!isRelevantProductFormNode(submitButton)) return;
          if (hasDisplayPortraitReady()) {
            discountFlyoutAddToCartIntent = true;
            closeDiscountFlyout({ persistDismissal: false });
          }
          if (!hasPersistedPortraitUrl() && hasDisplayPortraitReady()) return;
          handleCartValidationFailure(event);
        },
        true
      );

      document.addEventListener(
        'submit',
        async (event) => {
          const target = event.target;
          if (!(target instanceof Element)) return;
          if (!(target instanceof HTMLFormElement)) return;
          if (!isRelevantProductForm(target)) return;
          if (!wrapper.isConnected) return;
          if ((personalizedCheckoutConfigured() || getPortraitShape() !== 'portrait') && (!personalizedCheckoutEnabled() || !window.PopPrintsPersonalizedCheckout)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            bypassNextProductSubmit = false;
            showCartValidationError(!['US', 'CA', 'GB'].includes(personalizedCheckoutCountry())
              ? 'Personalised checkout is not available for this delivery country. Please contact us for help.'
              : 'Portrait checkout could not load. Please refresh the page and try again.');
            return;
          }
          if (!hasCurrentPortraitDetails() || (hasTextInputs && hasIncompleteRequiredFields())) {
            handleCartValidationFailure(event);
            return;
          }
          if (personalizedCheckoutEnabled()) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            discountFlyoutAddToCartIntent = true;
            closeDiscountFlyout({ persistDismissal: false });
            void addPersonalizedCheckoutToCart(target);
            return;
          }
          if (bypassNextProductSubmit) {
            bypassNextProductSubmit = false;
            return;
          }
          if (hasDisplayPortraitReady()) {
            discountFlyoutAddToCartIntent = true;
            closeDiscountFlyout({ persistDismissal: false });
          }

          if (!hasPersistedPortraitUrl() && hasDisplayPortraitReady()) {
            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') {
              event.stopImmediatePropagation();
            }

            const resolved = await tryResolvePortraitForCheckout();
            if (!resolved) {
              window.PopPrintsPersonalizedCheckout?.finishProgress?.(target);
              showCartValidationError('Your preview is still being finalised. Please wait a moment and try again.');
              return;
            }

            if (digitalDownloadEnabled && digitalDownloadSelected) {
              void addSelectedDigitalDownloadToCart(target);
              return;
            }

            bypassNextProductSubmit = true;
            if (typeof target.requestSubmit === 'function') {
              target.requestSubmit();
            } else {
              HTMLFormElement.prototype.submit.call(target);
            }
            return;
          }

          if (handleCartValidationFailure(event)) {
            window.PopPrintsPersonalizedCheckout?.finishProgress?.(target);
            return;
          }
          if (!digitalDownloadEnabled || !digitalDownloadSelected) return;

          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }

          void addSelectedDigitalDownloadToCart(target);
        },
        true
      );

      if (discountFlyoutCloseEls.length) {
        discountFlyoutCloseEls.forEach((element) => {
          element.addEventListener('click', () => closeDiscountFlyout());
        });
      }

      if (discountFlyoutCopyEl) {
        discountFlyoutCopyEl.addEventListener('click', async () => {
          try {
            if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
              await navigator.clipboard.writeText(DISCOUNT_FLYOUT_CODE);
            }
            discountFlyoutCopyEl.textContent = 'Copied';
          } catch (err) {
            discountFlyoutCopyEl.textContent = 'Code ready';
          }
        });
      }

      if (discountFlyoutFormEl && discountFlyoutEmailEl && discountFlyoutSubmitEl) {
        discountFlyoutFormEl.addEventListener('submit', async (event) => {
          event.preventDefault();
          const value = String(discountFlyoutEmailEl.value || '').trim();
          const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

          if (!isValid) {
            discountFlyoutEmailEl.setAttribute('aria-invalid', 'true');
            discountFlyoutEmailEl.focus();
            if (discountFlyoutHintEl) {
              discountFlyoutHintEl.hidden = false;
              discountFlyoutHintEl.textContent = 'Please enter a valid email address.';
            }
            return;
          }

          const previewUrl = getCurrentPreviewEmailUrl();
          if (!previewUrl) {
            if (discountFlyoutHintEl) {
              discountFlyoutHintEl.hidden = false;
              discountFlyoutHintEl.textContent = 'Your preview is still saving. Please wait a moment and try again.';
            }
            return;
          }

          const originalLabel = discountFlyoutSubmitEl.textContent;
          discountFlyoutSubmitEl.disabled = true;
          discountFlyoutSubmitEl.textContent = 'Sending...';
          discountFlyoutEmailEl.setAttribute('aria-invalid', 'false');

          try {
            const result = await submitPreviewReadyEmailCapture(value, {
              captureType: 'discount_offer',
              previewUrl,
              discountCode: DISCOUNT_FLYOUT_CODE,
            });
            if (!result || result.sent !== true) {
              throw new Error(result?.error || 'send_failed');
            }
            discountFlyoutSubmitted = true;
            writeStorageTimestamp(DISCOUNT_FLYOUT_CLAIM_KEY);
            if (discountFlyoutCodeEl && result.discountCode) {
              discountFlyoutCodeEl.textContent = result.discountCode;
            }
            discountFlyoutFormEl.hidden = true;
            if (discountFlyoutSuccessEl) {
              discountFlyoutSuccessEl.hidden = false;
            }
            if (discountFlyoutHintEl) {
              discountFlyoutHintEl.hidden = true;
              discountFlyoutHintEl.textContent = '';
            }
          } catch (err) {
            if (discountFlyoutHintEl) {
              discountFlyoutHintEl.hidden = false;
              discountFlyoutHintEl.textContent = 'We could not send your code just now. Please try again.';
            }
          } finally {
            discountFlyoutSubmitEl.disabled = false;
            discountFlyoutSubmitEl.textContent = originalLabel;
          }
        });
      }

      wrapper.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target.closest('[data-pop-portrait-style-id]') : null;
        if (!target || !wrapper.contains(target) || !selectedPortraitStyle) return;
        event.preventDefault();
        if (wrapper.classList.contains('is-loading') || wrapper.classList.contains('is-amending') || digitalDownloadCartSubmitting) return;
        const choice = portraitStyleChoices.find((item) => item.id === target.dataset.popPortraitStyleId);
        if (!choice || choice.key === selectedPortraitStyle.key) return;
        configurePortraitStyle(choice);
        invalidatePortraitForInputChange({ force: true, message: 'Style selected. Create your portrait when you are ready.' });
        lastTextDetailsSignature = currentDetailsSignature();
        captureStockPortraitUrls();
        updateMainImage(choice.imageUrl);
        syncPortraitStyleChoices();
      });
      if (selectedPortraitStyle) {
        new MutationObserver(syncPortraitStyleChoices).observe(wrapper, { attributes: true, attributeFilter: ['class'] });
      }

      wrapper.addEventListener('pop:portrait-shape-change', (event) => {
        if (event.target !== wrapper || event.detail?.restore) return;
        invalidatePortraitForInputChange({ message: 'Loading your selected portrait shape...', preserveShapeSource: true });
        lastTextDetailsSignature = currentDetailsSignature();
        const originalPhoto = String(originalUploadOutputInput?.value || '').trim();
        if (originalPhoto || selectedShapeArtwork) uploadInputs.forEach((input) => { if (!input.files?.length) input.required = false; });
        if (hasUploadedImage() && !hasIncompleteRequiredFields()) {
          window.requestAnimationFrame(() => handleGenerate());
        }
      });

      wrapper.addEventListener('click', (event) => {
        const target = event.target instanceof Element
          ? event.target.closest('[data-personalisation-question-link]')
          : null;
        if (!target || !wrapper.contains(target)) return;
        event.preventDefault();
        void openPortraitQuestion(target);
      });

      wrapper.addEventListener('personalisation:art-ready', (event) => {
        const detail = event && event.detail ? event.detail : {};
        scheduleDiscountFlyout(detail.source || 'generated');
        schedulePersonalizedCheckout();
      });

      // Coalesce artwork and finish/size changes while the customer reviews the saved portrait.
      sectionRoot.addEventListener('change', schedulePersonalizedCheckout);
      window.addEventListener('pageshow', () => requestAnimationFrame(schedulePersonalizedCheckout));
      window.addEventListener('popstate', schedulePersonalizedCheckout);

      ['click', 'touchstart', 'keydown', 'scroll'].forEach((eventName) => {
        document.addEventListener(eventName, noteDiscountFlyoutActivity, { passive: true });
      });

      syncGenerateButtonState();
      captureStockPortraitUrls();
      if (selectedPortraitStyle) updateMainImage(selectedPortraitStyle.imageUrl);
      applyForcedPersonalisationState();
      applyRequestedSavedPortraitFromUrl();
      applyForcedProgressOverlay();
      if (forcedDiscountFlyoutState) {
        window.setTimeout(() => {
          openDiscountFlyout();
        }, 80);
      }
      syncDigitalDownloadUpsell({ resetSelection: true });
      syncAmendPanelState();
      if (sectionRoot.classList.contains('personalisation-ready')) {
        scheduleDiscountFlyout('saved-image');
      }

      sectionRoot.addEventListener('variant:update', preservePersonalisedMediaInVariantHtml, true);

      sectionRoot.addEventListener('variant:update', () => {
        captureStockPortraitUrls();
        syncPortraitStyleChoices();
        scheduleReapply();
        syncDigitalDownloadUpsell();
        requestAnimationFrame(schedulePersonalizedCheckout);
      });

      schedulePersonalizedCheckout();

      let autoSelectAttempts = 0;
      const attemptAutoSelect = () => {
        autoSelectAttempts += 1;
        defaultToPrintSmall();
        if (autoSelectedDefaultVariant) return;
        if (autoSelectAttempts < 15) {
          requestAnimationFrame(attemptAutoSelect);
        }
      };

      const startAutoSelect = () => requestAnimationFrame(attemptAutoSelect);

      if (customElements.get('variant-picker')) {
        startAutoSelect();
      } else {
        customElements.whenDefined('variant-picker').then(startAutoSelect);
      }
    })();
